// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/animate.css/animate.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAMFBMVEVMaXH////////////////////////////////////////////////////////////6w4mEAAAAD3RSTlMAlAX+BKLcA5+b6hJ7foD4ZP1OAAAAkUlEQVR4XkWPoQ3CUBQAL4SktoKAbCUjgAKLJZ2ABYosngTJCHSD6joUI6BZgqSoB/+Shqde7sS9x3OGk81fdO+texMtRVTia+TsQtHEUJLdohJfgNNPJHyEJPZTsWLoxShqsWITazEwqePAn69Sw2TUxk1+euPis3EwaXy8RMHSZBIlRcKKnC5hRctjMf57/wJbBlAIs9k1BAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/YekanBakh-Regular/@font-face/7296ae79f6faca68798b00fbbbee4c22.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans:400,500,600,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes modal-video {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modal-video-inner {
  from {
    transform: translate(0, 100px);
  }
  to {
    transform: translate(0, 0);
  }
}
.modal-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000000;
  cursor: pointer;
  opacity: 1;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
  animation-name: modal-video;
  transition: opacity 0.3s ease-out;
}

.modal-video-effect-exit {
  opacity: 0;
}
.modal-video-effect-exit .modal-video-movie-wrap {
  transform: translate(0, 100px);
}

.modal-video-body {
  max-width: 960px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.modal-video-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
@media (orientation: landscape) {
  .modal-video-inner {
    padding: 10px 60px;
    box-sizing: border-box;
  }
}

.modal-video-movie-wrap {
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  background-color: #333;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
  animation-name: modal-video-inner;
  transform: translate(0, 0);
  transition: transform 0.3s ease-out;
}
.modal-video-movie-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-video-close-btn {
  position: absolute;
  z-index: 2;
  top: -45px;
  right: 0px;
  display: inline-block;
  width: 35px;
  height: 35px;
  overflow: hidden;
  border: none;
  background: transparent;
}
@media (orientation: landscape) {
  .modal-video-close-btn {
    top: 0;
    right: -45px;
  }
}
.modal-video-close-btn:before {
  transform: rotate(45deg);
}
.modal-video-close-btn:after {
  transform: rotate(-45deg);
}
.modal-video-close-btn:before, .modal-video-close-btn:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #fff;
  border-radius: 5px;
  margin-top: -6px;
}

/*
Theme Name: AgileTech
Theme URI: http://wowtheme7.com/html/agiletech
Author: wowtheme7
Author URI: http://wowtheme7.com
Description: AglieTech - IT Solutions & Technology Html5 Template
Version: 1.0.0
*/
/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
# Global
    ## Global
    ## Mixins
    ## Theme
    ## Variables
    ## Common

# Sections
    ## Nav Bar
    ## Banner
    ## Brand Area
    ## Footer
    ## Widgets

# Elements
    ## accordion
    ## filter
    ## apartment
    ## blog
    ## city
    ## feature
    ## gallery
    ## intro
    ## main-search
    ## pricing
    ## service
    ## team
    ## user-list

--------------------------------------------------------------*/
/*-----------------
    # Typography
-----------------*/
:root {
  --main-color: #246BFD;
  --main-color2: #EE0020;
  --heading-color: #101A29;
  --paragraph-color: #737588;
  --body-font: "Plus Jakarta Sans", sans-serif;
  --heading-font: "Plus Jakarta Sans", sans-serif;
  --body-font-size: 16px;
  --line-height30: 1.7;
}

html {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  overflow-x: hidden;
  font-family: var(--body-font);
}

* {
  box-sizing: border-box;
  outline: none;
  -moz-osx-font-smoothing: grayscale;
  /* Firefox */
  -webkit-font-smoothing: antialiased;
  /* WebKit  */
}

body {
  margin: 0;
  color: var(--paragraph-color);
  overflow-x: hidden;
  font-family: var(--body-font);
  line-height: var(--line-height30);
  font-size: var(--body-font-size);
  background: #fff;
  font-weight: 500;
}

h1 {
  font-size: 75px;
  line-height: 1.2333333333;
}

h2 {
  font-size: 40px;
  line-height: 1.2380952381;
}

h3 {
  font-size: 30px;
  line-height: 1.3833333333;
}

h4 {
  font-size: 24px;
  line-height: 1.3380952381;
}

h5 {
  font-size: 20px;
  line-height: 1.3380952381;
}

h6 {
  font-size: 16px;
  line-height: 1.2380952381;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--heading-color);
  font-weight: 600;
  font-family: var(--heading-font);
}

p {
  color: var(--paragraph-color);
  -webkit-hyphens: auto;
  hyphens: auto;
  margin-bottom: 10px;
}

a {
  color: inherit;
  text-decoration: none;
  transition: 0.4s;
}

a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
  color: inherit;
}

a:hover {
  color: var(--main-color);
}

pre {
  word-break: break-word;
}

a i {
  padding: 0 2px;
}

img {
  max-width: 100%;
}

button:hover,
button:active,
button:focus {
  outline: 0;
}

/*input and button type focus outline disable*/
input[type=text]:focus,
input[type=email]:focus,
input[type=url]:focus,
input[type=password]:focus,
input[type=search]:focus,
input[type=tel]:focus,
input[type=number]:focus,
textarea:focus,
input[type=button]:focus,
input[type=reset]:focus,
input[type=submit]:focus,
select:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid #ddd;
}

.no-gutter.row,
.no-gutter.container,
.no-gutter.container-fluid {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}

.no-gutter > [class^=col-] {
  padding-left: 0;
  padding-right: 0;
}

.no-gutter[class^=col-] {
  padding-left: 0;
  padding-right: 0;
}

.h-100vh {
  height: 100vh;
}

code {
  color: #faa603;
}

.check-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.check-list li {
  display: block;
  padding-left: 20px;
  position: relative;
  z-index: 0;
}
.check-list li:after {
  position: absolute;
  left: 0;
  top: 0;
  font-family: "fontawesome";
  content: "\\f105";
  color: var(--main-color);
}

.site-main .comment-navigation,
.site-main .posts-navigation,
.site-main .post-navigation {
  clear: both;
}

.comment-navigation .nav-previous,
.posts-navigation .nav-previous,
.post-navigation .nav-previous {
  float: left;
  width: 50%;
}

.comment-navigation .nav-next,
.posts-navigation .nav-next,
.post-navigation .nav-next {
  float: right;
  text-align: right;
  width: 50%;
}

.comment-navigation .nav-previous > a,
.posts-navigation .nav-previous > a,
.post-navigation .nav-previous > a,
.comment-navigation .nav-next > a,
.posts-navigation .nav-next > a,
.post-navigation .nav-next > a {
  transition: 0.3s ease-in;
}

.comment-navigation .nav-previous:hover > a,
.posts-navigation .nav-previous:hover > a,
.post-navigation .nav-previous:hover > a,
.comment-navigation .nav-next:hover > a,
.posts-navigation .nav-next:hover > a,
.post-navigation .nav-next:hover > a {
  color: var(--main-color);
}

.comment-list li {
  list-style: none;
}

.h-100vh {
  height: 100vh;
}

.position-relative {
  position: relative;
}

/*--------------------------------------------------------------
# Accessibility
--------------------------------------------------------------*/
/* Text meant only for screen readers. */
.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
  /* Many screen reader and browser combinations announce broken words as they would appear visually. */
}

.screen-reader-text:focus {
  background-color: #f1f1f1;
  border-radius: 3px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.6);
  clip: auto !important;
  clip-path: none;
  color: #21759b;
  display: block;
  font-size: 15px;
  font-size: 0.875rem;
  font-weight: bold;
  height: auto;
  left: 5px;
  line-height: normal;
  padding: 15px 23px 14px;
  text-decoration: none;
  top: 5px;
  width: auto;
  z-index: 100000;
  /* Above WP toolbar. */
}

/* Do not show the outline on the skip link target. */
#content[tabindex="-1"]:focus {
  outline: 0;
}

/*--------------------------------------------------------------
# Alignments
--------------------------------------------------------------*/
.alignleft {
  float: left;
  clear: both;
  margin-right: 20px;
}

.alignright {
  float: right;
  clear: both;
  margin-left: 20px;
}

.aligncenter {
  clear: both;
  display: block;
  margin: 0 auto 1.75em;
}

.alignfull {
  margin: 1.5em 0;
  max-width: 100%;
}

.alignwide {
  max-width: 1100px;
}

/*--------------------------------------------------------------
# Clearings
--------------------------------------------------------------*/
.clear:before,
.clear:after,
.entry-content:before,
.entry-content:after,
.comment-content:before,
.comment-content:after,
.site-header:before,
.site-header:after,
.site-content:before,
.site-content:after,
.site-footer:before,
.site-footer:after {
  content: "";
  display: table;
  table-layout: fixed;
}

.clear:after,
.entry-content:after,
.comment-content:after,
.site-header:after,
.site-content:after,
.site-footer:after {
  clear: both;
}

/*--------------------------------------------------------------
## Posts and pages
--------------------------------------------------------------*/
.sticky {
  display: block;
}

.updated:not(.published) {
  display: none;
}

/*--------------------------------------------------------------
# Media
--------------------------------------------------------------*/
.page-content .wp-smiley,
.entry-content .wp-smiley,
.comment-content .wp-smiley {
  border: none;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
}

/* Make sure embeds and iframes fit their containers. */
embed,
iframe,
object {
  max-width: 100%;
}

/* Make sure logo link wraps around logo image. */
.custom-logo-link {
  display: inline-block;
}

/*--------------------------------------------------------------
## Captions
--------------------------------------------------------------*/
.wp-caption {
  margin-bottom: 1.5em;
  max-width: 100%;
  clear: both;
}

.wp-caption img[class*=wp-image-] {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.wp-caption .wp-caption-text {
  margin: 0.8075em 0;
}

.wp-caption-text {
  text-align: center;
}

/*----------------------------------------
    # Unit test
------------------------------------------*/
.wp-link-pages a {
  margin: 0 5px;
  transition: 0.3s ease-in;
}

.wp-link-pages {
  margin-bottom: 30px;
  margin-top: 25px;
}

.wp-link-pages span,
.wp-link-pages a {
  border: 1px solid #e2e2e2;
  padding: 5px 15px;
  display: inline-block;
}

.wp-link-pages .current,
.wp-link-pages a:hover {
  background-color: var(--main-color);
  color: #fff;
  border-color: var(--main-color);
}

.wp-link-pages span:first-child {
  margin-right: 5px;
}

dl,
ol,
ul {
  padding-left: 17px;
}

.post-password-form input {
  display: block;
  border: 1px solid #e2e2e2;
  height: 50px;
  border-radius: 3px;
  padding: 0 20px;
}

.post-password-form label {
  font-weight: 600;
  color: #333;
}

.post-password-form input[type=submit] {
  width: 100px;
  height: 50px;
  background-color: var(--main-color);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease-in;
}

.post-password-form input[type=submit]:hover {
  background-color: #121A2F;
}

.footer-widget .table td,
.footer-widget .table th {
  padding: 0.5rem !important;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.custom-gutters-10 > .col,
.custom-gutters-10 > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

@media all and (min-width: 1200px) {
  .no-lg-gutters > .col,
  .no-lg-gutters > [class*=col-] {
    padding-right: 0;
    padding-left: 0;
  }
}
/*---------------------------------------
    ## Button
---------------------------------------*/
.btn {
  height: 55px;
  line-height: 55px;
  padding: 0 30px;
  border-radius: 0;
  overflow: hidden;
  position: relative;
  border: 0;
  transition: all 0.5s ease;
  font-weight: 600;
  border-radius: 30px;
  z-index: 0;
}
.btn:focus, .btn:active {
  outline: 0;
  box-shadow: none;
}
.btn:after {
  content: "";
  background: var(--heading-color);
  position: absolute;
  transition: all 0.3s ease-in;
  z-index: -1;
  height: 100%;
  left: -35%;
  top: 0;
  transform: skew(30deg);
  transition-duration: 0.6s;
  transform-origin: top left;
  width: 0;
}
.btn:hover:after {
  height: 100%;
  width: 135%;
}
.btn i {
  font-size: 14px;
  float: right;
  padding-top: 16px;
  padding-left: 5px;
}
.btn svg {
  font-size: 12px;
  margin-top: 20px;
  margin-left: 6px;
  float: right;
}
.btn.border-radius-0 {
  border-radius: 0;
}
.btn.border-radius-5 {
  border-radius: 5px;
}

.btn-small {
  height: 50px;
  line-height: 50px;
}
.btn-small i {
  padding-top: 12px;
}

.btn-base {
  color: #fff;
  background: var(--main-color);
}
.btn-base:hover {
  color: #fff;
}

.btn-red {
  color: #fff;
  background: #f14d5d;
}
.btn-red:hover {
  color: #fff;
}

.btn-white {
  color: var(--main-color) !important;
  background: #fff;
}
.btn-white:hover, .btn-white:focus {
  color: #fff !important;
  background: var(--main-color);
}

.btn-black {
  color: #fff !important;
  background: var(--heading-color);
}
.btn-black:hover, .btn-black:focus {
  color: #fff !important;
  background: var(--main-color);
}

.btn-black.sky {
  color: #fff !important;
  background: var(--heading-color);
}
.btn-black.sky:hover, .btn-black.sky:focus {
  color: #fff !important;
  background: #50af9b;
}

.btn-border-base {
  color: var(--heading-color);
  border: 2px solid var(--main-color);
  line-height: 52px;
}
.btn-border-base:after {
  background: var(--main-color);
}
.btn-border-base:hover, .btn-border-base:focus {
  color: #fff;
}

.btn-border-base-2 {
  color: #50af9b;
  border: 2px solid #50AF9B;
  line-height: 52px;
}
.btn-border-base-2:after {
  background: #50af9b;
}
.btn-border-base-2:hover, .btn-border-base-2:focus {
  color: #fff;
}

.btn-border-white {
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.7);
  line-height: 53px;
}
.btn-border-white:hover, .btn-border-white:focus {
  color: #fff;
  background: var(--main-color);
  border: 2px solid var(--main-color);
}

.btn-border-black {
  color: #a2a2a2;
  border: 2px solid #d4d4d4;
  line-height: 53px;
}
.btn-border-black:hover, .btn-border-black:focus {
  color: #fff;
  background: var(--main-color);
  border: 2px solid var(--main-color);
}
.btn-border-black:after {
  background: var(--main-color);
}

.btn-border-black-2 {
  color: #262626;
  border: 2px solid #262626;
  line-height: 53px;
}
.btn-border-black-2:hover, .btn-border-black-2:focus {
  color: #fff;
  background: var(--main-color);
  border: 2px solid var(--main-color);
}
.btn-border-black-2:after {
  background: var(--main-color);
}

.btn-border-gray {
  color: var(--heading-color);
  border: 2px solid #e3e3e3;
  line-height: 51px;
  background: #f8f9fc;
}
.btn-border-gray:hover, .btn-border-gray:focus {
  color: #fff;
  background: var(--main-color);
  border: 2px solid var(--heading-color);
}

.btn-base-color {
  color: #fff !important;
  background: #50af9b;
}

.read-more-text {
  position: relative;
  color: var(--heading-color);
  font-weight: 600;
}
.read-more-text i {
  font-size: 18px;
  position: absolute;
  top: 1px;
  margin-left: 3px;
  transition: 0.4s;
}
.read-more-text svg {
  font-size: 12px;
  position: absolute;
  top: 5px;
  margin-left: 6px;
  transition: 0.4s;
}
.read-more-text:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  background: var(--main-color);
  height: 1px;
  width: 0;
  transition: 0.4s;
  visibility: hidden;
  opacity: 0;
}
.read-more-text:hover i {
  padding-left: 6px;
}
.read-more-text:hover:after {
  width: 100%;
  visibility: visible;
  opacity: 1;
}

.read-more-arrow {
  height: 35px;
  width: 35px;
  line-height: 35px;
  color: #fff;
  text-align: center;
  background: var(--main-color);
  border-radius: 50%;
  display: inline-block;
}
.read-more-arrow:hover {
  background: #0a1851;
  color: #fff;
}

/*------------------------------------------------
    ## Back Top
------------------------------------------------*/
.back-to-top {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 44px;
  height: 44px;
  color: #fff;
  background-color: var(--main-color);
  text-align: center;
  line-height: 44px;
  z-index: 99;
  font-size: 25px;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  display: none;
  animation: backto-top-bounce 4s infinite ease-in-out;
}
@keyframes backto-top-bounce {
  0% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(-5px);
  }
}
/*-----------------------------------------
    ## Preloader Css
-------------------------------------------*/
.pre-wrap {
  position: fixed;
  content: "";
  transform: translate(-100%, -240%);
  font-size: 62px;
}

.preloader-inner {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999999999;
  background-color: #030724;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preloader-inner .cancel-preloader {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.preloader-inner .cancel-preloader a {
  background-color: #fff;
  font-weight: 600;
  text-transform: capitalize;
  color: var(--main-color);
  width: 200px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 30px;
  display: block;
  transition: all 0.4s ease;
}
.preloader-inner .cancel-preloader a:hover {
  background-color: var(--heading-color);
  color: #fff;
}

.spinner {
  margin: 120px auto;
  width: 60px;
  height: 60px;
  position: relative;
  text-align: center;
  animation: sk-rotate 2s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: var(--main-color);
  border-radius: 100%;
  animation: sk-bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  animation-delay: -1s;
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
/*-----------------------------------------
    ## video
------------------------------------------*/
.video-thumb {
  position: relative;
}
.video-thumb .video-play-btn-hover {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.video-play-btn {
  border-radius: 50%;
  background: #fff;
  width: 50px;
  height: 50px;
  display: inline-block;
  line-height: 50px;
  position: relative;
  z-index: 0;
  text-align: center;
  animation: ripple-white3 2.5s linear infinite;
  z-index: 3;
  box-shadow: 0 4px 15px rgba(19, 16, 34, 0.1);
}
.video-play-btn:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: rgba(247, 247, 247, 0.4);
  top: -15px;
  left: -15px;
}
.video-play-btn i {
  color: var(--main-color);
  margin-left: 6px;
  font-size: 28px;
}
.video-play-btn.video-play-btn-base {
  background: var(--main-color);
}
.video-play-btn.video-play-btn-base i {
  color: #fff;
}
.video-play-btn.video-play-btn-base:after {
  display: none;
}
.video-play-btn.small {
  width: 55px;
  height: 55px;
  line-height: 60px;
}
.video-play-btn.small i {
  font-size: 18px;
}

/*-----------------------------------------
    ## Breadcumb
------------------------------------------*/
.breadcrumb-area {
  padding: 222px 0 108px;
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  margin-top: -120px;
}
.breadcrumb-area .banner-bg-img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
  background-size: 102% 96%;
}
.breadcrumb-area .breadcrumb-inner {
  position: relative;
  z-index: 2;
}
.breadcrumb-area .page-title {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 5px;
}
.breadcrumb-area .page-list {
  margin: 0;
  padding: 0;
}
.breadcrumb-area .page-list li {
  font-weight: 600;
  list-style: none;
  display: inline-block;
  position: relative;
  color: var(--heading-color);
}
.breadcrumb-area .page-list li:first-child {
  padding-left: 0;
  margin-left: 0;
}
.breadcrumb-area .page-list li:first-child:after {
  display: none;
}

/********* social-media *********/
.social-media {
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}
.social-media li {
  display: inline-block;
  margin: 0 2px;
}
.social-media li a {
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 5px;
  display: inline-block;
  background: #333f4d;
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.social-media li a:hover {
  background: var(--main-color);
  color: #fff;
}
.social-media li a.facebook {
  color: #3b5999;
  border-color: #3b5999;
}
.social-media li a.twitter {
  color: #55acee;
  border-color: #55acee;
}
.social-media li a.instagram {
  color: #e4405f;
  border-color: #e4405f;
}
.social-media li a.youtube {
  color: #cd201f;
  border-color: #cd201f;
}
.social-media li:first-child {
  margin-left: 0;
}
.social-media li:last-child {
  margin-right: 0;
}

.social-media-light a {
  background: rgba(253, 74, 54, 0.15);
  display: inline-block;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  text-align: center;
  line-height: 31px;
}
.social-media-light a i {
  color: var(--main-color);
  font-size: 15px;
  transition: 0.4s;
}
.social-media-light a:hover {
  background: var(--main-color);
}
.social-media-light a:hover i {
  color: #fff;
}

/********* slider-control *********/
.slider-control-round .slick-slider .slick-next {
  height: 46px;
  width: 46px;
  line-height: 44px;
  margin: 0 10px;
  border-radius: 50%;
  border: 0;
  transition: 0.4s;
  box-shadow: none;
  color: var(--heading-color);
  border: 1px solid var(--main-color);
  padding: 9px;
  cursor: pointer;
  font-size: 18px;
  background: transparent;
  position: absolute;
  right: 0;
  top: -95px;
}
.slider-control-round .slick-slider .slick-next:hover {
  background: var(--main-color);
  color: #fff;
}
.slider-control-round .slick-slider .slick-prev {
  left: 0;
  height: 46px;
  width: 46px;
  line-height: 44px;
  margin: 0 10px;
  border-radius: 50%;
  border: 0;
  transition: 0.4s;
  box-shadow: none;
  color: var(--heading-color);
  border: 1px solid var(--main-color);
  padding: 9px;
  cursor: pointer;
  font-size: 18px;
  background: transparent;
  position: absolute;
  left: unset;
  top: -95px;
  right: 60px;
}
.slider-control-round .slick-slider .slick-prev:hover {
  background: var(--main-color);
  color: #fff;
}

.slider-control-square .slick-slider .slick-next {
  height: 46px;
  width: 46px;
  line-height: 44px;
  margin: 0 10px;
  border-radius: 8px;
  border: 0;
  transition: 0.4s;
  box-shadow: none;
  color: #fff;
  border: 1px solid #50af9b;
  padding: 9px;
  cursor: pointer;
  font-size: 18px;
  background: transparent;
  position: absolute;
  right: 0;
  top: -95px;
}
.slider-control-square .slick-slider .slick-next:hover {
  background: #50af9b;
  color: #fff;
}
.slider-control-square .slick-slider .slick-prev {
  left: 0;
  height: 46px;
  width: 46px;
  line-height: 44px;
  margin: 0 10px;
  border-radius: 8px;
  border: 0;
  transition: 0.4s;
  box-shadow: none;
  color: #fff;
  border: 1px solid #50af9b;
  padding: 9px;
  cursor: pointer;
  font-size: 18px;
  background: transparent;
  position: absolute;
  left: unset;
  top: -95px;
  right: 60px;
}
.slider-control-square .slick-slider .slick-prev:hover {
  background: #50af9b;
  color: #fff;
}

.slider-control-square .owl-nav button {
  height: 45px;
  width: 60px;
  line-height: 46px;
  margin: 0 8px;
  border-radius: 0;
  border: 1px solid var(--main-color);
  transition: 0.4s;
  box-shadow: none;
  color: var(--main-color);
  background: transparent;
  font-size: 20px;
  padding: 0;
  cursor: pointer;
}
.slider-control-square .owl-nav button:hover {
  background: var(--main-color);
  color: #fff;
}
.slider-control-square .owl-nav .owl-prev {
  margin-left: 0;
}
.slider-control-square .owl-nav .owl-next {
  margin-left: 0;
}

.slider-control-right-top .owl-nav {
  position: absolute;
  right: 0;
  top: -95px;
}

.slider-control-dots .owl-dots {
  text-align: center;
  padding-top: 23px;
}
.slider-control-dots .owl-dots .owl-dot {
  margin: 0 2px;
  border: 0;
  background: none;
}
.slider-control-dots .owl-dots .owl-dot span {
  display: block;
  border-radius: 50%;
  background-color: var(--heading-color);
  width: 8px;
  height: 8px;
  position: relative;
  transition: all 0.3s ease;
}
.slider-control-dots .owl-dots .owl-dot span:after {
  position: absolute;
  content: "";
  top: -5px;
  left: -5px;
  border: 1px solid var(--main-color);
  border-radius: 50%;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  transform: scale(0);
  transition: all 0.3s ease;
}
.slider-control-dots .owl-dots .owl-dot.active span {
  background: var(--main-color);
}
.slider-control-dots .owl-dots .owl-dot.active span:after {
  transform: scale(1);
}
.slider-control-dots .owl-dots .owl-dot:focus {
  outline: 0;
}

.single-list-inner {
  margin: 0;
  padding: 0;
}
.single-list-inner li {
  margin-bottom: 6px;
}
.single-list-inner li:last-child {
  margin-bottom: 0;
}
.single-list-inner.style-check li {
  list-style: none;
}
.single-list-inner.style-check li svg,
.single-list-inner.style-check li i {
  margin-right: 10px;
  color: var(--main-color);
  font-size: 18px;
}
.single-list-inner.style-check li .sky {
  color: #50af9b;
}
.single-list-inner.style-heading li {
  color: var(--heading-color);
  font-weight: 600;
}

/*--------------------------------------------------------------
# Globals
--------------------------------------------------------------*/
.border-radius-6 {
  border-radius: 6px;
}
.border-radius-6 img {
  border-radius: 6px;
}

.ratting-inner {
  color: #ffc107;
}

.bg-base {
  background: var(--main-color);
}

.bg-base-2 {
  background: #50af9b !important;
}

.bg-green {
  background: #1dc295;
}

.bg-blue {
  background: #2878eb;
}

.bg-red {
  background: #f14d5d;
}

.bg-gray {
  background: #f8f9fc;
}

.bg-sky {
  background: #f9f9f9;
}

.bg-gradient-gray {
  background-image: linear-gradient(#f8f9fc, #d9e5ff);
}

.bg-black {
  background: var(--heading-color);
}

.bg-light {
  background: #f7fafc;
}

.bg-light-pink {
  background: #fff9f5;
}

.bg-relative {
  position: relative;
}

.bg-cover {
  background-size: cover !important;
  background-position: center;
}

.bg-position-right {
  background-position: right;
  background-repeat: no-repeat;
}

.bg-left-50 {
  background-position: left;
  background-repeat: no-repeat;
  background-size: 50% 100%;
}

.bg-overlay {
  position: relative;
  background-size: cover !important;
}
.bg-overlay:after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(10, 24, 81, 0.88);
}
.bg-overlay .container {
  position: relative;
  z-index: 2;
}
.bg-overlay .bg-z-index {
  position: relative;
  z-index: 2;
}

.bg-overlay-light {
  position: relative;
  background-size: cover !important;
}
.bg-overlay-light:after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(10, 24, 81, 0.5);
}
.bg-overlay-light .container {
  position: relative;
  z-index: 2;
}
.bg-overlay-light .bg-z-index {
  position: relative;
  z-index: 2;
}

.bg-parallex {
  background-attachment: fixed;
  background-position: center 0;
}

.image-hover-animate {
  overflow: hidden;
}
.image-hover-animate img {
  transform: scale(1.02);
  transition: 0.7s;
}
.image-hover-animate:hover img {
  transform: scale(1.1);
}

.box-shadow {
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1);
}

.pd-top-60 {
  padding-top: 60px;
}

.pd-top-90 {
  padding-top: 90px;
}

.pd-top-100 {
  padding-top: 100px;
}

.pd-top-110 {
  padding-top: 110px;
}

.pd-top-115 {
  padding-top: 115px;
}

.pd-top-120 {
  padding-top: 120px;
}

.pd-top-200 {
  padding-top: 200px;
}

.mg-top-120 {
  margin-top: 120px;
}

.mg-bottom-120 {
  margin-bottom: 120px;
}

.pd-bottom-60 {
  padding-bottom: 60px;
}

.pd-bottom-70 {
  padding-bottom: 70px;
}

.pd-bottom-80 {
  padding-bottom: 80px;
}

.pd-bottom-90 {
  padding-bottom: 90px;
}

.pd-bottom-100 {
  padding-bottom: 100px;
}

.pd-bottom-110 {
  padding-bottom: 110px;
}

.pd-bottom-115 {
  padding-bottom: 115px;
}

.pd-bottom-120 {
  padding-bottom: 120px;
}

.mg-top--82 {
  margin-top: -100px;
}

.position-bottom-left {
  position: absolute;
  left: 30px;
  bottom: 150px;
  width: 50px;
}

.border-right-1 {
  border-right: 1px solid #ededed;
}

.border-radius-20 {
  border-radius: 20px;
}

.border-radius-5 {
  border-radius: 5px;
}

.color-base {
  color: var(--main-color);
}

.border-1 {
  border: 1px solid #ededed;
}

.border-top-1 {
  border-top: 1px solid #ededed;
}

.border-right-1 {
  border-right: 1px solid #ededed;
}

.border-radius-20 {
  border-radius: 20px;
}

.border-radius-5 {
  border-radius: 5px !important;
}

.image-hover-rotate .rotate-img {
  transition: 0.4s;
}
.image-hover-rotate:hover .rotate-img {
  transform: rotateY(180deg);
}

/************ animate style ************/
.top_image_bounce {
  animation: top-image-bounce 3s infinite ease-in-out;
}

.left_image_bounce {
  animation: left-image-bounce 3s infinite ease-in-out;
}

.right_image_bounce {
  animation: right-image-bounce 3s infinite ease-in-out;
}

.spin_image {
  animation: spin 3s infinite ease-in-out;
}
@keyframes top-image-bounce {
  0% {
    transform: translateY(-8px);
  }
  50% {
    transform: translateY(12px);
  }
  100% {
    transform: translateY(-8px);
  }
}
@keyframes left-image-bounce {
  0% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(-5px);
  }
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
    transform-origin: 50%;
  }
}
@keyframes ripple-white3 {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.1), 0 0 0 10px rgba(255, 255, 255, 0.1), 0 0 0 20px rgba(255, 255, 255, 0.1);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.1), 0 0 0 20px rgba(255, 255, 255, 0.1), 0 0 0 100px rgba(255, 255, 255, 0);
  }
}
/*------------------------------------------------
    ## Section title
------------------------------------------------*/
.section-title {
  margin-bottom: 50px;
  position: relative;
}
.section-title .sub-title {
  border-radius: 30px;
  box-shadow: 0 4.4px 30px rgba(19, 16, 34, 0.1);
  background: #fff;
  padding: 8px 20px;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 15px;
  letter-spacing: 1px;
}
.section-title .sub-title-sky-blue {
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  padding: 0;
  color: #50af9b;
  text-transform: uppercase;
  font-weight: 600;
}
.section-title .title {
  margin-bottom: 0;
  margin-top: 0;
}
.section-title .title span {
  color: var(--main-color);
}
.section-title .content {
  margin-top: 17px;
  margin-bottom: 0;
}
.section-title .small-title {
  margin-top: 18px;
  line-height: 36px;
}
.section-title .phone {
  font-weight: 400;
  margin-top: 30px;
}
.section-title .phone img {
  margin-right: 6px;
}
.section-title .single-list-wrap {
  margin-top: 21px;
}
.section-title .btn {
  margin-top: 30px;
}
.section-title.style-white .sub-title {
  color: var(--main-color);
}
.section-title.style-white .sub-title.left-line:before {
  background: #fff;
}
.section-title.style-white .sub-title.right-line:after {
  background: #fff;
}
.section-title.style-white .sub-title.double-line:before {
  background: #fff;
}
.section-title.style-white .sub-title.double-line:after {
  background: #fff;
}
.section-title.style-white .title {
  color: #fff;
}
.section-title.style-white .content {
  color: #fff;
}
.section-title.style-white .small-title {
  color: #fff;
}

/*----------------------------------------------
    # Nav bar
----------------------------------------------*/
.navbar-top {
  background: #091d3e;
  padding: 15px 0;
}
.navbar-top ul {
  margin: 0;
  padding: 0;
  line-height: initial;
}
.navbar-top ul li {
  display: inline-block;
  list-style: none;
  margin-right: 25px;
}
.navbar-top ul li:last-child {
  margin-right: 0;
  padding-right: 0;
  border-right: 0;
}
.navbar-top ul li p,
.navbar-top ul li a {
  margin: 0;
  font-size: 14px;
  color: #fff;
}
.navbar-top ul li p img,
.navbar-top ul li a img {
  margin-right: 5px;
}
.navbar-top ul li p i,
.navbar-top ul li a i {
  margin-right: 5px;
}
.navbar-top ul li p svg,
.navbar-top ul li a svg {
  margin-right: 5px;
}
.navbar-top ul li a:hover {
  color: var(--heading-color);
}
.navbar-top .topbar-right a {
  margin: 0 3px;
}
.navbar-top .topbar-right li a i {
  margin-right: 0;
}
.navbar-top .topbar-right li a svg {
  margin-right: 0;
}
.navbar-top .topbar-right li a:last-child {
  margin-right: 0;
}
.navbar-top .topbar-right li:last-child {
  border-right: 0;
}

.navbar-area {
  position: relative;
  z-index: 99;
  margin-top: 20px;
}
.navbar-area .nav-container {
  transition: all 0.4s;
  position: relative;
}
.navbar-area .nav-container.navbar-bg {
  position: relative;
  padding-left: 40px;
}
.navbar-area .nav-container.navbar-bg:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 0;
  height: 100%;
  width: 95%;
  background: #fff;
  z-index: -1;
}
.navbar-area .nav-container .logo {
  line-height: 0.9;
  color: var(--main-color);
}
.navbar-area .nav-container .logo a {
  font-weight: 700;
  font-size: 24px;
  color: #fff;
}
.navbar-area .nav-container .logo a img {
  height: auto;
  max-width: 150px;
}
.navbar-area .nav-container .btn-transparent {
  font-size: 13px;
  font-weight: 700;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav {
  display: block;
  width: 100%;
  text-align: left;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li {
  display: inline-block;
  font-weight: 500;
  line-height: 80px;
  text-transform: capitalize;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li a {
  color: var(--heading-color);
  font-weight: 600;
  font-size: 16px;
  font-family: var(--heading-font);
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li:hover a {
  color: var(--main-color);
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li + li {
  margin-left: 17px;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children {
  position: relative;
  z-index: 0;
  padding-right: 14px;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:before {
  content: "";
  position: absolute;
  right: 3px;
  top: 50%;
  height: 10px;
  width: 2px;
  transform: translateY(-50%);
  transition: all 0.3s ease-in;
  margin-top: 0;
  z-index: -1;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:after {
  content: "";
  position: absolute;
  right: -1px;
  top: 40px;
  height: 2px;
  width: 10px;
  transform: translateY(-50%);
  transition: all 0.3s ease-in;
  z-index: -1;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:hover {
  transition: all 0.4s ease;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:hover:before {
  opacity: 0;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:hover:after {
  background: var(--main-color);
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:hover > .sub-menu {
  visibility: visible;
  opacity: 1;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu {
  position: absolute;
  text-align: left;
  min-width: 210px;
  margin: 0;
  padding: 0;
  list-style: none;
  left: 0;
  top: 100%;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
  z-index: 9;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.4s ease;
  border-radius: 0;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu.border-bt0 {
  border-bottom: 0px !important;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li {
  display: block;
  margin-left: 0;
  line-height: 22px;
  font-size: 15px;
  transition: all 0.4s ease;
  border-bottom: 1px solid #f5f5f5;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li a {
  display: block;
  padding: 10px 20px;
  white-space: nowrap;
  transition: all 0.3s;
  color: #050a30;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.4s ease;
  position: relative;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li:hover {
  background: #061539;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li:hover a {
  color: #fff;
  padding: 10px 20px 10px 30px;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li:hover a:before {
  visibility: visible;
  opacity: 1;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li:last-child {
  border-bottom: 0;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .menu-item-has-children {
  position: relative;
  z-index: 0;
  padding-right: 0px;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .menu-item-has-children:before {
  position: absolute;
  right: 15px;
  top: 50%;
  content: "\\f105";
  font-family: "fontawesome";
  /* IE 9 */
  /* Chrome, Safari, Opera */
  transform: translateY(-50%);
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .menu-item-has-children > .sub-menu {
  left: 100%;
  top: 20px;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .menu-item-has-children > .sub-menu .sub-menu .sub-menu {
  left: auto;
  right: 100%;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .menu-item-has-children:hover > .sub-menu {
  visibility: visible;
  opacity: 1;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .menu-item-has-children:hover > .sub-menu li:hover:before {
  color: #fff;
}
.navbar-area .nav-container .navbar-collapse .navbar-nav > li {
  margin-right: 12px;
}

.navbar-nav {
  opacity: 0;
  margin-right: -30px;
  visibility: hidden;
  transition: all 0.4s ease 0s;
}

.navbar-area-2 {
  margin-top: 0;
}
.navbar-area-2:after {
  display: none;
}

.sticky-active {
  animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 9999;
  box-shadow: 0 10px 20px 0 rgba(46, 56, 220, 0.05);
  border-bottom: 0;
  background: #fff;
}

.menu-open {
  opacity: 1;
  margin-right: 0;
  visibility: visible;
}

.bar1 {
  width: 32px;
  height: 2px;
  margin-bottom: 5px;
  position: absolute;
  background: #fff;
  z-index: 9999;
  top: 10px;
  right: -5px;
}

.bar2 {
  width: 24px;
  height: 2px;
  margin-bottom: 5px;
  position: absolute;
  background: #fff;
  z-index: 9999;
  top: 17px;
  right: -5px;
}

.bar3 {
  width: 18px;
  height: 2px;
  margin-bottom: 5px;
  position: absolute;
  background: #fff;
  z-index: 9999;
  top: 24px;
  right: -5px;
}

.responsive-mobile-menu button:focus {
  outline: none;
  border: none;
}

/**************** nav-left-part *************/
.header-cat-menu {
  margin: 0;
  padding: 0;
  margin-left: 58px;
}
.header-cat-menu li {
  position: relative;
  margin-right: 0;
  cursor: pointer;
  list-style: none;
}
.header-cat-menu li img {
  margin-top: -3px;
  margin-right: 5px;
}
.header-cat-menu li a {
  color: #022334;
  font-weight: 500;
  font-size: 18px;
}
.header-cat-menu li .sub-menu {
  position: absolute;
  left: 0;
  top: 40px;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 9;
  border: none;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
  min-width: 210px;
}
.header-cat-menu li .sub-menu li {
  display: block;
  margin-left: 0;
  line-height: 22px;
  font-size: 15px;
  transition: all 0.4s ease;
  border-bottom: 1px solid #f5f5f5;
}
.header-cat-menu li .sub-menu li a {
  display: block;
  padding: 10px 20px;
  white-space: nowrap;
  transition: all 0.3s;
  color: #050a30;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.4s ease;
  position: relative;
}
.header-cat-menu li .sub-menu li a:before {
  position: absolute;
  left: 17px;
  top: 50%;
  content: "\\f105";
  font-family: "fontawesome";
  /* IE 9 */
  /* Chrome, Safari, Opera */
  transform: translateY(-50%);
  visibility: hidden;
  opacity: 0;
  transition: 0.4s;
  color: #fff;
}
.header-cat-menu li .sub-menu li:hover {
  background: #061539;
}
.header-cat-menu li .sub-menu li:hover a {
  color: #fff;
  padding: 10px 20px 10px 30px;
}
.header-cat-menu li .sub-menu li:hover a:before {
  visibility: visible;
  opacity: 1;
}
.header-cat-menu li .sub-menu li:last-child {
  border-bottom: 0;
}
.header-cat-menu li:hover > a {
  color: var(--main-color);
}
.header-cat-menu li:hover ul {
  opacity: 1;
  visibility: visible;
  animation: menuslide 300ms;
}

/**************** nav-right-part *************/
.nav-right-part .navbar-phone {
  height: 80px;
  color: #fff;
  border-radius: 0;
  position: relative;
  display: inline-block;
  background: var(--main-color);
  padding: 11px 25px 11px 85px;
}
.nav-right-part .navbar-phone .icon {
  position: absolute;
  left: 20px;
  background: rgba(255, 255, 255, 0.1);
  display: inline-block;
  height: 50px;
  width: 50px;
  line-height: 47px;
  text-align: center;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}
.nav-right-part .navbar-phone span {
  font-weight: 500;
  color: #fff;
  display: inline-block;
  margin-bottom: 2px;
  font-size: 15px;
}
.nav-right-part .navbar-phone h5 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0;
}
.nav-right-part a {
  margin-left: 15px;
  color: var(--heading-color);
}
.nav-right-part .search-bar-btn {
  margin-top: -22px;
  cursor: pointer;
}
.nav-right-part .search-bar:hover {
  background: var(--main-color);
  border: 1px solid var(--main-color);
}

.navbar-area-2 .nav-right-part {
  align-items: center;
}

.navbar-area-2 .nav-right-part .navbar-phone {
  color: var(--heading-color);
  background: transparent;
}

.navbar-area-2 .nav-right-part .navbar-phone .icon {
  background: rgba(36, 107, 253, 0.1803921569);
}

.navbar-area-2 .nav-right-part .navbar-phone .icon img {
  filter: invert(38%) sepia(100%) saturate(3579%) hue-rotate(212deg) brightness(97%) contrast(105%);
}

.navbar-area-2 .nav-right-part .navbar-phone h5,
.navbar-area-2 .nav-right-part .navbar-phone span {
  color: var(--heading-color);
}

.navbar-area-3 .nav-container .navbar-collapse .navbar-nav li a {
  color: #fff;
}
.navbar-area-3 .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:before,
.navbar-area-3 .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:after {
  background: #fff;
}

.navbar-area-3 .navbarFive li:hover > a {
  color: #50af9b !important;
}
.navbar-area-3 .navbarFive li:hover:before {
  background: #50af9b !important;
}
.navbar-area-3 .navbarFive li:hover::after {
  background: #50af9b !important;
}
.navbar-area-3 .navbarFive li .sub-menu li:hover {
  background: #50af9b !important;
}
.navbar-area-3 .navbarFive li .sub-menu li:hover > a {
  color: #fff !important;
}

.nav-right-part-desktop {
  margin-left: 20px;
}

.nav-right-part-mobile {
  display: none;
}

/**************** sidebar-menu *************/
.sidebar-menu {
  width: 0;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  background-color: #fff;
  z-index: 999;
  overflow-y: auto;
  transition: 0.5s;
  opacity: 0;
  visibility: hidden;
}

.sidebar-menu .sidebar-inner {
  position: relative;
  top: 150px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  padding: 90px 40px 50px 40px;
}
.sidebar-menu .sidebar-inner .thumb {
  margin-bottom: 15px;
}
.sidebar-menu .sidebar-inner p {
  margin-bottom: 28px;
}
.sidebar-menu .sidebar-inner .sidebar-address {
  margin-bottom: 35px;
}
.sidebar-menu .sidebar-inner .sidebar-address ul {
  margin: 0;
  padding: 0;
}
.sidebar-menu .sidebar-inner .sidebar-address ul li {
  list-style: none;
  margin-bottom: 4px;
}
.sidebar-menu .sidebar-inner .sidebar-address ul li:last-child {
  margin-bottom: 0;
}
.sidebar-menu .sidebar-inner .sidebar-address ul li i {
  margin-right: 6px;
  width: 25px;
}
.sidebar-menu .sidebar-inner .sidebar-subscribe {
  position: relative;
  margin-bottom: 40px;
}
.sidebar-menu .sidebar-inner .sidebar-subscribe input {
  width: 100%;
  border: 1px solid #d6dadf;
  height: 42px;
  padding: 0 45px 0 12px;
}
.sidebar-menu .sidebar-inner .sidebar-subscribe button {
  position: absolute;
  right: 0;
  top: 0;
  height: 42px;
  width: 42px;
  background: #97b3d0;
  transition: 0.4s;
  border: 0;
  color: var(--heading-color);
  cursor: pointer;
}
.sidebar-menu .sidebar-inner .sidebar-subscribe button:hover {
  background: var(--main-color);
  color: #fff;
}
.sidebar-menu .sidebar-inner .social-media li a {
  background: #ced4da;
}
.sidebar-menu .sidebar-inner .social-media li a:hover {
  background: var(--main-color);
  color: #fff;
}

.sidebar-menu .sidebar-menu-close {
  background-color: var(--main-color);
  border: 0;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  width: 50px;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  z-index: 999;
}

.sidebar-menu.active {
  width: 360px;
  opacity: 1;
  visibility: visible;
}

.sidebar-menu.active .sidebar-inner {
  top: 0;
  opacity: 1;
  visibility: visible;
  transition: all 0.7s ease-out 0.8s;
}

@media only screen and (max-width: 991px) {
  .navbar-area {
    background: #fff;
  }
  .navbar-area .nav-container {
    padding: 5px 0;
  }
  .nav-right-part {
    margin-right: 60px;
  }
  .nav-right-part .btn .right {
    padding-left: 5px;
    font-size: 13px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav > li {
    margin-right: 0;
    padding-right: 0;
  }
  .navbar-area .nav-container {
    position: relative;
    z-index: 0;
  }
  .navbar-area .nav-container .navbar-toggler {
    padding: 0px;
  }
  .navbar-area .nav-container .navbar-collapse {
    margin-top: 13px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav {
    display: block;
    margin-top: 20px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li {
    display: block;
    text-align: left;
    line-height: 30px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li a {
    display: block;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li:last-child {
    border-bottom: none;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li + li {
    margin-left: 0;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:before {
    top: 26px;
    right: 3px !important;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu {
    position: initial;
    display: block;
    width: 100%;
    border-top: none;
    box-shadow: none;
    margin-left: 0;
    padding-bottom: 0;
    height: auto;
    overflow: hidden;
    max-height: 0;
    overflow-y: hidden;
    background-color: transparent;
    border-radius: 10px;
    padding: 0px;
    border-bottom: none;
    transition: none;
    visibility: visible;
    opacity: 1;
    transition: all 0.5s linear;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu.active {
    visibility: visible;
    opacity: 1;
    max-height: 250px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu .sub-menu .menu-item-has-children:before {
    content: "\\f107";
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li {
    padding: 0;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li.menu-item-has-children:hover:before {
    top: 30px;
    color: #fff;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li + li {
    border-top: none;
  }
}
.sopen {
  display: block !important;
}

.toggle-btn {
  left: auto;
  right: 0;
  position: absolute;
  top: 8px;
  width: 40px;
  height: 40px;
  transition-duration: 0.5s;
  border: 0;
  background: transparent;
}
.toggle-btn .icon-left {
  transition-duration: 0.5s;
  position: absolute;
  height: 2px;
  width: 11px;
  top: 18px;
  background-color: var(--heading-color);
  left: 7px;
}
.toggle-btn .icon-left:before {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  background-color: var(--heading-color);
  content: "";
  top: -7px;
  left: 0;
}
.toggle-btn .icon-left:after {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  background-color: var(--heading-color);
  content: "";
  top: 7px;
  left: 0;
}
.toggle-btn .icon-left:hover {
  cursor: pointer;
}
.toggle-btn .icon-right {
  transition-duration: 0.5s;
  position: absolute;
  height: 2px;
  width: 11px;
  top: 18px;
  background-color: var(--heading-color);
  left: 18px;
}
.toggle-btn .icon-right:before {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  background-color: var(--heading-color);
  content: "";
  top: -7px;
  left: 0;
}
.toggle-btn .icon-right:after {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  background-color: var(--heading-color);
  content: "";
  top: 7px;
  left: 0;
}
.toggle-btn .icon-right:hover {
  cursor: pointer;
}
.toggle-btn.open .icon-left {
  transition-duration: 0.5s;
  background: transparent;
}
.toggle-btn.open .icon-left:before {
  transform: rotateZ(45deg) scaleX(1.4) translate(2px, 1px);
}
.toggle-btn.open .icon-left:after {
  transform: rotateZ(-45deg) scaleX(1.4) translate(2px, -1px);
}
.toggle-btn.open .icon-right {
  transition-duration: 0.5s;
  background: transparent;
}
.toggle-btn.open .icon-right:before {
  transform: rotateZ(-45deg) scaleX(1.4) translate(-2px, 1px);
}
.toggle-btn.open .icon-right:after {
  transform: rotateZ(45deg) scaleX(1.4) translate(-2px, -1px);
}
.toggle-btn:hover {
  cursor: pointer;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .navbar-area .nav-container .navbar-collapse .navbar-nav li {
    font-size: 16px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li + li {
    margin-left: 5px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .responsive-mobile-menu {
    display: block;
    width: 100%;
    position: relative;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li {
    font-size: 14px;
  }
}
@media only screen and (max-width: 1199px) {
  .margin-xlt-80 {
    margin-top: 0px;
  }
  .contact-widget .contact_info_list li.single-info-item .details {
    padding-left: 25px;
  }
}
@media only screen and (max-width: 991px) {
  .navbar-area .logo {
    padding-top: 0px !important;
  }
  .widget ul {
    text-align: left;
  }
  .navbar-collapse {
    background: #fff;
    margin-top: 0px;
    width: 100%;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:before {
    right: 20px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav {
    margin-bottom: 20px;
  }
  .navbar-area {
    padding-bottom: 0px;
  }
  .bar1,
  .bar2,
  .bar3 {
    background: #fff;
  }
  .party-box-wrapper {
    padding: 50px 0px;
  }
  .party-box-wrapper .party-box-content h4 {
    font-size: 30px;
    line-height: 45px;
  }
  .footer-area .copyright-area-inner {
    padding: 20px;
  }
  .navbar-expand-lg .navbar-collapse {
    margin-top: 0px;
  }
  .contact-widget .contact_info_list li.single-info-item .details {
    padding-left: 25px;
  }
  .footer-area .footer-top .widget.widget_nav_menu ul li a {
    font-size: 14px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu {
    padding: 0 0 0 20px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li a {
    padding: 12px 0;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li:last-child a {
    padding-bottom: 3px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li a:hover i {
    opacity: 0;
    margin-right: -18px;
  }
  .nav-right-part-mobile {
    display: block;
  }
  .nav-right-part-desktop {
    display: none;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children .sub-menu li:hover {
    background: none;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li a {
    color: #333333;
  }
}
/* Tablet Layout wide: 767px. */
@media only screen and (max-width: 767px) {
  .logo-wrapper.mobile-logo {
    display: block;
    width: 100%;
  }
  .responsive-mobile-menu {
    display: block;
    width: 100%;
    position: relative;
  }
  .responsive-mobile-menu .navbar-toggler {
    position: absolute;
    left: calc(100% - 130px);
    top: 10px;
  }
  .table-responsive {
    display: block !important;
  }
  .btn-custom-default,
  .btn-custom-white {
    font-size: 14px;
    line-height: 33px;
    padding: 6px 20px;
  }
  .navbar-area .logo {
    padding-top: 0px !important;
  }
}
/* medium tablet layout 599px */
@media only screen and (max-width: 575px) {
  .navbar-area .nav-container {
    margin: 0px 0px;
  }
  .navbar-area .logo {
    padding-top: 10px;
  }
  .widget.footer-widget .subscribe-form.subscribe-form-style2 .form-control {
    padding: 15px 20px;
  }
  .widget.footer-widget .subscribe-form.subscribe-form-style2 .btn {
    padding: 15px 20px;
  }
  .search-popup .search-form {
    min-width: 350px;
  }
}
@media only screen and (max-width: 375px) {
  .btn-custom-default,
  .btn-custom-white {
    padding: 5px 18px;
  }
  .search-popup .search-form .form-group .form-control,
  .search-popup .search-form .submit-btn {
    height: 45px;
  }
  .search-popup .search-form {
    min-width: 300px;
  }
}
@media only screen and (max-width: 320px) {
  .search-popup .search-form {
    min-width: 265px;
  }
  .responsive-mobile-menu .navbar-toggler {
    left: calc(100% - 95px);
  }
}
/*----------------------------------------------
    # banner style
----------------------------------------------*/
.banner-area {
  margin-top: -120px;
}

.banner-area-1 {
  padding-top: 180px;
}
.banner-area-1 .animate-img-1 {
  position: absolute;
  left: 80px;
  bottom: 100px;
}
.banner-area-1 .animate-img-2 {
  position: absolute;
  left: 100px;
  bottom: 50px;
}

.banner-area-2 {
  padding-top: 210px;
  padding-bottom: 70px;
}
.banner-area-2 .bg-img-2 {
  position: absolute;
  right: -100px;
  top: 0;
  width: 660px;
}
.banner-area-2 .video-play-btn-hover {
  cursor: pointer;
}

.banner-area-3 {
  margin-top: 0;
}
.banner-area-3 .bg-gray {
  padding: 140px 0;
  position: relative;
}
.banner-area-3 .img-right {
  position: absolute;
  right: 0;
  top: 0;
  width: 55%;
  bottom: 0;
  height: 100%;
  z-index: 1;
}
.banner-area-3:after {
  content: "";
  position: absolute;
  right: 40%;
  top: 0;
  width: 20%;
  height: 100%;
  background-image: linear-gradient(to right, #f8f9fc 50%, transparent);
  z-index: 2;
}

.navbar-area-2 .nav-right-part {
  align-items: center;
}
.navbar-area-2 .nav-right-part .navbar-phone {
  color: var(--heading-color);
  background: transparent;
}
.navbar-area-2 .nav-right-part .navbar-phone .icon {
  background: rgba(36, 107, 253, 0.1803921569);
}
.navbar-area-2 .nav-right-part .navbar-phone .icon img {
  filter: invert(38%) sepia(100%) saturate(3579%) hue-rotate(212deg) brightness(97%) contrast(105%);
}
.navbar-area-2 .nav-right-part .navbar-phone h5,
.navbar-area-2 .nav-right-part .navbar-phone span {
  color: var(--heading-color);
}

.banner-inner {
  position: relative;
  z-index: 3;
}
.banner-inner .subtitle {
  border-radius: 30px;
  box-shadow: 0 4.4px 30px rgba(19, 16, 34, 0.05);
  background: #fff;
  padding: 8px 20px;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 15px;
  letter-spacing: 1px;
}
.banner-inner .title {
  font-size: 60px;
  margin-bottom: 20px;
  font-weight: 700;
}
.banner-inner .title span {
  color: var(--main-color);
}
.banner-inner .content {
  margin-bottom: 32px;
}

.banner-thumb {
  position: relative;
}
.banner-thumb .main-img {
  border-radius: 300px 300px 0 0;
}
.banner-thumb:after {
  content: "";
  position: absolute;
  left: -25px;
  bottom: -25px;
  width: 100%;
  height: 100%;
  border: 5px solid var(--main-color);
  border-radius: 300px 300px 0 0;
}
.banner-thumb .banner-animate-img {
  position: absolute;
}
.banner-thumb .banner-animate-img-1 {
  left: -140px;
}
.banner-thumb .banner-animate-img-2 {
  right: 25px;
  bottom: -25px;
  height: 120px;
  width: 120px;
  background: var(--main-color);
  padding: 20px;
}
.banner-thumb .banner-animate-img-3 {
  right: -9px;
  bottom: -68px;
}

.banner-thumb-2 {
  position: relative;
}
.banner-thumb-2 .banner-animate-img {
  position: absolute;
}
.banner-thumb-2 .main-img-wrap {
  position: relative;
}
.banner-thumb-2 .main-img-wrap .banner-animate-img-1 {
  left: -140px;
  width: 120px;
  z-index: 1;
}
.banner-thumb-2 .main-img-wrap .banner-animate-img-2 {
  right: -70px;
  z-index: 1;
  top: 50px;
}
.banner-thumb-2 .main-img-wrap .banner-animate-img-3 {
  left: -110px;
  bottom: 100px;
  z-index: 1;
}
.banner-thumb-2 .banner-animate-img-4 {
  right: -20px;
  top: 0;
  z-index: 0;
}
.banner-thumb-2 .main-img-wrap {
  z-index: 1;
  margin-left: 160px;
}

.banner-thumb-3 {
  position: relative;
  position: relative;
}
.banner-thumb-3 .banner-animate-img {
  position: absolute;
}
.banner-thumb-3 .banner-animate-img-1 {
  left: -50px;
  top: 30%;
}
.banner-thumb-3 .banner-animate-img-2 {
  right: 50px;
  bottom: 40px;
}

/*----------------------------------------------
    # about style
----------------------------------------------*/
.about-thumb-inner {
  position: relative;
}
.about-thumb-inner .animate-img-1 {
  position: absolute;
  left: 100px;
  bottom: 7px;
  z-index: 2;
}
.about-thumb-inner .top_image_bounce {
  z-index: 9;
}
.about-thumb-inner .animate-img-2 {
  position: absolute;
  right: 50px;
  top: 180px;
  z-index: 2;
}
.about-thumb-inner .animate-img-3 {
  position: absolute;
  left: 80px;
  top: -20px;
}
.about-thumb-inner .animate-img-4 {
  position: absolute;
  right: 0;
  bottom: 0;
}
.about-thumb-inner .animate-img-bottom-right {
  position: absolute;
  right: -100px;
  bottom: 80px;
  z-index: 2;
}
.about-thumb-inner .animate-main-img {
  position: absolute;
  left: 0;
  top: 0;
}
.about-thumb-inner .main-img {
  position: relative;
  z-index: 1;
}
.about-thumb-inner .video-play-btn-hover {
  position: absolute;
  right: 10px;
  top: 60px;
  z-index: 9;
}

.single-about-inner .thumb {
  display: inline-block;
  background: #f8f9fc;
  border-radius: 5px 40px 40px 40px;
  height: 80px;
  width: 80px;
  line-height: 78px;
  text-align: center;
  transition: 0.4s;
}
.single-about-inner .thumb img {
  transition: 0.4s;
}
.single-about-inner .details p {
  margin-bottom: 0;
}
.single-about-inner:hover .thumb {
  background: var(--main-color);
}
.single-about-inner:hover .thumb img {
  filter: brightness(100);
}

.accordion-inner .accordion-item {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e3e3e3;
}
.accordion-inner .accordion-item .accordion-button {
  background: transparent;
  font-size: 20px;
  padding: 22px 0;
  box-shadow: none;
  color: var(--main-color);
  font-weight: 600;
}
.accordion-inner .accordion-item .accordion-button.collapsed {
  color: var(--heading-color);
}
.accordion-inner .accordion-item .accordion-body {
  padding: 0 0 30px 0;
}
.accordion-inner.accordion-icon-left .accordion-item .accordion-button {
  padding-left: 50px;
}
.accordion-inner.accordion-icon-left .accordion-item .accordion-button:after {
  left: 0;
  position: absolute;
}
.accordion-inner.style-2 .accordion-item .accordion-button.collapsed {
  color: var(--heading-color);
}
.accordion-inner.style-2 .accordion-item .accordion-button.collapsed:after {
  content: "+";
  font-size: 20px;
}
.accordion-inner.style-2 .accordion-item .accordion-button:after {
  content: "-";
  background-image: none !important;
  font-size: 22px;
  transform: rotate(0);
  width: 30px;
  height: 30px;
  line-height: 24px;
  background: var(--main-color);
  color: #fff;
  text-align: center;
  border-radius: 6px;
}
.accordion-inner.style-3 .accordion-item {
  border: 1px solid #e3e3e3;
  margin-bottom: 20px;
  border-radius: 5px;
  padding: 0 20px;
}
.accordion-inner.style-3 .accordion-item .accordion-button.collapsed {
  color: var(--heading-color);
}
.accordion-inner.style-3 .accordion-item .accordion-button.collapsed:after {
  content: "+";
  font-size: 20px;
}
.accordion-inner.style-3 .accordion-item .accordion-button:after {
  content: "-";
  background-image: none !important;
  font-size: 22px;
  transform: rotate(0);
  width: 30px;
  height: 30px;
  line-height: 24px;
  background: var(--main-color);
  color: #fff;
  text-align: center;
  border-radius: 6px;
}

.single-progressbar {
  background: #fff;
  border-radius: 0px;
  margin-top: 0px;
}
.single-progressbar h6 {
  font-size: 14px;
  font-weight: 700;
  display: inline-block;
  margin-bottom: 0;
}
.single-progressbar .skill {
  overflow: hidden;
  padding: 40px 0 5px;
  position: relative;
  margin-bottom: 10px;
  margin-top: -30px;
}
.single-progressbar .skill:before {
  width: 100%;
  height: 10px;
  content: "";
  display: block;
  position: absolute;
  background: #f2f2f2;
  border-radius: 10px;
  bottom: 5px;
}
.single-progressbar .skill p {
  position: absolute;
  right: 0;
  top: 0px;
  font-size: 14px;
  font-weight: 700;
  font-family: var(--heading-font);
  color: var(--main-color);
}

.skill-bar {
  width: 100%;
  height: 10px;
  background: var(--main-color);
  display: block;
  position: relative;
  border-radius: 10px;
}
.skill-bar .skill-count1 {
  right: -17px;
  position: absolute;
  top: -30px;
  padding: 3px 0;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--heading-font);
  color: var(--heading-color);
}
.skill-bar .skill-count1 p {
  margin: 0 -3px 0 0;
}

/*----------------------------------------------
    # service style
----------------------------------------------*/
.single-service-inner {
  background: #fff;
  padding: 40px 35px;
  margin-bottom: 30px;
  border-radius: 24px;
  transition: 0.5s;
  box-shadow: 0px 4px 20px rgba(19, 16, 34, 0.06);
}
.single-service-inner .thumb {
  margin-bottom: 35px;
  transition: 0.5s;
}
.single-service-inner .thumb img {
  transition: 0.5s;
}
.single-service-inner .details h5 {
  margin-bottom: 20px;
  position: relative;
  transition: 0.4s;
}
.single-service-inner .details p {
  margin-bottom: 28px;
}
.single-service-inner:hover {
  box-shadow: 0px 4px 20px rgba(19, 16, 34, 0.1);
}
.single-service-inner:hover .thumb img {
  transform: rotateY(180deg);
}
.single-service-inner.style-3 {
  border-radius: 5px;
  margin-top: 50px;
  padding: 35px;
}
.single-service-inner.style-3 .thumb {
  height: 100px;
  width: 100px;
  line-height: 96px;
  border-radius: 50%;
  border: 1px solid #e3e3e3;
  text-align: center;
  margin-top: -82px;
  background: #fff;
}
.single-service-inner.style-3 .details h5 {
  font-size: 22px;
}
.single-service-inner.style-3:hover .thumb {
  border: 1px solid var(--main-color);
}

.single-service-inner-2 {
  margin-bottom: 30px;
}
.single-service-inner-2 .thumb {
  background: #f3f4ff;
  border-radius: 20px;
  padding: 30px;
}
.single-service-inner-2 .thumb img {
  transform: scale(1.05);
  transition: 0.6s;
}
.single-service-inner-2 .details {
  padding: 30px;
  background: #fff;
  margin-top: -100px;
  margin-left: 60px;
  position: relative;
  z-index: 2;
  border-radius: 40px 0 0 0;
}
.single-service-inner-2 .details .icon img {
  transition: 0.4s;
}
.single-service-inner-2 .details p {
  margin-bottom: 0;
}
.single-service-inner-2:hover .thumb img {
  transform: scale(1.1);
}
.single-service-inner-2:hover .details {
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
}
.single-service-inner-2:hover .details .icon img {
  transform: rotateY(180deg);
}

.single-service-inner-3 {
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  position: relative;
  transition: 0.4s;
  margin-bottom: 30px;
}
.single-service-inner-3 .thumb {
  display: inline-block;
  border-radius: 50%;
  border: 1px solid #50af9b;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.4s;
}
.single-service-inner-3 .thumb .thumb-inner {
  background: #fff;
  height: 70px;
  width: 70px;
  line-height: 68px;
  border-radius: 50%;
  box-shadow: 0px 0px 4px rgba(19, 16, 34, 0.15);
  margin: 7px;
}
.single-service-inner-3 .details p {
  transition: 0.4s;
}
.single-service-inner-3.single-service-inner-3-left {
  padding: 40px 50px 40px 30px;
}
.single-service-inner-3.single-service-inner-3-left .thumb {
  right: -40px;
}
.single-service-inner-3.single-service-inner-3-right {
  padding: 40px 30px 40px 50px;
}
.single-service-inner-3.single-service-inner-3-right .thumb {
  left: -40px;
}
.single-service-inner-3:hover {
  background: #50af9b;
}
.single-service-inner-3:hover .thumb {
  border: 1px solid #fff;
}
.single-service-inner-3:hover .details h5 {
  color: #fff;
}
.single-service-inner-3:hover .details p {
  color: #fff;
}

.bg-blue-right {
  background: rgba(80, 175, 155, 0.1);
}

.service-middle-section {
  padding: 30px 30px 0 30px;
  height: 100%;
  display: flex;
  align-items: flex-end;
}

.single-work-process-inner {
  border-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  margin-bottom: 30px;
  padding: 30px 20px;
  transition: 0.4s;
}
.single-work-process-inner .thumb img {
  transition: 0.4s;
}
.single-work-process-inner .details .process-count {
  color: var(--main-color);
  font-weight: 600;
}
.single-work-process-inner .details h5 {
  font-weight: 700;
}
.single-work-process-inner .details .content {
  margin-bottom: 0;
}
.single-work-process-inner:hover {
  box-shadow: 0px 10px 30px rgba(0, 33, 71, 0.08);
}
.single-work-process-inner:hover .thumb img {
  transform: rotateY(180deg);
}

.single-work-process-inner-2 {
  padding: 25px;
  margin-top: -90px;
}
.single-work-process-inner-2 .thumb {
  height: 120px;
  width: 120px;
  line-height: 120px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  display: inline-block;
  position: relative;
  background: #fff;
}
.single-work-process-inner-2 .thumb img {
  transition: 0.4s;
}
.single-work-process-inner-2 .thumb .process-count {
  height: 30px;
  width: 30px;
  color: #fff;
  background: var(--main-color);
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  position: absolute;
  right: -15px;
  top: 45px;
  transition: 0.4s;
}
.single-work-process-inner-2 .details p {
  margin-bottom: 0;
}
.single-work-process-inner-2:hover .thumb img {
  transform: rotateY(180deg);
}
.single-work-process-inner-2:hover .thumb .process-count {
  background: var(--heading-color);
}

.single-work-process-inner-3 {
  padding: 40px;
  padding-top: 0;
}
.single-work-process-inner-3 img {
  border-radius: 50%;
}

.single-team-inner {
  border: 1px solid #e3e3e3;
  box-shadow: 0px 4.4px 20px rgba(19, 16, 34, 0.05);
  border-radius: 22px;
  position: relative;
  margin-bottom: 30px;
}
.single-team-inner .thumb {
  position: relative;
  border-radius: 22px;
  overflow: hidden;
}
.single-team-inner .thumb img {
  transform: scale(1.05);
  transition: 0.9s;
}
.single-team-inner .thumb .team-social-inner {
  opacity: 0;
  transition: 0.4s;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
}
.single-team-inner .thumb .team-social-inner.sky {
  background: #50af9b;
}
.single-team-inner .team-social-inner {
  height: 50px;
  padding: 11px 25px 8px;
  background: #fff;
  border-radius: 50px;
  transition: 0.4s;
  display: inline-block;
}
.single-team-inner .team-social-inner li {
  display: inline-block;
  margin-right: 10px;
  padding-right: 10px;
  font-size: 15px;
  border-right: 1px solid #e3e3e3;
  color: #737588;
}
.single-team-inner .team-social-inner li:last-child {
  margin-right: 0;
  padding-right: 0;
  border-right: 0;
}
.single-team-inner .details {
  padding: 20px;
}
.single-team-inner .details p {
  margin-bottom: 0;
}
.single-team-inner:hover .thumb img {
  transform: scale(1.1);
}
.single-team-inner:hover .thumb .team-social-inner {
  bottom: 20px;
  visibility: visible;
  opacity: 1;
}
.single-team-inner.style-2 {
  border-radius: 10px;
  border: 0;
}
.single-team-inner.style-2 .thumb {
  border-radius: 10px;
}
.single-team-inner.style-2 .details {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  padding: 0 20px 0;
}
.single-team-inner.style-2 .details .details-inner {
  border-radius: 10px 10px 0 0;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
}
.single-team-inner.style-2 .details h5 {
  color: var(--main-color);
}
.single-team-inner.style-2 .details h5:hover a {
  color: var(--heading-color);
}
.single-team-inner.style-2 .details p {
  color: var(--heading-color);
}
.single-team-inner.style-2 .details .team-social-inner {
  border-radius: 5px;
  height: 40px;
  padding: 6px 15px;
}

.team-details-page .thumb {
  background: #f5f3ef;
  padding: 40px 0 40px 0;
  margin-right: 40px;
}
.team-details-page .thumb img {
  width: 100%;
  margin-right: -80px;
}
.team-details-page .social-media li a {
  height: 46px;
  width: 46px;
  line-height: 46px;
  border-radius: 0;
  background: var(--heading-color);
  font-size: 16px;
  color: #fff;
}
.team-details-page .social-media li a:hover {
  background: var(--main-color);
}

/*----------------------------------------------
    # pricing style
----------------------------------------------*/
.single-pricing-inner {
  background: #fff;
  padding: 48px;
  transition: 0.4s;
  margin-bottom: 30px;
  box-shadow: 0px 4.8px 20px rgba(19, 16, 34, 0.1);
}
.single-pricing-inner h2 {
  transition: 0.4s;
}
.single-pricing-inner h2 sub {
  font-size: 16px;
  bottom: 1px;
}
.single-pricing-inner h5 {
  margin-bottom: 32px;
  transition: 0.4s;
}
.single-pricing-inner ul {
  padding: 0;
}
.single-pricing-inner ul li {
  list-style: none;
  color: var(--heading-color);
  margin-bottom: 15px;
  transition: 0.4s;
}
.single-pricing-inner ul li i,
.single-pricing-inner ul li svg {
  margin-right: 10px;
}
.single-pricing-inner ul li.hide {
  color: var(--paragraph-color);
}
.single-pricing-inner .btn {
  margin-top: 28px;
}
.single-pricing-inner.price-active, .single-pricing-inner:hover {
  background: #F8F9FC;
  box-shadow: none;
}
.single-pricing-inner.price-active .btn, .single-pricing-inner:hover .btn {
  background: var(--main-color);
  border-color: var(--main-color);
  color: #fff !important;
  line-height: 50px;
}
.single-pricing-inner.style-3 {
  border: 1px solid #E3E3E3;
  box-shadow: none;
}
.single-pricing-inner.style-3 h5 {
  background: #F8F9FC;
  padding: 12px 20px;
  display: inline-block;
  margin-bottom: 32px;
  transition: 0.4s;
}
.single-pricing-inner.style-3.price-active, .single-pricing-inner.style-3:hover {
  background: var(--main-color);
}
.single-pricing-inner.style-3.price-active h2, .single-pricing-inner.style-3:hover h2 {
  color: #fff;
}
.single-pricing-inner.style-3.price-active h5, .single-pricing-inner.style-3:hover h5 {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.single-pricing-inner.style-3.price-active ul, .single-pricing-inner.style-3:hover ul {
  padding: 0;
}
.single-pricing-inner.style-3.price-active ul li, .single-pricing-inner.style-3:hover ul li {
  color: #fff;
}
.single-pricing-inner.style-3.price-active ul li i,
.single-pricing-inner.style-3.price-active ul li svg, .single-pricing-inner.style-3:hover ul li i,
.single-pricing-inner.style-3:hover ul li svg {
  margin-right: 10px;
}
.single-pricing-inner.style-3.price-active ul li.hide, .single-pricing-inner.style-3:hover ul li.hide {
  color: grba(255, 255, 255, 0.1);
}
.single-pricing-inner.style-3.price-active .btn, .single-pricing-inner.style-3:hover .btn {
  background: #fff;
  color: var(--main-color) !important;
}

.single-case-study-inner {
  margin-bottom: 30px;
}
.single-case-study-inner .thumb {
  position: relative;
  overflow: hidden;
  border-radius: 5px;
}
.single-case-study-inner .thumb img {
  transform: scale(1.05);
  transition: 0.9s;
}
.single-case-study-inner .details {
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  padding: 25px 75px 25px 25px;
  margin-left: 50px;
  margin-top: -55px;
  position: relative;
  z-index: 2;
  background: #fff;
  border-radius: 5px 0 5px 5px;
}
.single-case-study-inner .details h5 {
  margin-bottom: 5px;
}
.single-case-study-inner .details .cat {
  color: var(--main-color);
}
.single-case-study-inner .details .right-arrow {
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  background: rgba(36, 107, 253, 0.1);
  display: inline-block;
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--main-color);
}
.single-case-study-inner .details .right-arrow:hover {
  background: var(--main-color);
  color: #fff;
}
.single-case-study-inner:hover .thumb img {
  transform: scale(1.1);
}
.single-case-study-inner:hover .details .right-arrow {
  background: var(--main-color);
  color: #fff;
}

.single-case-study-inner.style-2 {
  position: relative;
}

.single-case-study-inner.style-2 .details {
  position: absolute;
  left: 0;
  bottom: 0;
  background: transparent;
  width: 100%;
  margin-left: 0;
}

.single-case-study-inner.style-2 .details h5 {
  color: #fff;
}

.single-case-study-inner.style-2 .details .cat {
  color: #fff;
}

.single-case-study-inner:hover .thumb img {
  transform: scale(1.1);
}

.single-case-study-inner:hover .details .right-arrow {
  background: var(--main-color);
  color: #fff;
}

/*----------------------------------------------
    # content style
----------------------------------------------*/
.single-counter-inner {
  margin-bottom: 30px;
}
.single-counter-inner .thumb img {
  transition: 0.4s;
}
.single-counter-inner:hover .thumb img {
  transform: rotateY(180deg);
}
.single-counter-inner.style-2 {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 30px;
  border-radius: 5px;
}
.single-counter-inner.style-2 p {
  margin-bottom: 0;
}

.single-contact-list {
  padding: 50px;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  transition: 0.4s;
  border-radius: 5px;
  margin-bottom: 30px;
  background: #fff;
  border: 1px solid rgba(66, 74, 97, 0.1);
}
.single-contact-list .media-left {
  margin-right: 15px;
}
.single-contact-list .media-body {
  margin-top: -2px;
}
.single-contact-list .media-body h5 {
  margin-bottom: 6px;
}
.single-contact-list .media-body h6 {
  margin-bottom: 0;
}
.single-contact-list:hover {
  box-shadow: 0px 10px 30px rgba(0, 33, 71, 0.08);
}

.client-slider .item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}
.client-slider .thumb {
  text-align: center;
  display: flex;
  align-items: center;
  align-self: center;
  padding: 0 50px;
}
.client-slider .thumb img {
  width: auto;
}
.client-slider .owl-nav {
  display: none;
}

.client-border-radius {
  border-radius: 15px 15px 0 0;
}

.single-testimonial-inner {
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  padding: 40px 30px;
  margin: 10px;
  background: #fff;
}
.single-testimonial-inner .designation {
  font-weight: 600;
}
.single-testimonial-inner .icon {
  display: inline-block;
}
.single-testimonial-inner.style-1 {
  margin-bottom: 120px;
  position: relative;
}
.single-testimonial-inner.style-1:after {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  transform: rotate(-45deg);
  background: #fff;
  bottom: -9px;
  left: 50%;
  margin-left: -10px;
}
.single-testimonial-inner.style-1 .thumb {
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  padding: 8px;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  position: absolute;
  bottom: -105px;
  left: 50%;
  transform: translateX(-50%);
}
.single-testimonial-inner.style-1 .thumb img {
  border-radius: 50%;
}
.single-testimonial-inner.style-2 .icon {
  border: 2px solid rgba(36, 107, 253, 0.1);
  height: 50px;
  width: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;
  padding: 5px;
  position: relative;
}
.single-testimonial-inner.style-2 .icon:after {
  content: "";
  position: absolute;
  left: 3px;
  top: 3px;
  background: var(--main-color);
  height: 40px;
  width: 40px;
  border-radius: 50%;
  z-index: 0;
}
.single-testimonial-inner.style-2 .icon img {
  position: relative;
  z-index: 2;
  color: #fff;
  width: auto;
  margin: 0 auto;
  padding-top: 9px;
  filter: brightness(10);
}
.single-testimonial-inner.style-2 .thumb img {
  width: auto;
  border: 1px solid var(--main-color);
  padding: 5px;
  border-radius: 50%;
}
.single-testimonial-inner.style-2 .ratting-inner {
  font-size: 15px;
}
.single-testimonial-inner.style-2 .ratting-inner svg {
  font-size: 13px;
}
.single-testimonial-inner.style-3 {
  padding: 0;
  box-shadow: none;
  background: transparent;
}
.single-testimonial-inner.style-3 img {
  width: auto;
}
.single-testimonial-inner.style-3 .thumb {
  position: relative;
  padding-right: 50px;
}
.single-testimonial-inner.style-3 .thumb .shadow-img {
  background: #fff;
  padding: 35px 20px;
  border-radius: 8px;
}
.single-testimonial-inner.style-3 .thumb .main-img {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 130px;
  border-radius: 8px;
}
.single-testimonial-inner.style-3 .details {
  position: relative;
  padding: 10px;
}
.single-testimonial-inner.style-3 .details .quote {
  position: absolute;
  left: 0;
  top: 0;
}
.single-testimonial-inner.style-3 .details .designation {
  font-weight: 400;
  font-size: 15px;
}
.single-testimonial-inner.style-3 .details h6 {
  color: var(--main-color);
}
.single-testimonial-inner.style-3 .details .ratting-inner {
  font-size: 10px;
  display: flex;
  gap: 3px;
  align-items: center;
}

.testimonial-slider-2 .owl-nav {
  display: none;
}

.slick-dots {
  bottom: -50px;
}

.slick-dots li button:before {
  font-size: 14px;
  color: var(--main-color);
}

.slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: var(--main-color);
}

.testimonial-tab {
  border: 0 !important;
}
.testimonial-tab button {
  border: 2px dashed transparent !important;
  padding: 0;
  height: 140px;
  width: 140px;
  border-radius: 50% !important;
  padding: 30px;
  transition: 0.4s;
}
.testimonial-tab button img {
  width: 100%;
  transition: 0.4s;
}
.testimonial-tab button.active {
  border: 2px dashed #50af9b !important;
  padding: 12px;
}

.faq-area-margin-top {
  margin-top: -120px;
}

.case-study-area .animate-img-1 {
  position: absolute;
  bottom: 130px;
  left: 90px;
  width: 50px;
}

.contact-inner-1 {
  margin-top: -120px;
  position: relative;
  z-index: 2;
}
.contact-inner-1 .animate-img-1 {
  position: absolute;
  left: -30px;
  bottom: -30px;
  z-index: -1;
}
.contact-inner-1 .animate-img-2 {
  position: absolute;
  right: -30px;
  bottom: -30px;
}
.contact-inner-1 .section-title {
  background: #fff;
  padding: 50px;
  margin-left: -190px;
  margin-top: 50px;
  border-radius: 5px;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
}
.contact-inner-1 .section-title .title {
  font-size: 35px;
}

.contact-page-list {
  margin-bottom: -110px;
  position: relative;
}

.contact-page-inner {
  padding: 100px;
  border-radius: 10px;
}

.contact-g-map {
  margin-bottom: -100px;
}
.contact-g-map iframe {
  width: 100%;
  height: 550px;
}

.career-wrap-area {
  background: #f8f9fc;
  border-radius: 5px;
}

.career-nav-tab {
  border-bottom: 1px solid #ebebeb !important;
}
.career-nav-tab button {
  border: 0 !important;
  border-right: 1px solid #ebebeb !important;
  background: transparent !important;
  width: 25%;
  font-weight: 600;
  color: var(--heading-color);
  padding: 15px 6px;
}
.career-nav-tab button:last-child {
  border-right: 0 !important;
}
.career-nav-tab button.active {
  color: var(--main-color) !important;
}

.career-wrap {
  padding: 60px;
}

.project-nav-tab {
  border-bottom: 0 !important;
  background: #f8f9fc;
  padding: 5px 15px;
  border-radius: 5px;
}
.project-nav-tab button {
  border: 0 !important;
  background: transparent !important;
  font-weight: 600;
  color: var(--heading-color);
  padding: 5px 15px;
}
.project-nav-tab button:last-child {
  border-right: 0 !important;
}
.project-nav-tab button.active {
  color: var(--main-color) !important;
}

.counter-4-area {
  position: relative;
}
.counter-4-area .counter-4-title {
  background: rgba(255, 255, 255, 0.1);
  display: inline-block;
  padding: 35px 40px;
  color: #fff;
  min-width: 200px;
}

.about-area-margin-bottom {
  position: relative;
  margin-bottom: -120px;
  z-index: 2;
}

/*----------------------------------------
  ## Search Popup
----------------------------------------*/
.td-search-popup.active .search-form {
  visibility: visible;
  opacity: 1;
  width: 40%;
  z-index: 9999;
}

.td-search-popup .search-form {
  width: 35%;
  position: absolute;
  position: fixed;
  top: 50%;
  left: 50%;
  transition: all 0.4s ease;
  visibility: hidden;
  opacity: 0;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.td-search-popup .search-form .form-group .form-control {
  border: none;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  height: 54px;
  padding: 0 75px 0 25px;
  background: #f7f9fb;
}

.td-search-popup .search-form .form-group .form-control:hover,
.td-search-popup .search-form .form-group .form-control:focus,
.td-search-popup .search-form .form-group .form-control:active {
  outline: 0;
  box-shadow: none;
}

.td-search-popup .search-form .submit-btn {
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 54px;
  border: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #ffffff;
  transition: all 0.4s ease;
  padding: 0;
  text-align: center;
  cursor: pointer;
  background: var(--main-color);
}

.td-search-popup .search-form .submit-btn:hover,
.td-search-popup .search-form .submit-btn:focus,
.td-search-popup .search-form .submit-btn:active {
  outline: 0;
  box-shadow: none;
}

.body-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  display: block;
  background: rgba(0, 0, 0, 0.95);
  z-index: 999;
  content: "";
  left: 0;
  top: 0;
  visibility: hidden;
  opacity: 0;
  transition: all 0.4s ease;
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), progress;
}

.body-overlay.active {
  visibility: visible;
  opacity: 0.97;
}

.mfp-zoom-in {
  /* animate in */
  /* animate out */
}

.mfp-zoom-in .mfp-content {
  opacity: 0;
  transition: all 0.4s ease;
  transform: scale(0.7);
}

.mfp-zoom-in.mfp-bg {
  opacity: 0;
  transition: all 0.4s ease;
}

.mfp-zoom-in.mfp-ready .mfp-content {
  opacity: 1;
  transform: scale(1);
}

.mfp-zoom-in.mfp-ready.mfp-bg {
  opacity: 0.7;
}

.mfp-zoom-in.mfp-removing .mfp-content {
  transform: scale(0.7);
  opacity: 0;
}

.mfp-zoom-in.mfp-removing.mfp-bg {
  opacity: 0;
}

/************ single-inpur-inner ************/
.single-input-inner {
  margin-bottom: 20px;
}
.single-input-inner input {
  width: 100%;
  height: 50px;
  border: 0 !important;
  padding: 0 18px;
  border-radius: 6px;
  font-weight: 300;
}
.single-input-inner input::placeholder {
  color: #adadad;
}
.single-input-inner textarea {
  width: 100%;
  border: 0 !important;
  height: 140px;
  border-radius: 6px;
  padding: 14px 18px;
  font-weight: 300;
}
.single-input-inner textarea::placeholder {
  color: #adadad;
}
.single-input-inner .single-select {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border: 0 !important;
  border-radius: 6px;
  padding: 0 18px;
  margin-bottom: 20px;
}
.single-input-inner .single-select .list {
  width: 100%;
}
.single-input-inner.style-border input {
  border: 1px solid rgba(234, 225, 214, 0.7) !important;
}
.single-input-inner.style-border input::placeholder {
  color: #adadad;
}
.single-input-inner.style-border textarea {
  border: 1px solid rgba(234, 225, 214, 0.7) !important;
  background: transparent;
}
.single-input-inner.style-border textarea::placeholder {
  color: #adadad;
}
.single-input-inner.style-border .single-select {
  border: 1px solid rgba(234, 225, 214, 0.7) !important;
  color: #adadad;
}
.single-input-inner.style-border-bottom input {
  border-bottom: 1px solid rgba(234, 225, 214, 0.7) !important;
  background: transparent;
  padding: 0;
}
.single-input-inner.style-border-bottom input::placeholder {
  color: #adadad;
}
.single-input-inner.style-border-bottom textarea {
  border-bottom: 1px solid rgba(234, 225, 214, 0.7) !important;
}
.single-input-inner.style-border-bottom textarea::placeholder {
  color: #adadad;
}
.single-input-inner.style-border-bottom .single-select {
  border-bottom: 1px solid rgba(234, 225, 214, 0.7) !important;
  background: transparent;
  color: #adadad;
}
.single-input-inner.style-bg input {
  background: #F7FAFC;
}
.single-input-inner.style-bg input::placeholder {
  color: #3F517E;
}
.single-input-inner.style-bg textarea {
  background: #F7FAFC;
}
.single-input-inner.style-bg textarea::placeholder {
  color: #3F517E;
}
.single-input-inner.style-bg .single-select {
  background: #F7FAFC;
  color: #3F517E;
}
.single-input-inner.style-bg-none input {
  background: transparent;
  color: #fff;
}
.single-input-inner.style-bg-none input::placeholder {
  color: #fff;
}
.single-input-inner.style-bg-none textarea {
  background: transparent;
  color: #fff;
}
.single-input-inner.style-bg-none textarea::placeholder {
  color: #fff;
}
.single-input-inner.style-bg-none .single-select {
  background: transparent;
  color: #fff;
}

.contact-form-inner {
  padding: 0 30px 30px;
  border-radius: 7px;
  overflow: hidden;
  background-size: cover;
}
.contact-form-inner .single-input-inner.style-border-bottom input {
  border-bottom: 1px solid #fff !important;
}
.contact-form-inner .single-input-inner.style-border-bottom input::placeholder {
  color: #fff;
}

.blog-comment-form textarea {
  background: #FBFBFB;
  border: 1px solid #FBFBFB;
}

/*---------------------------------------------------
	widget styles
----------------------------------------------------*/
.widget-title {
  position: relative;
  font-size: 20px;
}

.td-sidebar .widget {
  margin-bottom: 34px;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid #ededed;
}
.td-sidebar .widget .widget-title {
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 8px;
  color: var(--main-color);
}
.td-sidebar .widget .widget-title:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -5px;
  height: 3px;
  width: 100%;
  background: #e1e1e1;
}
.td-sidebar .widget .widget-title:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -5px;
  height: 3px;
  width: 60px;
  background: var(--main-color);
  z-index: 2;
}
.td-sidebar .widget.widget-recent-post ul li .media {
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  padding: 15px 20px;
  border-radius: 5px;
}

.footer-area .widget-title {
  color: #fff;
}

.td-sidebar-service .widget {
  margin-bottom: 34px;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
}
.td-sidebar-service .widget .widget-title:before {
  display: none;
}
.td-sidebar-service .widget .widget-title:after {
  border-bottom: 1px dashed var(--main-color);
  background: transparent;
  width: 156px;
}

.widget_search .search-form {
  position: relative;
  background: #f4f6f9;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e1e1e1;
}

.widget_search .search-form .form-group {
  margin-bottom: 0;
}

.widget_search .search-form input {
  width: 100%;
  border: 0;
  height: 55px;
  padding: 0 60px 0 22px;
}

.widget_search .search-form input:focus {
  border: 0;
  outline: 0;
}

.widget_search .search-form button {
  position: absolute;
  right: 0;
  border: 0;
  background: var(--main-color);
  cursor: pointer;
  padding: 0 22px;
  top: 0;
  height: 55px;
  color: #fff;
}

.widget_search .search-form button svg,
.widget_search .search-form button i {
  color: #fff;
}

.widget_search .search-form button:active,
.widget_search .search-form button:focus {
  box-shadow: none;
  outline: 0;
}

.widget-recent-post ul {
  list-style: none;
  padding-left: 0;
  margin-bottom: 9px;
  padding-bottom: 0;
}

.widget-recent-post ul li {
  margin-bottom: 15px;
}

.widget-recent-post ul li .media {
  align-items: center;
}

.widget-recent-post ul li .media .media-left {
  margin-right: 18px;
}

.widget-recent-post ul li .media .media-left img {
  border-radius: 4px;
}

.widget-recent-post ul li .media .media-body .title {
  margin-bottom: 8px;
}

.widget-recent-post ul li .media .media-body .post-info {
  font-size: 13px;
  color: var(--heading-color);
  display: flex;
  align-items: center;
}

.widget-recent-post ul li .media .media-body .post-info span {
  color: #3f517e;
}

.widget-recent-post ul li .media .media-body .post-info svg,
.widget-recent-post ul li .media .media-body .post-info i {
  margin-right: 8px;
  color: var(--main-color);
}

.widget-recent-post ul li:last-child {
  border-bottom: 0 !important;
  padding-bottom: 0;
  margin-bottom: 0;
}

.widget_catagory ul {
  padding-left: 0;
  padding-bottom: 0;
  margin-bottom: 0;
  margin-top: -5px;
}

.widget_catagory ul li {
  list-style: none;
  transition: 0.6s;
  padding-bottom: 10px;
}
.widget_catagory ul li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}

.widget_catagory ul li a {
  position: relative;
  padding: 10px 15px;
  background: #f8f9fc;
  display: block;
  padding-right: 60px;
  border-radius: 6px;
}
.widget_catagory ul li a span {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border: 1px solid rgba(66, 74, 97, 0.1);
  display: inline-block;
  padding: 10px 18px;
  right: 0;
  border-radius: 6px;
}

.widget_catagory ul li:last-child {
  margin-bottom: 0;
}

.widget_catagory_2 ul {
  padding: 0;
}
.widget_catagory_2 ul li {
  list-style: none;
}
.widget_catagory_2 ul li a {
  border: 1px solid #d1d1d1;
  display: block;
  margin-bottom: 20px;
  padding: 10px 15px;
  border-radius: 5px;
  font-weight: 600;
}
.widget_catagory_2 ul li a i {
  float: right;
  padding-top: 3px;
  font-size: 21px;
}
.widget_catagory_2 ul li a span i {
  float: left;
  margin-right: 10px;
  color: var(--main-color);
  background: #ffe6e2;
  padding: 5px 5px 2px 5px;
  border-radius: 3px;
}
.widget_catagory_2 ul li a:hover {
  background-image: linear-gradient(to right, #f99746, #ee0020);
  border: 1px solid var(--main-color);
  color: #fff;
}

.widget_tag_cloud .tagcloud a {
  background: #f4f6f9;
  height: 36px;
  line-height: 34px;
  padding: 0 18px;
  border-radius: 5px;
  display: inline-block;
  margin: 0 5px 9px 0;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #909090;
  border: 1px solid rgba(66, 74, 97, 0.1);
}
.widget_tag_cloud .tagcloud a i {
  float: right;
  padding-top: 5px;
}

.widget_tag_cloud .tagcloud a:hover {
  background: var(--main-color);
  color: #ffffff;
  border-color: var(--main-color);
}

/*********** widget_checkbox_list ************/
.widget_checkbox_list .single-checkbox:last-child {
  margin-bottom: 0;
  border-bottom: 0;
  padding-bottom: 0;
}

.single-checkbox {
  display: block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 7px;
  padding-bottom: 7px;
  cursor: pointer;
  font-size: 16px;
  color: var(--heading-color);
  -webkit-user-select: none;
  user-select: none;
  border-bottom: 1px solid #e3e3e3;
}
.single-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.single-checkbox input:checked ~ .checkmark {
  background-color: var(--main-color);
}
.single-checkbox input:checked ~ .checkmark:after {
  display: block;
}
.single-checkbox .checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eae1d6;
}
.single-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/******** widget-video-inner *********/
.widget-video-inner {
  border-radius: 5px;
}
.widget-video-inner .thumb {
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
}
.widget-video-inner .thumb:after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}
.widget-video-inner .thumb .video-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  line-height: 52px;
  z-index: 1;
}
.widget-video-inner .thumb .video-btn i {
  font-size: 18px;
}
.widget-video-inner .thumb .video-btn:after {
  width: 70px;
  height: 70px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.widget-video-inner .details {
  margin-top: 10px;
}
.widget-video-inner .details ul {
  padding: 0;
  margin: 0;
}
.widget-video-inner .details ul li {
  list-style: none;
  text-align: right;
  display: flex;
  align-items: baseline;
  border-bottom: 1px dashed #e3e3e3;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.widget-video-inner .details ul li:last-child {
  border-bottom: 0;
}
.widget-video-inner .details ul li i {
  color: var(--main-color);
  margin-right: 7px;
}
.widget-video-inner .details ul li span {
  margin-right: auto;
  font-weight: 500;
  color: var(--heading-color);
}

/******** widget-contact *********/
.widget_contact .details {
  padding: 0;
}
.widget_contact .details li {
  margin-bottom: 10px;
  position: relative;
  list-style: none;
}
.widget_contact .details li i {
  margin-right: 14px;
  color: var(--main-color);
}
.widget_contact .details li svg {
  margin-right: 14px;
  color: var(--main-color);
}
.widget_contact .details li svg.sky {
  color: #50af9b;
}
.widget_contact .details li:last-child {
  margin-bottom: 0;
}
.widget_contact .details li .time {
  font-size: 12px;
  margin-top: 3px;
}
.widget_contact .social-media li a {
  border: 1px solid var(--paragraph-color);
  background: transparent;
  line-height: 28px;
}
.widget_contact .social-media li a svg {
  margin-right: 0;
  transition: 0.4s;
}
.widget_contact .social-media li a:hover {
  background: var(--main-color);
  border: 1px solid var(--main-color);
}
.widget_contact .social-media li a:hover svg {
  color: #fff !important;
}
.widget_contact .social-media li a.sky:hover {
  background: #50af9b;
  border: 1px solid #50af9b;
}
.widget_contact .social-media li a.sky:hover svg {
  color: #fff !important;
}

.widget_instagram .instagram-wrap {
  margin: 0 10px;
}
.widget_instagram .instagram-wrap .thumb {
  margin-bottom: 10px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}
.widget_instagram .instagram-wrap .thumb img {
  transform: scale(1.05);
  transition: 0.9s;
}
.widget_instagram .instagram-wrap .thumb:after {
  content: "";
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  visibility: hidden;
  opacity: 0;
  transition: 0.4s;
}
.widget_instagram .instagram-wrap .thumb i {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 35px;
  width: 35px;
  line-height: 35px;
  text-align: center;
  background: rgba(253, 74, 54, 0.7);
  display: inline-block;
  z-index: 3;
  color: #fff;
  border-radius: 50%;
  visibility: hidden;
  opacity: 0;
  transition: 0.4s;
}
.widget_instagram .instagram-wrap .thumb:hover:after {
  visibility: visible;
  opacity: 1;
}
.widget_instagram .instagram-wrap .thumb:hover i {
  visibility: visible;
  opacity: 1;
}
.widget_instagram .instagram-wrap .thumb:hover img {
  transform: scale(1.1);
}

.widget_author {
  padding: 50px 30px !important;
}
.widget_author .thumb {
  margin-bottom: 20px;
}
.widget_author .thumb img {
  border-radius: 50%;
  max-width: 180px;
  max-height: 180px;
}
.widget_author .details h5 {
  margin-bottom: 15px;
}
.widget_author .details h6 {
  margin-bottom: 30px;
}
.widget_author .details .social-media li a {
  background: #f8f9fc;
  color: var(--main-color);
  height: 45px;
  width: 45px;
  line-height: 45px;
  font-size: 15px;
}
.widget_author .details .social-media li a:hover {
  background: var(--main-color);
  color: #fff;
}

.widget-info-inner h6 {
  margin-bottom: 4px;
}
.widget-info-inner p {
  margin-bottom: 15px;
}
.widget-info-inner p:last-child {
  margin-bottom: 0;
}

.service-sidebar .widget {
  background: #f8f9fc;
  border: 0;
}
.service-sidebar .widget .widget-title {
  padding-bottom: 0;
}
.service-sidebar .widget .widget-title svg {
  margin-top: 6px;
  float: left;
  margin-right: 10px;
  font-size: 15px;
}
.service-sidebar .widget .widget-title:before, .service-sidebar .widget .widget-title:after {
  display: none;
}
.service-sidebar .widget_catagory .catagory-items {
  border-top: 1px solid #e5e5e5;
}
.service-sidebar .widget_catagory .catagory-items li {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 0;
}
.service-sidebar .widget_author {
  padding: 0 !important;
  background: transparent;
}
.service-sidebar .widget_author .thumb img {
  border-radius: 5px;
  max-width: 100%;
  max-height: 100%;
}
.service-sidebar .widget_author .details {
  margin-top: -49px;
  padding: 0;
}
.service-sidebar .widget_download ul {
  padding: 8px 0;
  background: #fff;
  border-radius: 5px;
}
.service-sidebar .widget_download ul li {
  list-style: none;
}
.service-sidebar .widget_download ul li a {
  padding: 10px 18px;
  display: block;
}
.service-sidebar .widget_download ul li a svg {
  height: 30px;
  width: 30px;
  background: rgba(36, 107, 253, 0.1);
  color: var(--main-color);
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  padding: 8px;
  float: right;
  transition: 0.4s;
}
.service-sidebar .widget_download ul li a:hover svg {
  background: var(--main-color);
  color: #fff;
}

/*------------------------------------------------
    blog style
------------------------------------------------*/
.single-blog-inner {
  margin-bottom: 50px;
  overflow: hidden;
  transition: 0.4s;
}
.single-blog-inner .thumb {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  border-radius: 10px;
}
.single-blog-inner .thumb .date {
  height: 94px;
  width: 84px;
  background: var(--main-color);
  position: absolute;
  left: 20px;
  top: 20px;
  border-radius: 5px;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  padding: 15px;
  padding-top: 22px;
}
.single-blog-inner .thumb img {
  transform: scale(1.05);
  transition: 0.9s;
}
.single-blog-inner .blog-meta {
  margin: 0;
  padding: 0;
  margin-bottom: 15px;
}
.single-blog-inner .blog-meta li {
  display: inline-block;
  margin-right: 15px;
  color: #8a8a8a;
  font-size: 14px;
}
.single-blog-inner .blog-meta li i {
  margin-right: 4px;
  color: var(--main-color);
}
.single-blog-inner .blog-meta li svg {
  margin-right: 4px;
  color: var(--main-color);
}
.single-blog-inner .blog-meta li:last-child {
  margin-right: 0;
}
.single-blog-inner .details h2 {
  margin-bottom: 3px;
}
.single-blog-inner .details h2:hover a {
  color: var(--main-color);
}
.single-blog-inner .details .title {
  margin-bottom: 17px;
}
.single-blog-inner .details p {
  margin-bottom: 16px;
}
.single-blog-inner .details .read-more-text {
  font-weight: 600;
}
.single-blog-inner .portfolio-details {
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--main-color);
  border-radius: 0 30px 0 0;
  overflow: hidden;
}
.single-blog-inner .portfolio-details h5 {
  padding: 10px 30px;
  background: var(--heading-color);
  color: #fff;
}
.single-blog-inner .portfolio-details p {
  margin-bottom: 4px;
  color: #fff;
  border-bottom: 1px dashed #fff;
  padding: 5px 30px 7px 30px;
}
.single-blog-inner .portfolio-details p:last-child {
  border-bottom: 0;
}
.single-blog-inner .portfolio-details strong {
  min-width: 95px;
  display: inline-block;
  color: #fff;
}
.single-blog-inner:hover .thumb img {
  transform: scale(1.1);
}

.single-blog-list {
  border-radius: 6px;
  box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);
  margin-bottom: 30px;
  overflow: hidden;
  transition: 0.4s;
}
.single-blog-list .thumb {
  overflow: hidden;
  position: relative;
}
.single-blog-list .thumb img {
  transition: 0.7s;
}
.single-blog-list .thumb .date {
  position: absolute;
  right: 0;
  top: 25px;
  background: #fff;
  padding: 9px 18px;
  border-radius: 5px 0 0 5px;
  border-left: 3px solid var(--main-color);
  color: var(--heading-color);
  font-weight: 600;
}
.single-blog-list .details {
  padding: 25px 30px;
  position: relative;
}
.single-blog-list .details .cat {
  position: absolute;
  right: 0;
  top: -24px;
  background: var(--main-color);
  padding: 9px 18px;
  border-radius: 5px 0 0 5px;
  color: #fff;
}
.single-blog-list .details .blog-meta li {
  list-style: none;
  display: inline-block;
  margin-right: 12px;
  font-size: 12px;
}
.single-blog-list .details .blog-meta li svg {
  color: var(--main-color);
  margin-right: 4px;
}
.single-blog-list .details p {
  font-weight: 500;
}
.single-blog-list .details p i,
.single-blog-list .details p svg {
  margin-right: 10px;
}
.single-blog-list .details h5 {
  margin-bottom: 0;
}
.single-blog-list .details .meta {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #ededed;
}
.single-blog-list .details .meta p {
  margin-bottom: 0;
}
.single-blog-list:hover {
  box-shadow: 0px 10px 30px rgba(0, 33, 71, 0.08);
}
.single-blog-list:hover .thumb img {
  transform: scale(1.1);
}
.single-blog-list.style-2 .thumb img {
  border-radius: 5px;
}
.single-blog-list.style-2 .details .blog-meta {
  display: flex;
  align-items: center;
  background: #f8f9fc;
  padding: 10px;
  border-radius: 6px 0 0 6px;
  margin-right: -30px;
  margin-left: 50px;
  margin-top: -64px;
  z-index: 2;
  position: relative;
}
.single-blog-list.style-2 .details .blog-meta .date {
  height: 50px;
  width: 50px;
  border-radius: 5px;
  background: var(--main-color);
  color: #fff;
  text-align: center;
  padding: 8px;
  line-height: 1.4;
}
.single-blog-list.style-3 .thumb img {
  border-radius: 5px;
}
.single-blog-list.style-3 .details .blog-meta {
  display: flex;
  align-items: center;
  background: #50af9b;
  padding: 10px;
  border-radius: 6px;
  margin-right: 48px;
  margin-top: -54px;
  z-index: 2;
  position: relative;
}
.single-blog-list.style-3 .details .blog-meta li {
  color: #fff;
}
.single-blog-list.style-3 .details .blog-meta li svg {
  color: #fff;
}
.single-blog-list.style-3 .details .blog-meta li span {
  border-radius: 50%;
  border: 1px solid #fff;
  padding: 3px;
  display: inline-block;
  height: 30px;
  width: 30px;
  margin-right: 3px;
}
.single-blog-list.style-3 .details .blog-meta li span img {
  border-radius: 50%;
}
.single-blog-list.style-3 .details .blog-meta .date {
  height: 50px;
  width: 50px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  padding: 8px;
  line-height: 1.4;
}
.single-blog-list.style-3 .details .btn-wrap {
  position: relative;
}
.single-blog-list.style-3 .details .btn-wrap .read-more-text {
  background: #fff;
  z-index: 2;
  position: relative;
  padding-left: 5px;
}
.single-blog-list.style-3 .details .btn-wrap .read-more-text svg {
  background: #fff;
}
.single-blog-list.style-3 .details .btn-wrap:after {
  content: "";
  position: absolute;
  left: 0;
  top: 15px;
  height: 1px;
  width: 100%;
  background: #ccc;
  opacity: 1;
  visibility: visible;
}
.single-blog-list.style-3 .details .btn-wrap:hover .read-more-text {
  color: #50af9b;
}
.single-blog-list.style-3 .details .btn-wrap:hover .read-more-text::after {
  background: #50af9b;
}
.single-blog-list.style-3 .details .btn-wrap:hover::after {
  background: #50af9b;
}

/************ page navigation ************/
.pagination {
  display: inline-flex;
  margin: 10px 0 0 0;
}
.pagination .prev,
.pagination .next {
  transition: all 0.4s ease;
}
.pagination .page-numbers {
  height: 40px;
  width: 40px;
  margin-right: 8px;
  border: 0;
  border-radius: 5px;
  background: #f8f9fc;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
  transition: all 0.4s ease;
  display: block;
  color: var(--heading-color);
  font-size: 16px;
  font-weight: 700;
}
.pagination .page-numbers:active, .pagination .page-numbers:focus, .pagination .page-numbers:hover {
  background: var(--main-color);
  color: #fff;
}
.pagination .page-numbers.current {
  background: var(--main-color);
  color: #fff;
}

/******** blog-details-page-content ***********/
.blog-details-page-content .single-blog-inner {
  box-shadow: none !important;
  border-radius: 0;
  border-bottom: 0;
  padding-bottom: 0;
}
.blog-details-page-content blockquote {
  background: #fff;
  padding: 30px 40px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 30px;
  position: relative;
  border: 1px solid rgba(66, 74, 97, 0.1);
  text-align: center;
}
.blog-details-page-content blockquote p {
  margin-bottom: 0 !important;
  text-align: left;
}
.blog-details-page-content blockquote svg {
  height: 50px;
  width: 50px !important;
  line-height: 50px;
  padding: 15px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  color: #fff;
  background: var(--main-color);
  margin-bottom: 15px;
}
.blog-details-page-content blockquote .name {
  position: relative;
  padding-left: 40px;
  margin-top: 15px;
  text-align: left;
}
.blog-details-page-content blockquote .name:after {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 28px;
  height: 3px;
  background: var(--main-color);
}

/*********** tag-and-share ************/
.tag-and-share {
  margin-top: 20px;
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 0;
}
.tag-and-share .tags a {
  height: 30px;
  line-height: 29px;
  padding: 0 12px;
  background: #f2f5f6;
  display: inline-block;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #757575;
  transition: 0.4s;
  border: 1px solid rgba(66, 74, 97, 0.1);
}
.tag-and-share .tags a:hover {
  background: var(--main-color);
  color: #fff;
  border-color: var(--main-color);
}
.tag-and-share strong {
  color: var(--heading-color);
  margin-right: 6px;
  font-size: 20px;
}
.tag-and-share .blog-share ul {
  margin: 0;
  padding: 0;
  display: inline-block;
}
.tag-and-share .blog-share ul li {
  display: inline-block;
  list-style: none;
  margin-right: 10px;
  color: var(--heading-color);
}
.tag-and-share .blog-share ul li:last-child {
  margin-right: 0;
}

/****** prev-next-post ******/
.prev-next-post {
  padding: 20px;
  margin-top: 50px;
  border: 1px solid #ededed;
  border-radius: 5px;
}
.prev-next-post .btn {
  height: 50px;
  width: 50px;
  line-height: 50px;
  padding: 0;
  text-align: center;
  display: inline-block;
}
.prev-next-post .btn svg {
  font-size: 12px;
  margin-top: 0;
  margin-left: 0;
  float: initial;
}

.blog-comment-form {
  padding-top: 30px;
}
.blog-comment-form h3 {
  position: relative;
  margin-bottom: 32px;
}

.comment-content a {
  word-wrap: break-word;
}

.bypostauthor {
  display: block;
}

.blog-comment {
  position: relative;
  margin-top: 40px;
}

.blog-comment .comment-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.blog-comment .comment-list ul.children {
  margin: 0;
  list-style: none;
  padding-left: 65px;
}

.blog-comment .comment-box {
  position: relative;
  margin-bottom: 60px;
  padding-bottom: 60px;
  border-bottom: 1px solid var(--aivons-light, #f2f4f8);
}

.blog-comment .comment {
  position: relative;
  min-height: 90px;
}

.blog-comment .comment-box .author-thumb {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin-bottom: 20px;
  overflow: hidden;
}

.blog-comment .comment-box .author-thumb img {
  width: 90px;
  height: 90px;
  display: block;
  border-radius: 50%;
}

.blog-comment .comment-box .info {
  position: relative;
  margin-bottom: 25px;
  line-height: 24px;
}

.blog-comment .comment-box .info .name {
  position: relative;
  display: block;
  font-size: 24px;
  line-height: 30px;
  font-weight: 800;
  color: var(--aivons-black, #0f0d1d);
  text-transform: uppercase;
}

.blog-comment .comment-box .info .date {
  position: relative;
  display: inline-block;
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  color: var(--main-color);
}

.blog-comment .comment-box .text {
  position: relative;
  display: block;
  color: var(--aivons-gray, #726f84);
  font-weight: 300;
  line-height: 1.5em;
  letter-spacing: 0.1em;
  margin-bottom: 30px;
}

.blog-comment .comment-box .reply-btn {
  position: relative;
  display: block;
}

.blog-comment .comment-box .theme-btn .btn-title {
  padding: 6px 30px 4px;
  line-height: 30px;
}

.blog-comment .comment-body .says {
  display: none;
}

.blog-comment .comment-body {
  position: relative;
  padding-left: 100px;
  margin-bottom: 30px;
}

.blog-comment .pingback .comment-body,
.blog-comment .trackback .comment-body {
  padding-left: 0;
}

.blog-comment .comment-body .avatar {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  height: 85px;
  width: 85px;
}

.blog-comment .fn a,
.blog-comment .fn {
  position: relative;
  display: block;
  font-size: 18px;
  color: var(--heading-color);
  text-decoration: none;
  line-height: 1;
}

.blog-comment .comment-body .comment-metadata {
  margin-bottom: 13px;
}

.blog-comment .comment-body .comment-metadata a {
  position: relative;
  display: inline-block;
  font-size: 12px;
  text-decoration: none;
}

.blog-comment .comment-body .comment-metadata a:hover {
  color: var(--aivons-black, #0f0d1d);
}

.blog-comment .comment-body .comment-metadata .edit-link a::before {
  content: ".";
  margin-left: 8px;
  margin-right: 10px;
}

.blog-comment .comment-content p {
  position: relative;
  display: block;
  color: var(--aivons-gray, #726f84);
  font-weight: 300;
  line-height: 1.5em;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 2em;
  font-family: var(--aivons-font, "Jost", sans-serif);
  letter-spacing: 0;
  font-weight: 500;
}

.blog-comment .comment-content table a {
  color: var(--main-color);
  text-decoration: none;
}

.blog-comment .comment-content {
  font-weight: 500;
}

.blog-comment .comment-content table a {
  color: var(--aivons-black, #0f0d1d);
}

.blog-comment .comment-content table a:hover {
  color: var(--main-color);
}

.blog-comment .comment-content p:last-of-type {
  margin-bottom: 0;
}

.blog-comment .reply a {
  position: relative;
  background-color: var(--main-color);
  font-size: 12px;
  color: #fff;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  height: 30px;
  line-height: 30px;
  transition: all 500ms ease;
  margin-top: 40px;
  display: inline-block;
  vertical-align: middle;
  -webkit-appearance: none;
  border: none;
  outline: none !important;
  padding: 0 18px;
  border-radius: 30px;
  text-transform: capitalize;
}

.blog-admin {
  background: #f8f9fc;
  padding: 30px;
  border-radius: 5px;
}
.blog-admin p {
  margin-bottom: 0;
}

@media (min-width: 992px) {
  .blog-comment .reply a {
    margin-top: 0;
    position: absolute;
    top: 0;
    right: 0;
  }
}
.blog-comment .reply a:hover {
  background-color: var(--aivons-black, #0f0d1d);
  color: #ffffff;
}

.blog-comment .blog-pagination a,
.blog-comment .blog-pagination span {
  margin-bottom: 45px;
}

.comment-respond .blog-details__content-title {
  margin-bottom: 50px;
}

.reply-form .logged-in-as {
  display: flex;
  color: var(--main-color);
  margin-left: -10px;
  margin-top: -40px;
  margin-bottom: 20px;
}

.reply-form .logged-in-as a {
  text-decoration: none;
  margin-left: 10px;
  margin-right: 10px;
}

.comment-form__title small {
  font-size: 20px;
}

.comment-form__title small a {
  text-decoration: none;
  color: var(--main-color);
  text-decoration: underline;
}

.comment-form__title small a:hover {
  color: var(--aivons-black, #0f0d1d);
  opacity: 0.5;
}

.comment-list .comment-respond {
  margin-bottom: 30px;
}

.reply-form .form-submit {
  margin-bottom: 0;
}

.comment-list .reply-form .form-submit {
  margin-bottom: 30px;
}

.single-project-inner {
  position: relative;
  border-radius: 10px;
  margin-bottom: 25px;
}
.single-project-inner .details {
  position: absolute;
  left: 50%;
  top: 55%;
  text-align: center;
  transform: translate(-50%, -50%);
  z-index: 2;
  color: var(--main-color);
  visibility: hidden;
  opacity: 0;
  transition: 0.4s;
}
.single-project-inner .details span {
  display: block;
  margin-bottom: 10px;
}
.single-project-inner .details a {
  color: var(--main-color);
}
.single-project-inner:after {
  content: "";
  position: absolute;
  left: 20px;
  right: 20px;
  top: 20px;
  bottom: 20px;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1;
  border-radius: 50px;
  visibility: hidden;
  opacity: 0;
  transition: 0.4s;
}
.single-project-inner:hover .details {
  top: 50%;
  visibility: visible;
  opacity: 1;
}
.single-project-inner:hover:after {
  visibility: visible;
  opacity: 1;
  border-radius: 10px;
}

/*--------------------------------------------------
    ##Footer style
---------------------------------------------------*/
.footer-area {
  position: relative;
  margin-top: 90px;
}
.footer-area:after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: var(--heading-color);
  z-index: -1;
}
.footer-area .widget {
  position: relative;
  z-index: 2;
  margin-bottom: 70px;
}
.footer-area .widget-title {
  margin-bottom: 30px;
  position: relative;
}
.footer-area .widget_about .thumb {
  margin-bottom: 20px;
  color: var(--main-color);
}
.footer-area .widget_about .thumb img {
  max-width: 150px;
}
.footer-area .widget_about .details p {
  margin-bottom: 0;
  color: #fff;
}
.footer-area .widget_about .details p svg {
  color: var(--main-color);
  margin-right: 10px;
}
.footer-area .widget_about .details p + p {
  font-weight: 500;
}
.footer-area .widget_about .details .social-media {
  margin-top: 26px;
}
.footer-area .widget_about .details .social-media li a:hover {
  background: var(--main-color);
  color: #fff;
}
.footer-area .widget_about .subscribe {
  position: relative;
}
.footer-area .widget_about .subscribe input {
  width: 100%;
  height: 44px;
  padding: 0 50px 0 15px;
  border-radius: 5px;
  border: 1px solid #e3e3e3;
  box-shadow: none;
  outline: 0;
}
.footer-area .widget_about .subscribe button {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 5px 5px 0;
  height: 44px;
  width: 40px;
  border: 0;
  background: var(--main-color);
  color: #fff;
  font-size: 15px;
  transition: 0.4s;
}
.footer-area .widget_about .subscribe button:hover {
  background: var(--heading-color);
}
.footer-area .widget_nav_menu ul {
  margin: 0;
  padding: 0;
}
.footer-area .widget_nav_menu ul li {
  list-style: none;
  margin-bottom: 7px;
  position: relative;
  color: #fff;
  position: relative;
}
.footer-area .widget_nav_menu ul li svg {
  margin-right: 8px;
  color: #333f4d;
  transition: 0.4s;
}
.footer-area .widget_nav_menu ul li:hover svg {
  color: var(--main-color);
}
.footer-area .widget_nav_menu ul li.sky:hover svg {
  color: #50af9b;
}
.footer-area .widget_nav_menu ul li.sky:hover a {
  color: #50af9b;
}
.footer-area .widget_subscribe .single-input-inner {
  position: relative;
}
.footer-area .widget_subscribe .single-input-inner input {
  padding-right: 40px;
}
.footer-area .widget_subscribe button {
  padding: 0;
  border: 0;
  position: absolute;
  right: 15px;
  top: 10px;
  background: transparent;
  color: var(--main-color);
}
.footer-area .widget_subscribe label {
  color: #fff;
  position: relative;
  padding-left: 22px;
}
.footer-area .widget_subscribe label input {
  position: absolute;
  left: 0;
  top: 7px;
}
.footer-area .widget-recent-post ul li .media .media-body .title {
  color: #fff;
}
.footer-area .widget-recent-post ul li .media .media-body .title.sky a:hover {
  color: #50af9b;
}
.footer-area .widget-recent-post ul li .media .media-body .post-info span {
  color: #fff;
}
.footer-area .widget-recent-post ul li .media .media-body .post-info .sky {
  color: #50af9b;
}

.footer-top {
  padding-top: 55px;
  padding-bottom: 90px;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 23px 0;
  position: relative;
  z-index: 2;
}
.footer-bottom p {
  margin-bottom: 0;
  color: #fff;
}
.footer-bottom a {
  margin-right: 10px;
  color: #fff;
}
.footer-bottom a:last-child {
  margin-right: 0;
}

.footer-subscribe {
  transform: translateY(-90px);
}
.footer-subscribe .footer-subscribe-inner {
  border-radius: 10px;
  padding: 40px;
  position: relative;
}
.footer-subscribe .footer-subscribe-inner h2 {
  color: #fff;
}
.footer-subscribe .footer-subscribe-inner input {
  height: 55px;
  padding: 0 150px 0 20px;
  color: var(--heading-color);
  width: 100%;
  border: 0;
}
.footer-subscribe .footer-subscribe-inner .btn {
  position: absolute;
  right: 30px;
}
.footer-subscribe .footer-subscribe-inner.style-2 {
  display: flex;
  text-align: center;
  margin-top: -90px;
  border-radius: 0;
}
.footer-subscribe .footer-subscribe-inner.style-2 .media {
  width: 340px;
  padding: 30px;
}
.footer-subscribe .footer-subscribe-inner.style-2 p {
  font-size: 13px;
}
.footer-subscribe .footer-subscribe-inner.style-2 input {
  padding: 0 18px;
}
.footer-subscribe .footer-subscribe-inner.style-2 .btn {
  position: relative;
  right: auto;
}
.footer-subscribe .footer-subscribe-inner.style-2 .row {
  padding: 20px 30px;
}

.footer-area-2 .widget-title {
  color: var(--heading-color) !important;
}
.footer-area-2 p {
  color: var(--heading-color) !important;
}
.footer-area-2 a {
  color: var(--paragraph-color) !important;
}
.footer-area-2 a svg {
  color: var(--paragraph-color) !important;
}
.footer-area-2 a:hover {
  color: var(--main-color) !important;
}
.footer-area-2 .widget_about {
  background: #fff;
  padding: 25px;
}
.footer-area-2 .footer-bottom {
  border-top: 1px solid #e3e3e3;
}

/*--------------------------------------------------
    ## All responsive style
---------------------------------------------------*/
@media all and (min-width: 1600px) {
  .container {
    max-width: 1280px;
  }
  .back-to-top {
    right: 70px;
    bottom: 50px;
  }
  .position-bottom-left {
    position: absolute;
    left: 90px;
    bottom: 180px;
  }
  .case-study-area .animate-img-1 {
    bottom: 53px;
    left: 282px;
  }
  .contact-g-map iframe {
    height: 650px;
  }
  .banner-thumb-2 .main-img-wrap .banner-animate-img-2 {
    right: 0;
  }
  .contact-inner-1 .section-title {
    margin-top: 106px;
  }
  .banner-area-2 .bg-img-2 {
    right: 0px;
    top: -72px;
    width: 796px;
  }
  .contact-inner-2 .section-title {
    margin-top: 134px;
  }
  .banner-area-3 .bg-gray {
    padding: 240px 0;
  }
  .single-service-inner-3.single-service-inner-3-left {
    padding: 43px 70px 43px 40px;
  }
  .single-service-inner-3.single-service-inner-3-right {
    padding: 43px 40px 43px 70px;
  }
}
@media all and (max-width: 1599px) {
  .banner-area-1 .animate-img-1 {
    position: absolute;
    left: 30px;
    bottom: 70px;
    width: 40px;
  }
  .banner-area-1 .animate-img-2 {
    position: absolute;
    left: 50px;
    bottom: 50px;
    width: 60px;
  }
  .banner-thumb .banner-animate-img-1 {
    width: 40px;
    left: -100px;
  }
}
@media all and (max-width: 1199px) {
  .single-blog-inner .details h2 {
    font-size: 35px;
  }
  .single-work-process-inner-3 {
    padding: 20px;
  }
  .single-service-inner {
    padding: 30px 25px;
  }
  .single-case-study-inner .details {
    margin-left: 25px;
  }
  .single-pricing-inner {
    padding: 25px;
  }
  .single-blog-list .details p {
    font-size: 15px;
  }
  .single-blog-list .details .meta p {
    font-size: 14px;
  }
  .single-list-inner li {
    font-size: 15px;
  }
  .single-service-inner-2 .details {
    padding: 20px;
    margin-left: 30px;
  }
  .contact-inner-1 .section-title {
    padding: 30px;
  }
  .accordion-inner .accordion-item .accordion-button {
    font-size: 17px;
  }
  .single-testimonial-inner {
    padding: 30px 20px;
  }
  .single-blog-list.style-2 .details .blog-meta {
    margin-left: 12px;
  }
  .single-pricing-inner ul li {
    font-size: 15px;
  }
  .single-testimonial-inner.style-2 .ratting-inner {
    font-size: 13px;
  }
  .single-testimonial-inner.style-2 .ratting-inner svg {
    font-size: 11px;
  }
  .contact-page-inner {
    padding: 50px;
  }
  .banner-area-3 .bg-gray {
    padding: 80px 0;
  }
  .banner-area-3 {
    padding: 0;
  }
}
@media all and (max-width: 991px) {
  .navbar {
    padding: 14px 0;
  }
  .td-sidebar {
    margin-top: 100px;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav {
    padding-left: 0;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children {
    padding-right: 0;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:after {
    top: 26px;
  }
  .navbar-area .nav-container .navbar-collapse {
    padding: 13px;
    padding-left: 0;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav {
    margin: 0;
  }
  .navbar-area:after {
    display: none;
  }
  .navbar-area .nav-container .navbar-collapse .navbar-nav li a {
    font-size: 16px;
  }
  .navbar-area .nav-container.navbar-bg {
    padding-left: 15px;
  }
  .navbar-area {
    margin-top: 0;
  }
  .banner-area-1 {
    padding-top: 200px;
  }
  .toggle-btn {
    top: 0;
  }
  .contact-inner-1 .section-title {
    padding: 30px;
    margin-left: 0;
    margin-top: 30px;
  }
  .footer-bottom p,
  .footer-bottom a {
    font-size: 15px;
  }
  .footer-subscribe .footer-subscribe-inner h2 {
    font-size: 30px;
  }
  .single-work-process-inner-2 {
    margin-top: 0;
  }
  .slider-control-right-top .owl-nav {
    display: none;
  }
  .service-sidebar .widget_author .thumb img {
    width: 100%;
  }
  .service-sidebar {
    margin-top: 0;
  }
  .td-sidebar .widget.widget_author .social-media {
    text-align: center !important;
  }
  .single-project-inner .details span {
    margin-bottom: 0px;
  }
  .single-project-inner .details a {
    font-size: 13px;
  }
  .single-project-inner:after {
    top: 15px;
    bottom: 15px;
    left: 15px;
    right: 15px;
  }
  .career-wrap {
    padding: 30px;
  }
  .banner-area-3 .bg-gray {
    padding: 80px 0;
  }
  .single-service-inner-3 {
    margin-right: 40px;
    padding: 25px 60px 25px 25px !important;
  }
  .single-service-inner-3.single-service-inner-3-right .thumb {
    left: auto;
    right: -40px;
  }
  .footer-subscribe .footer-subscribe-inner.style-2 .border-1 {
    margin: 5px 0;
  }
}
@media all and (max-width: 767px) {
  .breadcrumb-area .page-title {
    font-size: 50px;
  }
  .banner-area-3 .img-right {
    display: none;
  }
}
@media all and (max-width: 575px) {
  .back-to-top {
    right: 15px;
    bottom: 20px;
  }
  .navbar-top .topbar-right li {
    margin-bottom: 4px;
  }
  .breadcrumb-area .page-title {
    font-size: 30px;
  }
  .breadcrumb-area .page-list li {
    font-size: 15px;
  }
  .single-blog-inner .details h2 {
    font-size: 24px;
  }
  .td-page-navigation .pagination li a {
    height: 45px;
    width: 45px;
    line-height: 45px;
    font-size: 16px;
  }
  .blog-details-page-content blockquote {
    padding: 30px 20px;
  }
  .blog-comment .comment-body {
    padding-left: 0;
    margin-bottom: 40px;
  }
  .blog-comment .comment-body .avatar {
    position: relative;
    margin-bottom: 18px;
  }
  .blog-comment .comment-body .comment-metadata {
    margin-bottom: 6px;
  }
  .blog-comment .reply a {
    margin-top: 12px;
  }
  .td-sidebar .widget {
    padding: 25px;
  }
  .banner-inner .title {
    font-size: 40px;
  }
  .banner-inner .subtitle {
    font-size: 13px;
  }
  .section-title .title {
    font-size: 32px;
  }
  .about-thumb-inner .animate-img-bottom-right {
    position: absolute;
    right: 0;
    bottom: 30px;
    width: 200px;
  }
  .accordion-inner .accordion-item .accordion-button {
    font-size: 16px;
  }
  .accordion-inner.accordion-icon-left .accordion-item .accordion-button {
    padding-left: 42px;
  }
  .footer-subscribe .footer-subscribe-inner h2 {
    font-size: 24px;
  }
  .td-search-popup.active .search-form {
    width: 90%;
  }
  .navbar {
    padding: 14px 10px;
  }
  .banner-thumb-3 .banner-animate-img {
    width: 60px;
  }
  .banner-thumb-3 .banner-animate-img-1 {
    left: -8px;
  }
  .contact-inner-1 .section-title .title {
    font-size: 32px;
  }
  .footer-subscribe .footer-subscribe-inner input {
    padding: 0 20px;
    width: 100%;
  }
  .footer-subscribe .footer-subscribe-inner .btn {
    margin-top: 10px;
    width: 100%;
    position: relative;
    right: 0;
  }
  .footer-subscribe .footer-subscribe-inner {
    padding: 25px;
  }
  .contact-page-inner {
    padding: 30px;
  }
  .single-contact-list {
    padding: 25px;
  }
  .widget_author {
    padding: 30px 20px !important;
  }
  .single-blog-inner .thumb .date {
    height: 68px;
    width: 65px;
    font-size: 16px;
    padding-top: 15px;
  }
  .blog-comment .reply a {
    margin-top: 12px;
  }
  .blog-comment .comment-body .comment-metadata {
    margin-bottom: 5px;
  }
  .blog-admin {
    display: block;
    padding: 20px;
  }
  .blog-admin .media-left {
    margin-bottom: 20px;
  }
  .blog-comment .comment-list .comment-author a {
    display: block;
  }
  .banner-area-3 .img-right {
    display: none;
  }
  .career-wrap {
    padding: 30px;
  }
  .career-nav-tab button {
    width: 50%;
  }
  .career-nav-tab button:nth-child(2) {
    border-right: 0 !important;
  }
  .single-project-inner img {
    width: 100%;
  }
  .single-testimonial-inner.style-3 .thumb {
    margin-bottom: 20px;
  }
  .single-testimonial-inner.style-3 .thumb .shadow-img {
    width: 180px;
  }
  .single-testimonial-inner.style-3 .thumb .main-img {
    right: auto;
    left: 130px;
  }
}
@media all and (max-width: 360px) {
  .contact-inner-1 .section-title .title,
  .section-title .title {
    font-size: 30px;
  }
  .single-case-study-inner .details {
    padding: 18px 60px 18px 18px;
  }
  .single-case-study-inner .details .right-arrow {
    right: 15px;
  }
}
@media all and (min-width: 1300px) {
  .custom-container {
    max-width: 1250px;
  }
}
@media all and (min-width: 2000px) {
  .contact-inner-2 {
    max-width: 1920px;
    margin: 0 auto;
  }
}
@media all and (min-width: 1800px) {
  .custom-container {
    max-width: 1720px;
  }
}
@font-face {
  font-family: yekanBakh;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
* {
  font-family: yekanBakh !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/react-modal-video/scss/modal-video.scss","webpack://./src/index.scss","webpack://./public/assets/scss/style.scss","webpack://./public/assets/scss/global/_variables.scss","webpack://./public/assets/scss/global/_global.scss","webpack://./public/assets/scss/global/_common.scss","webpack://./public/assets/scss/global/_mixins.scss","webpack://./public/assets/scss/global/_animate.scss","webpack://./public/assets/scss/sections/_section-title.scss","webpack://./public/assets/scss/sections/_navbar.scss","webpack://./public/assets/scss/sections/_banner.scss","webpack://./public/assets/scss/sections/_about.scss","webpack://./public/assets/scss/sections/_service.scss","webpack://./public/assets/scss/sections/_work-process.scss","webpack://./public/assets/scss/sections/_team.scss","webpack://./public/assets/scss/sections/_pricing.scss","webpack://./public/assets/scss/sections/_case-study.scss","webpack://./public/assets/scss/sections/_content.scss","webpack://./public/assets/scss/sections/_testimonial.scss","webpack://./public/assets/scss/sections/_section-style.scss","webpack://./public/assets/scss/sections/_search.scss","webpack://./public/assets/scss/sections/_widgets.scss","webpack://./public/assets/scss/sections/_blog.scss","webpack://./public/assets/scss/sections/_project.scss","webpack://./public/assets/scss/sections/_footer.scss","webpack://./public/assets/scss/sections/_responsive.scss"],"names":[],"mappings":"AAIA;EACC;IACC,UAAA;ECEA;EDCD;IACC,UAAA;ECCA;AACF;ADEA;EACC;IACC,8BAAA;ECAA;EDGD;IACC,0BAAA;ECDA;AACF;ADIA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCA5BgB;EA6BhB,gBAAA;EACA,eAAA;EACA,UAAA;EACA,mCAjCoB;EAkCpB,wBAnCiB;EAoCjB,2BAAA;EAKA,iCAAA;ACFD;;ADKA;EACC,UAAA;ACFD;ADIC;EAKC,8BAAA;ACFF;;ADMA;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACG,aAAA;EACA,uBAAA;EACH,sBAAA;ACHD;;ADMA;EACC,aAAA;EACG,uBAAA;EACA,mBAAA;EACH,WAAA;EACA,YAAA;ACHD;ADKI;EAPJ;IAQQ,kBAAA;IACA,sBAAA;ECFN;AACF;;ADKA;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCArFoB;EAsFpB,wBAvFiB;EAwFjB,iCAAA;EAKA,0BAAA;EAKA,mCAAA;ACFD;ADIC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ACFF;;ADMA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;ACHD;ADKI;EAZJ;IAaQ,MAAA;IACA,YAAA;ECFN;AACF;ADIC;EACC,wBAAA;ACFF;ADKC;EACC,yBAAA;ACHF;ADMC;EAEC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;ACLF;;AC5IA;;;;;;;CAAA;AAQA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;+DAAA;ACGA;;kBAAA;ACXA;EACI,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,4CAAA;EACA,+CAAA;EACA,sBAAA;EACA,oBAAA;AH2LJ;;AGxLA;EACI,8BAAA;EACA,0BAAA;EACA,kBAAA;EACA,6BAAA;AH2LJ;;AGxLA;EAEI,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,YAAA;EACA,mCAAA;EACA,YAAA;AH2LJ;;AGxLA;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AH2LJ;;AGxLA;EACI,eAAA;EACA,yBAAA;AH2LJ;;AGxLA;EACI,eAAA;EACA,yBAAA;AH2LJ;;AGxLA;EACI,eAAA;EACA,yBAAA;AH2LJ;;AGxLA;EACI,eAAA;EACA,yBAAA;AH2LJ;;AGzLA;EACI,eAAA;EACA,yBAAA;AH4LJ;;AG1LA;EACI,eAAA;EACA,yBAAA;AH6LJ;;AG3LA;;;;;;EAMI,2BAAA;EACA,gBAAA;EACA,gCAAA;AH8LJ;;AG3LA;EACI,6BAAA;EACA,qBAAA;EAGA,aAAA;EACA,mBAAA;AH8LJ;;AG3LA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;AH8LJ;;AG3LA;;;;EAII,qBAAA;EACA,aAAA;EACA,cAAA;AH8LJ;;AG5LA;EACI,wBAAA;AH+LJ;;AG7LA;EACI,sBAAA;AHgMJ;;AG7LA;EACI,cAAA;AHgMJ;;AG7LA;EACI,eAAA;AHgMJ;;AG7LA;;;EAGI,UAAA;AHgMJ;;AG7LA,8CAAA;AAEA;;;;;;;;;;;;EAYI,aAAA;EAEA,gBAAA;EACA,sBAAA;AH+LJ;;AG5LA;;;EAGE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AH+LF;;AG5LA;EACE,eAAA;EACA,gBAAA;AH+LF;;AG7LA;EACI,eAAA;EACA,gBAAA;AHgMJ;;AG7LA;EACI,aAAA;AHgMJ;;AG7LA;EACI,cAAA;AHgMJ;;AG7LA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;AHgMJ;AG/LI;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AHiMR;AGhMQ;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,0BAAA;EACA,gBAAA;EACA,wBAAA;AHkMZ;;AG7LA;;;EAGI,WAAA;AHgMJ;;AG7LA;;;EAGI,WAAA;EACA,UAAA;AHgMJ;;AG7LA;;;EAGI,YAAA;EACA,iBAAA;EACA,UAAA;AHgMJ;;AG7LA;;;;;;EAMI,wBAAA;AHgMJ;;AG7LA;;;;;;EAMI,wBAAA;AHgMJ;;AG7LA;EACI,gBAAA;AHgMJ;;AG7LA;EACI,aAAA;AHgMJ;;AG7LA;EACI,kBAAA;AHgMJ;;AG7LA;;+DAAA;AAKA,wCAAA;AAEA;EACI,SAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;EACA,4BAAA;EACA,qGAAA;AH6LJ;;AG1LA;EACI,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AH6LJ;;AGzLA,qDAAA;AAEA;EACI,UAAA;AH2LJ;;AGxLA;;+DAAA;AAIA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AH0LJ;;AGvLA;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AH0LJ;;AGvLA;EACI,WAAA;EACA,cAAA;EACA,qBAAA;AH0LJ;;AGvLA;EACI,eAAA;EACA,eAAA;AH0LJ;;AGvLA;EACI,iBAAA;AH0LJ;;AGtLA;;+DAAA;AAIA;;;;;;;;;;;;EAYI,WAAA;EACA,cAAA;EACA,mBAAA;AHwLJ;;AGrLA;;;;;;EAMI,WAAA;AHwLJ;;AGpLA;;+DAAA;AAIA;EACI,cAAA;AHsLJ;;AGnLA;EACI,aAAA;AHsLJ;;AGnLA;;+DAAA;AAIA;;;EAGI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AHqLJ;;AGjLA,uDAAA;AAEA;;;EAGI,eAAA;AHmLJ;;AG/KA,iDAAA;AAEA;EACI,qBAAA;AHiLJ;;AG7KA;;+DAAA;AAIA;EACI,oBAAA;EACA,eAAA;EACA,WAAA;AH+KJ;;AG5KA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AH+KJ;;AG5KA;EACI,kBAAA;AH+KJ;;AG5KA;EACI,kBAAA;AH+KJ;;AG5KA;;2CAAA;AAIA;EACI,aAAA;EACA,wBAAA;AH8KJ;;AG3KA;EACI,mBAAA;EACA,gBAAA;AH8KJ;;AG3KA;;EAEI,yBAAA;EACA,iBAAA;EACA,qBAAA;AH8KJ;;AG3KA;;EAEI,mCAAA;EACA,WAAA;EACA,+BAAA;AH8KJ;;AG3KA;EACI,iBAAA;AH8KJ;;AG3KA;;;EAGI,kBAAA;AH8KJ;;AG3KA;EACI,cAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AH8KJ;;AG3KA;EACI,gBAAA;EACA,WAAA;AH8KJ;;AG3KA;EACI,YAAA;EACA,YAAA;EACA,mCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AH8KJ;;AG3KA;EACI,yBAAA;AH8KJ;;AG3KA;;EAEI,0BAAA;AH8KJ;;AG3KA;EAGI,aAAA;EAGA,uBAAA;AH8KJ;;AG5KA;EAGI,SAAA;AH+KJ;;AG5KA;;EAEI,kBAAA;EACA,iBAAA;AH+KJ;;AG5KA;EACI;;IAEI,gBAAA;IACA,eAAA;EH+KN;AACF;AIlrBA;;wCAAA;AAGA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;ECkIE,yBAAA;EDhIF,gBAAA;EACA,mBAAA;EACA,UAAA;AJsrBF;AIrrBE;EAEE,UAAA;EACA,gBAAA;AJsrBJ;AIprBE;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,4BFPS;EEQT,WAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,QAAA;AJsrBJ;AInrBI;EACE,YAAA;EACA,WAAA;AJqrBN;AIlrBE;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AJorBJ;AIlrBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AJorBJ;AIlrBE;EACE,gBAAA;AJorBJ;AIlrBE;EACE,kBAAA;AJorBJ;;AIjrBA;EACE,YAAA;EACA,iBAAA;AJorBF;AInrBE;EACE,iBAAA;AJqrBJ;;AIlrBA;EACE,WAAA;EACA,6BAAA;AJqrBF;AIprBE;EACE,WAAA;AJsrBJ;;AInrBA;EACE,WAAA;EACA,mBAAA;AJsrBF;AIrrBE;EACE,WAAA;AJurBJ;;AIprBA;EACE,mCAAA;EACA,gBAAA;AJurBF;AItrBE;EAEE,sBAAA;EACA,6BAAA;AJurBJ;;AIprBA;EACE,sBAAA;EACA,gCAAA;AJurBF;AItrBE;EAEE,sBAAA;EACA,6BAAA;AJurBJ;;AIprBA;EACE,sBAAA;EACA,gCAAA;AJurBF;AItrBE;EAEE,sBAAA;EACA,mBAAA;AJurBJ;;AIprBA;EACE,2BAAA;EACA,mCAAA;EACA,iBAAA;AJurBF;AItrBE;EACE,6BAAA;AJwrBJ;AItrBE;EAEE,WAAA;AJurBJ;;AIprBA;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;AJurBF;AItrBE;EACE,mBAAA;AJwrBJ;AItrBE;EAEE,WAAA;AJurBJ;;AIprBA;EACE,WAAA;EACA,0CAAA;EACA,iBAAA;AJurBF;AItrBE;EAEE,WAAA;EACA,6BAAA;EACA,mCAAA;AJurBJ;;AIprBA;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;AJurBF;AItrBE;EAEE,WAAA;EACA,6BAAA;EACA,mCAAA;AJurBJ;AIrrBE;EACE,6BAAA;AJurBJ;;AIprBA;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;AJurBF;AItrBE;EAEE,WAAA;EACA,6BAAA;EACA,mCAAA;AJurBJ;AIrrBE;EACE,6BAAA;AJurBJ;;AIprBA;EACE,2BAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AJurBF;AItrBE;EAEE,WAAA;EACA,6BAAA;EACA,sCAAA;AJurBJ;;AInrBA;EACE,sBAAA;EACA,mBAAA;AJsrBF;;AInrBA;EACE,kBAAA;EACA,2BAAA;EACA,gBAAA;AJsrBF;AIrrBE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AJurBJ;AIrrBE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AJurBJ;AIrrBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AJurBJ;AIprBI;EACE,iBAAA;AJsrBN;AIprBI;EACE,WAAA;EACA,mBAAA;EACA,UAAA;AJsrBN;;AIjrBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;AJorBF;AInrBE;EACE,mBAAA;EACA,WAAA;AJqrBJ;;AIjrBA;;iDAAA;AAGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WF5Pa;EE6Pb,mCAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;EACA,aAAA;EACA,oDAAA;AJorBF;AInqBA;EACE;IAEE,2BAAA;EJorBF;EIlrBA;IAEE,2BAAA;EJorBF;EIlrBA;IAEE,2BAAA;EJorBF;AACF;AIjrBA;;4CAAA;AAGA;EACE,eAAA;EACA,WAAA;EACA,kCAAA;EACA,eAAA;AJmrBF;;AIjrBA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJorBF;AInrBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AJqrBJ;AIprBI;EACE,sBF9TS;EE+TT,gBAAA;EACA,0BAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EC7LF,yBAAA;ALs3BJ;AIvrBM;EACE,sCAAA;EACA,WF3UO;AFogCf;;AIprBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAGA,uCAAA;AJsrBF;;AInrBA;;EAEE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,mCAAA;EACA,mBAAA;EAEA,4CAAA;AJsrBF;;AInrBA;EACE,SAAA;EACA,SAAA;EAEA,oBAAA;AJsrBF;AI9qBA;EACE;IACE,yBAAA;IACA,iCAAA;EJsrBF;AACF;AIzqBA;EACE;IAEE,mBAAA;IACA,2BAAA;EJkrBF;EIhrBA;IACE,mBAAA;IACA,2BAAA;EJkrBF;AACF;AI/qBA;;2CAAA;AAGA;EACE,kBAAA;AJirBF;AIhrBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AJkrBJ;;AI/qBA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,6CAAA;EACA,UAAA;EACA,4CAAA;AJkrBF;AIjrBE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,UAAA;EACA,WAAA;AJmrBJ;AIjrBE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;AJmrBJ;AIjrBE;EACE,6BAAA;AJmrBJ;AIlrBI;EACE,WAAA;AJorBN;AIlrBI;EACE,aAAA;AJorBN;AIjrBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AJmrBJ;AIlrBI;EACE,eAAA;AJorBN;;AI/qBA;;2CAAA;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;EACA,kBAAA;AJkrBF;AIjrBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;AJmrBJ;AIjrBE;EACE,kBAAA;EACA,UAAA;AJmrBJ;AIjrBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AJmrBJ;AIjrBE;EACE,SAAA;EACA,UAAA;AJmrBJ;AIlrBI;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;AJorBN;AIlrBM;EACE,eAAA;EACA,cAAA;AJorBR;AInrBQ;EACE,aAAA;AJqrBV;;AI9qBA,iCAAA;AACA;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AJirBF;AIhrBE;EACE,qBAAA;EACA,aAAA;AJkrBJ;AIjrBI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJmrBN;AIlrBM;EACE,6BAAA;EACA,WAAA;AJorBR;AIlrBM;EACE,cFthBG;EEuhBH,qBFvhBG;AF2sCX;AIlrBM;EACE,cFzhBE;EE0hBF,qBF1hBE;AF8sCV;AIlrBM;EACE,cF5hBI;EE6hBJ,qBF7hBI;AFitCZ;AIlrBM;EACE,cF/hBE;EEgiBF,qBFhiBE;AFotCV;AIjrBI;EACE,cAAA;AJmrBN;AIjrBI;EACE,eAAA;AJmrBN;;AI9qBE;EACE,mCAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AJirBJ;AIhrBI;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;AJkrBN;AIhrBI;EACE,6BAAA;AJkrBN;AIjrBM;EACE,WAAA;AJmrBR;;AI7qBA,mCAAA;AAGI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AJ8qBN;AI7qBM;EACE,6BAAA;EACA,WAAA;AJ+qBR;AI5qBI;EACE,OAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AJ8qBN;AI7qBM;EACE,6BAAA;EACA,WAAA;AJ+qBR;;AIxqBI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AJ2qBN;AI1qBM;EACE,mBAAA;EACA,WAAA;AJ4qBR;AIzqBI;EACE,OAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AJ2qBN;AI1qBM;EACE,mBAAA;EACA,WAAA;AJ4qBR;;AIpqBI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AJuqBN;AItqBM;EACE,6BAAA;EACA,WAAA;AJwqBR;AIrqBI;EACE,cAAA;AJuqBN;AIrqBI;EACE,cAAA;AJuqBN;;AIjqBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AJoqBJ;;AI/pBE;EACE,kBAAA;EACA,iBAAA;AJkqBJ;AIjqBI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AJmqBN;AIlqBM;EACE,cAAA;EACA,kBAAA;EACA,sCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EC5lBJ,yBAAA;ALmwCJ;AIrqBQ;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;ECvmBN,yBAAA;ALixCJ;AItqBM;EACE,6BAAA;AJwqBR;AIvqBQ;EACE,mBAAA;AJyqBV;AItqBM;EACE,UAAA;AJwqBR;;AIlqBA;EACE,SAAA;EACA,UAAA;AJqqBF;AIpqBE;EACE,kBAAA;AJsqBJ;AIrqBI;EACE,gBAAA;AJuqBN;AInqBI;EACE,gBAAA;AJqqBN;AIpqBM;;EAEE,kBAAA;EACA,wBAAA;EACA,eAAA;AJsqBR;AIpqBM;EACE,cAAA;AJsqBR;AIjqBI;EACE,2BAAA;EACA,gBAAA;AJmqBN;;AI9pBA;;+DAAA;AAGA;EACE,kBAAA;AJiqBF;AIhqBE;EACE,kBAAA;AJkqBJ;;AI/pBA;EACE,cAAA;AJkqBF;;AIhqBA;EACE,6BAAA;AJmqBF;;AIjqBA;EACE,8BAAA;AJoqBF;;AIlqBA;EACE,mBAAA;AJqqBF;;AInqBA;EACE,mBAAA;AJsqBF;;AIpqBA;EACE,mBAAA;AJuqBF;;AIrqBA;EACE,mBAAA;AJwqBF;;AItqBA;EACE,mBAAA;AJyqBF;;AIvqBA;EACE,mDAAA;AJ0qBF;;AIxqBA;EACE,gCAAA;AJ2qBF;;AIzqBA;EACE,mBAAA;AJ4qBF;;AI1qBA;EACE,mBAAA;AJ6qBF;;AI3qBA;EACE,kBAAA;AJ8qBF;;AI5qBA;EACE,iCAAA;EACA,2BAAA;AJ+qBF;;AI7qBA;EACE,0BAAA;EACA,4BAAA;AJgrBF;;AI9qBA;EACE,yBAAA;EACA,4BAAA;EACA,yBAAA;AJirBF;;AI/qBA;EACE,kBAAA;EACA,iCAAA;AJkrBF;AIjrBE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,kCAAA;AJmrBJ;AIjrBE;EACE,kBAAA;EACA,UAAA;AJmrBJ;AIjrBE;EACE,kBAAA;EACA,UAAA;AJmrBJ;;AIhrBA;EACE,kBAAA;EACA,iCAAA;AJmrBF;AIlrBE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,iCAAA;AJorBJ;AIlrBE;EACE,kBAAA;EACA,UAAA;AJorBJ;AIlrBE;EACE,kBAAA;EACA,UAAA;AJorBJ;;AIjrBA;EACE,4BAAA;EACA,6BAAA;AJorBF;;AIlrBA;EACE,gBAAA;AJqrBF;AIprBE;EACE,sBAAA;EACA,gBAAA;AJsrBJ;AInrBI;EACE,qBAAA;AJqrBN;;AIjrBA;EACE,2CAAA;AJorBF;;AIjrBA;EACE,iBAAA;AJorBF;;AIlrBA;EACE,iBAAA;AJqrBF;;AInrBA;EACE,kBAAA;AJsrBF;;AIprBA;EACE,kBAAA;AJurBF;;AIrrBA;EACE,kBAAA;AJwrBF;;AItrBA;EACE,kBAAA;AJyrBF;;AIvrBA;EACE,kBAAA;AJ0rBF;;AIvrBA;EACE,iBAAA;AJ0rBF;;AIxrBA;EACE,oBAAA;AJ2rBF;;AIxrBA;EACE,oBAAA;AJ2rBF;;AIzrBA;EACE,oBAAA;AJ4rBF;;AI1rBA;EACE,oBAAA;AJ6rBF;;AI3rBA;EACE,oBAAA;AJ8rBF;;AI5rBA;EACE,qBAAA;AJ+rBF;;AI7rBA;EACE,qBAAA;AJgsBF;;AI9rBA;EACE,qBAAA;AJisBF;;AI/rBA;EACE,qBAAA;AJksBF;;AI/rBA;EACE,kBAAA;AJksBF;;AIhsBA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;AJmsBF;;AIjsBA;EACE,+BAAA;AJosBF;;AIlsBA;EACE,mBAAA;AJqsBF;;AInsBA;EACE,kBAAA;AJssBF;;AIpsBA;EACE,wBAAA;AJusBF;;AIpsBA;EACE,yBAAA;AJusBF;;AIrsBA;EACE,6BAAA;AJwsBF;;AItsBA;EACE,+BAAA;AJysBF;;AIvsBA;EACE,mBAAA;AJ0sBF;;AIxsBA;EACE,6BAAA;AJ2sBF;;AIvsBE;EACE,gBAAA;AJ0sBJ;AIvsBI;EACE,0BAAA;AJysBN;;AMzsDA,wCAAA;AACA;EACC,mDAAA;AN4sDD;;AM1sDA;EACE,oDAAA;AN6sDF;;AM3sDA;EACE,qDAAA;AN8sDF;;AM5sDA;EACE,uCAAA;AN+sDF;AMjsDA;EACE;IAEE,2BAAA;ENktDF;EMjtDA;IAEE,2BAAA;ENmtDF;EMltDA;IAEE,2BAAA;ENotDF;AACF;AMxsDA;EACE;IAEE,2BAAA;ENwtDF;EMvtDA;IAEE,2BAAA;ENytDF;EMxtDA;IAEE,2BAAA;EN0tDF;AACF;AMltDA;EACE;IAEE,yBAAA;IAEA,qBAAA;EN4tDF;AACF;AM3tDA;EACE;IACE,sHAAA;EN6tDF;EM3tDA;IACE,wHAAA;EN6tDF;AACF;AO3yDA;;iDAAA;AAGA;EACE,mBAAA;EACA,kBAAA;AP6yDF;AO5yDE;EACE,mBAAA;EACA,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AP8yDJ;AO5yDE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AP8yDJ;AO5yDE;EACE,gBAAA;EACA,aAAA;AP8yDJ;AO7yDI;EACE,wBAAA;AP+yDN;AO5yDE;EACE,gBAAA;EACA,gBAAA;AP8yDJ;AO5yDE;EACE,gBAAA;EACA,iBAAA;AP8yDJ;AO5yDE;EACE,gBAAA;EACA,gBAAA;AP8yDJ;AO7yDI;EACE,iBAAA;AP+yDN;AO5yDE;EACE,gBAAA;AP8yDJ;AO5yDE;EACE,gBAAA;AP8yDJ;AO3yDI;EACE,wBAAA;AP6yDN;AO3yDQ;EACE,gBAAA;AP6yDV;AOzyDQ;EACE,gBAAA;AP2yDV;AOvyDQ;EACE,gBAAA;APyyDV;AOvyDQ;EACE,gBAAA;APyyDV;AOryDI;EACE,WAAA;APuyDN;AOryDI;EACE,WAAA;APuyDN;AOryDI;EACE,WAAA;APuyDN;;AQ13DA;;+CAAA;AAGA;EACE,mBAAA;EACA,eAAA;AR63DF;AQ53DE;EACE,SAAA;EACA,UAAA;EACA,oBAAA;AR83DJ;AQ73DI;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;AR+3DN;AQ93DM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;ARg4DR;AQ93DM;;EAEE,SAAA;EACA,eAAA;EACA,WAAA;ARg4DR;AQ/3DQ;;EACE,iBAAA;ARk4DV;AQh4DQ;;EACE,iBAAA;ARm4DV;AQj4DQ;;EACE,iBAAA;ARo4DV;AQj4DM;EACE,2BAAA;ARm4DR;AQ93DI;EACE,aAAA;ARg4DN;AQ53DQ;EACE,eAAA;AR83DV;AQ53DQ;EACE,eAAA;AR83DV;AQ53DQ;EACE,eAAA;AR83DV;AQ33DM;EACE,eAAA;AR63DR;;AQv3DA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AR03DF;AQz3DE;EACE,oBAAA;EACA,kBAAA;AR23DJ;AQ13DI;EACE,kBAAA;EACA,kBAAA;AR43DN;AQ33DM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AR63DR;AQ13DI;EACE,gBAAA;EAUA,wBAAA;ARm3DN;AQ53DM;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AR83DR;AQ73DQ;EACE,YAAA;EACA,gBAAA;AR+3DV;AQ13DI;EACE,eAAA;EACA,gBAAA;AR43DN;AQz3DM;EACE,cAAA;EACA,WAAA;EACA,gBAAA;AR23DR;AQ13DQ;EAaE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;ARg3DV;AQ/3DU;EACE,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;ARi4DZ;AQ/3DU;EACE,wBAAA;ARi4DZ;AQ/3DU;EACE,iBAAA;ARi4DZ;AQ33DU;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;AR63DZ;AQ53DY;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;AR83Dd;AQ53DY;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;AR83Dd;AQ53DY;EHTR,yBAAA;AL04DJ;AQ/3Dc;EACE,UAAA;ARi4DhB;AQ/3Dc;EACE,6BAAA;ARi4DhB;AQ93DY;EACE,mBAAA;EACA,UAAA;ARg4Dd;AQ93DY;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,OAAA;EACA,SAAA;EACA,0CAAA;EACA,sBN1KC;EM2KD,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EHpCV,yBAAA;EG2CU,gBAAA;AR63Dd;AQ53Dc;EACE,6BAAA;AR83DhB;AQ53Dc;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EHnDZ,yBAAA;EGqDY,gCAAA;ARg4DhB;AQ/3DgB;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EH7Dd,yBAAA;EG+Dc,kBAAA;ARm4DlB;AQj4DgB;EACE,mBAAA;ARm4DlB;AQl4DkB;EACE,WAAA;EACA,4BAAA;ARo4DpB;AQn4DoB;EACE,mBAAA;EACA,UAAA;ARq4DtB;AQj4DgB;EACE,gBAAA;ARm4DlB;AQh4Dc;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;ARk4DhB;AQj4DgB;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EHlFd,SAAA;EAEA,0BAAA;EACA,2BGgFiC;ARu4DrC;AQr4DgB;EACE,UAAA;EACA,SAAA;ARu4DlB;AQr4DoB;EACE,UAAA;EACA,WAAA;ARu4DtB;AQn4DgB;EACE,mBAAA;EACA,UAAA;ARq4DlB;AQl4DsB;EACE,WNtPT;AF0nEf;AQ33DQ;EACE,kBAAA;AR63DV;;AQt3DA;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;ARy3DF;;AQt3DA;EACE,aAAA;ARy3DF;AQx3DE;EACE,aAAA;AR03DJ;;AQr3DA;EAEE,gEAAA;EACA,OAAA;EAEA,MAAA;EACA,WAAA;EACA,aAAA;EAEA,iDAAA;EACA,gBAAA;EACA,gBAAA;ARu3DF;;AQp3DA;EACE,UAAA;EACA,eAAA;EACA,mBAAA;ARu3DF;;AQr3DA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBN9Sa;EM+Sb,aAAA;EACA,SAAA;EACA,WAAA;ARw3DF;;AQt3DA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBNxTa;EMyTb,aAAA;EACA,SAAA;EACA,WAAA;ARy3DF;;AQv3DA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBNlUa;EMmUb,aAAA;EACA,SAAA;EACA,WAAA;AR03DF;;AQx3DA;EACE,aAAA;EACA,YAAA;AR23DF;;AQx3DA,6CAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,iBAAA;AR23DF;AQ13DE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AR43DJ;AQ33DI;EACE,gBAAA;EACA,iBAAA;AR63DN;AQ33DI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AR63DN;AQ33DI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;AR63DN;AQ53DM;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EHxOJ,yBAAA;EG0OI,gCAAA;ARg4DR;AQ/3DQ;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EHlPN,yBAAA;EGoPM,kBAAA;ARm4DV;AQl4DU;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EHnPR,SAAA;EAEA,0BAAA;EACA,2BGiP2B;EACnB,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;ARw4DZ;AQr4DQ;EACE,mBAAA;ARu4DV;AQt4DU;EACE,WAAA;EACA,4BAAA;ARw4DZ;AQv4DY;EACE,mBAAA;EACA,UAAA;ARy4Dd;AQr4DQ;EACE,gBAAA;ARu4DV;AQl4DM;EACE,wBAAA;ARo4DR;AQl4DM;EACE,UAAA;EACA,mBAAA;EACA,0BAAA;ARo4DR;;AQ93DA,8CAAA;AAEE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,4BAAA;ARg4DJ;AQ/3DI;EACE,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;ARi4DN;AQ/3DI;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;ARi4DN;AQ/3DI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;ARi4DN;AQ93DE;EACE,iBAAA;EACA,2BAAA;ARg4DJ;AQ93DE;EACE,iBAAA;EACA,eAAA;ARg4DJ;AQ73DI;EACE,6BAAA;EACA,mCAAA;AR+3DN;;AQ33DA;EAGE,mBAAA;AR83DF;;AQ53DA;EACE,2BAAA;EACA,uBAAA;AR+3DF;;AQ73DA;EACE,4CAAA;ARg4DF;;AQ93DA;EAGE,iGAAA;ARg4DF;;AQ73DA;;EAEE,2BAAA;ARg4DF;;AQ53DE;EACE,WAAA;AR+3DJ;AQ73DE;;EAEE,gBAAA;AR+3DJ;;AQz3DM;EACE,yBAAA;AR43DR;AQz3DI;EACE,8BAAA;AR23DN;AQz3DI;EACE,8BAAA;AR23DN;AQv3DQ;EACE,8BAAA;ARy3DV;AQx3DU;EACE,sBAAA;AR03DZ;;AQn3DA;EACE,iBAAA;ARs3DF;;AQp3DA;EACE,aAAA;ARu3DF;;AQp3DA,4CAAA;AACA;EACE,QAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;ARu3DF;;AQr3DA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;ARw3DF;AQv3DE;EACE,mBAAA;ARy3DJ;AQv3DE;EACE,mBAAA;ARy3DJ;AQv3DE;EACE,mBAAA;ARy3DJ;AQx3DI;EACE,SAAA;EACA,UAAA;AR03DN;AQz3DM;EACE,gBAAA;EACA,kBAAA;AR23DR;AQ13DQ;EACE,gBAAA;AR43DV;AQ13DQ;EACE,iBAAA;EACA,WAAA;AR43DV;AQv3DE;EACE,kBAAA;EACA,mBAAA;ARy3DJ;AQx3DI;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;AR03DN;AQx3DI;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AR03DN;AQz3DM;EACE,6BAAA;EACA,WAAA;AR23DR;AQv3DE;EACE,mBAAA;ARy3DJ;AQv3DE;EACE,6BAAA;EACA,WAAA;ARy3DJ;;AQt3DA;EACE,mCAAA;EACA,SAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;ARy3DF;;AQv3DA;EACE,YAAA;EACA,UAAA;EACA,mBAAA;AR03DF;;AQx3DA;EACE,MAAA;EACA,UAAA;EACA,mBAAA;EACA,kCAAA;AR23DF;;AQx3DA;EACE;IACE,gBAAA;ER23DF;EQz3DA;IACE,cAAA;ER23DF;EQz3DA;IACE,kBAAA;ER23DF;EQz3DA;IACE,iBAAA;IACA,eAAA;ER23DF;EQz3DA;IACE,eAAA;IACA,gBAAA;ER23DF;EQx3DE;IACE,kBAAA;IACA,UAAA;ER03DJ;EQz3DI;IACE,YAAA;ER23DN;EQz3DI;IACE,gBAAA;ER23DN;EQz3DM;IACE,cAAA;IACA,gBAAA;ER23DR;EQ13DQ;IAIE,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,2CAAA;ERy3DV;EQh4DU;IACE,cAAA;ERk4DZ;EQ33DU;IACE,mBAAA;ER63DZ;EQ33DU;IACE,cAAA;ER63DZ;EQ13DY;IACE,SAAA;IACA,qBAAA;ER43Dd;EQ13DY;IACE,iBAAA;IACA,cAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,YAAA;IACA,gBAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;IACA,mBAAA;IACA,YAAA;IACA,mBAAA;IACA,gBAAA;IACA,mBAAA;IACA,UAAA;IACA,2BAAA;ER43Dd;EQ33Dc;IACE,mBAAA;IACA,UAAA;IACA,iBAAA;ER63DhB;EQ13Dc;IACE,gBAAA;ER43DhB;EQ13Dc;IASE,UAAA;ERo3DhB;EQ13DoB;IACE,SAAA;IACA,WN1tBT;EFslFb;EQv3DgB;IACE,gBAAA;ERy3DlB;AACF;AQ/2DA;EACE,yBAAA;ARi3DF;;AQ72DA;EACE,UAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,uBAAA;ARg3DF;AQ92DE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,sCAAA;EACA,SAAA;ARg3DJ;AQ/2DI;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;ARi3DN;AQ92DI;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;ARg3DN;AQ72DI;EACE,eAAA;AR+2DN;AQ32DE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,sCAAA;EACA,UAAA;AR62DJ;AQ32DI;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AR62DN;AQ12DI;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;AR42DN;AQz2DI;EACE,eAAA;AR22DN;AQt2DI;EACE,yBAAA;EACA,uBAAA;ARw2DN;AQt2DM;EACE,yDAAA;ARw2DR;AQr2DM;EACE,2DAAA;ARu2DR;AQn2DI;EACE,yBAAA;EACA,uBAAA;ARq2DN;AQn2DM;EACE,2DAAA;ARq2DR;AQl2DM;EACE,2DAAA;ARo2DR;AQ/1DE;EACE,eAAA;ARi2DJ;;AQ71DA;EACE;IACE,eAAA;ERg2DF;EQ91DA;IACE,gBAAA;ERg2DF;AACF;AQ71DA;EACE;IACE,cAAA;IACA,WAAA;IACA,kBAAA;ER+1DF;EQ71DA;IACE,eAAA;ER+1DF;AACF;AQ51DA;EACE;IACE,eAAA;ER81DF;EQ51DA;IACE,kBAAA;ER81DF;AACF;AQ31DA;EACE;IACE,2BAAA;ER61DF;EQ31DA;IACE,gBAAA;ER61DF;EQ31DA;IACE,gBNx4BW;IMy4BX,eAAA;IACA,WAAA;ER61DF;EQ31DA;IAKE,WAAA;ERy1DF;EQv1DA;IACE,mBAAA;ERy1DF;EQv1DA;IACE,mBAAA;ERy1DF;EQv1DA;;;IAGE,gBAAA;ERy1DF;EQv1DA;IACE,iBAAA;ERy1DF;EQv1DA;IACE,eAAA;IACA,iBAAA;ERy1DF;EQv1DA;IACE,aAAA;ERy1DF;EQt1DA;IACE,eAAA;ERw1DF;EQt1DA;IACE,kBAAA;ERw1DF;EQt1DA;IACE,eAAA;ERw1DF;EQt1DA;IAME,mBAAA;ERm1DF;EQj1DA;IAQE,eAAA;ER40DF;EQ10DA;IAQE,mBAAA;ERq0DF;EQn0DA;IASE,UAAA;IACA,mBAAA;ER6zDF;EQ3zDA;IACE,cAAA;ER6zDF;EQ3zDA;IACE,aAAA;ER6zDF;EQ3zDA;IAOE,gBAAA;ERuzDF;EQrzDA;IACE,cAAA;ERuzDF;AACF;AQpzDA,+BAAA;AACA;EACE;IACE,cAAA;IACA,WAAA;ERszDF;EQpzDA;IACE,cAAA;IACA,WAAA;IACA,kBAAA;ERszDF;EQnzDA;IACE,kBAAA;IACA,wBAAA;IACA,SAAA;ERqzDF;EQnzDA;IACE,yBAAA;ERqzDF;EQnzDA;;IAEE,eAAA;IACA,iBAAA;IACA,iBAAA;ERqzDF;EQnzDA;IACE,2BAAA;ERqzDF;AACF;AQlzDA,+BAAA;AACA;EACE;IACE,eAAA;ERozDF;EQlzDA;IACE,iBAAA;ERozDF;EQlzDA;IACE,kBAAA;ERozDF;EQlzDA;IACE,kBAAA;ERozDF;EQlzDA;IACE,gBAAA;ERozDF;AACF;AQjzDA;EACE;;IAEE,iBAAA;ERmzDF;EQjzDA;;IAEE,YAAA;ERmzDF;EQjzDA;IACE,gBAAA;ERmzDF;AACF;AQhzDA;EACE;IACE,gBAAA;ERkzDF;EQhzDA;IACE,uBAAA;ERkzDF;AACF;ASx2FA;;+CAAA;AAGA;EACE,kBAAA;AT02FF;;ASx2FA;EACE,kBAAA;AT22FF;AS12FE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AT42FJ;AS12FE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AT42FJ;;ASz2FA;EACE,kBAAA;EACA,oBAAA;AT42FF;AS32FE;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;AT62FJ;AS32FE;EACE,eAAA;AT62FJ;;AS12FA;EACE,aAAA;AT62FF;AS52FE;EACE,gBAAA;EACA,kBAAA;AT82FJ;AS52FE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AT82FJ;AS52FE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,qEAAA;EACA,UAAA;AT82FJ;;ASz2FE;EACE,mBAAA;AT42FJ;AS32FI;EACE,2BAAA;EACA,uBAAA;AT62FN;AS52FM;EACE,4CAAA;AT82FR;AS72FQ;EACE,iGAAA;AT+2FV;AS32FM;;EAEE,2BAAA;AT62FR;;ASv2FA;EACE,kBAAA;EACA,UAAA;AT02FF;ASz2FE;EACE,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AT22FJ;ASz2FE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AT22FJ;AS12FI;EACE,wBAAA;AT42FN;ASz2FE;EACE,mBAAA;AT22FJ;;ASv2FA;EACE,kBAAA;AT02FF;ASz2FE;EACE,8BAAA;AT22FJ;ASz2FE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,8BAAA;AT22FJ;ASz2FE;EACE,kBAAA;AT22FJ;ASz2FE;EACE,YAAA;AT22FJ;ASz2FE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;AT22FJ;ASz2FE;EACE,WAAA;EACA,aAAA;AT22FJ;;ASv2FA;EACE,kBAAA;AT02FF;ASz2FE;EACE,kBAAA;AT22FJ;ASz2FE;EACE,kBAAA;AT22FJ;AS12FI;EACE,YAAA;EACA,YAAA;EACA,UAAA;AT42FN;AS12FI;EACE,YAAA;EACA,UAAA;EACA,SAAA;AT42FN;AS12FI;EACE,YAAA;EACA,aAAA;EACA,UAAA;AT42FN;ASz2FE;EACE,YAAA;EACA,MAAA;EACA,UAAA;AT22FJ;ASz2FE;EACE,UAAA;EACA,kBAAA;AT22FJ;;ASv2FA;EACE,kBAAA;EAIA,kBAAA;ATu2FF;AS12FE;EACE,kBAAA;AT42FJ;ASz2FE;EACE,WAAA;EACA,QAAA;AT22FJ;ASz2FE;EACE,WAAA;EACA,YAAA;AT22FJ;;AUviGA;;+CAAA;AAGA;EACE,kBAAA;AV0iGF;AUziGE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AV2iGJ;AUziGE;EACE,UAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,UAAA;AV2iGJ;AUziGE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AV2iGJ;;AUtiGE;EACE,qBAAA;EACA,mBAAA;EACA,iCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AVyiGJ;AUxiGI;EACE,gBAAA;AV0iGN;AUtiGI;EACE,gBAAA;AVwiGN;AUpiGI;EACE,6BAAA;AVsiGN;AUriGM;EACE,uBAAA;AVuiGR;;AUhiGE;EACE,uBAAA;EACA,SAAA;EACA,gCAAA;AVmiGJ;AUliGI;EACE,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AVoiGN;AUniGM;EACE,2BAAA;AVqiGR;AUliGI;EACE,mBAAA;AVoiGN;AU/hGM;EACE,kBAAA;AViiGR;AUhiGQ;EACE,OAAA;EACA,kBAAA;AVkiGV;AU1hGQ;EACE,2BAAA;AV4hGV;AU3hGU;EACE,YAAA;EACA,eAAA;AV6hGZ;AU1hGQ;EACE,YAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AV4hGV;AUthGI;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AVwhGN;AUthGQ;EACE,2BAAA;AVwhGV;AUvhGU;EACE,YAAA;EACA,eAAA;AVyhGZ;AUthGQ;EACE,YAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AVwhGV;;AUjhGA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AVohGF;AUnhGE;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AVqhGJ;AUnhGE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AVqhGJ;AUphGI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AVshGN;AUphGI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,wBAAA;AVshGN;;AUlhGA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AVqhGF;AUphGE;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,2BAAA;AVshGJ;AUrhGI;EACE,kBAAA;AVuhGN;;AWxvGA;;+CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+CAAA;AX2vGF;AW1vGE;EACE,mBAAA;EACA,gBAAA;AX4vGJ;AW3vGI;EACE,gBAAA;AX6vGN;AWzvGI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AX2vGN;AWzvGI;EACE,mBAAA;AX2vGN;AWxvGE;EACE,8CAAA;AX0vGJ;AWxvGM;EACE,0BAAA;AX0vGR;AWtvGE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;AXwvGJ;AWvvGI;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AXyvGN;AWtvGM;EACE,eAAA;AXwvGR;AWpvGM;EACE,mCAAA;AXsvGR;;AWhvGA;EACE,mBAAA;AXmvGF;AWlvGE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;AXovGJ;AWnvGI;EACE,sBAAA;EACA,gBAAA;AXqvGN;AWlvGE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AXovGJ;AWlvGM;EACE,gBAAA;AXovGR;AWjvGI;EACE,gBAAA;AXmvGN;AW9uGM;EACE,qBAAA;AXgvGR;AW7uGI;EACE,8CT9EO;AF6zGb;AW7uGQ;EACE,0BAAA;AX+uGV;;AWxuGA;EACE,gBAAA;EACA,8CT1FW;ES2FX,kBAAA;EACA,gBAAA;EACA,mBAAA;AX2uGF;AW1uGE;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;AX4uGJ;AW3uGI;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AX6uGN;AWzuGI;EACE,gBAAA;AX2uGN;AWxuGE;EACE,4BAAA;AX0uGJ;AWzuGI;EACE,YAAA;AX2uGN;AWxuGE;EACE,4BAAA;AX0uGJ;AWzuGI;EACE,WAAA;AX2uGN;AWxuGE;EACE,mBAAA;AX0uGJ;AWzuGI;EACE,sBAAA;AX2uGN;AWxuGM;EACE,WAAA;AX0uGR;AWxuGM;EACE,WAAA;AX0uGR;;AWruGA;EACE,mCAAA;AXwuGF;;AWtuGA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AXyuGF;;AYp5GA;EACC,kBAAA;EACA,8CViBY;EUhBZ,mBAAA;EACA,kBAAA;EACG,gBAAA;AZu5GJ;AYr5GE;EACC,gBAAA;AZu5GH;AYn5GE;EACC,wBAAA;EACA,gBAAA;AZq5GH;AYn5GE;EACC,gBAAA;AZq5GH;AYn5GE;EACC,gBAAA;AZq5GH;AYl5GC;EACC,+CVJY;AFw5Gd;AYl5GG;EACC,0BAAA;AZo5GJ;;AY74GA;EACC,aAAA;EACA,iBAAA;AZg5GD;AY/4GC;EACC,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8CVxBW;EUyBX,qBAAA;EACA,kBAAA;EACA,gBAAA;AZi5GF;AYh5GE;EACC,gBAAA;AZk5GH;AYh5GE;EACC,YAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AZk5GH;AY94GE;EACC,gBAAA;AZg5GH;AY34GG;EACC,0BAAA;AZ64GJ;AY34GG;EACC,gCAAA;AZ64GJ;;AYv4GA;EACC,aAAA;EACA,cAAA;AZ04GD;AYz4GC;EACC,kBAAA;AZ24GF;;Aaj+GA;EACE,yBAAA;EACA,iDAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;Abo+GF;Aan+GE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;Abq+GJ;Aap+GI;EACE,sBAAA;EACA,gBAAA;Abs+GN;Aap+GI;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;Abs+GN;Aar+GM;EACE,mBAAA;Abu+GR;Aan+GE;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;Abq+GJ;Aap+GI;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;Abs+GN;Aar+GM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;Abu+GR;Aan+GE;EACE,aAAA;Abq+GJ;Aap+GI;EACE,gBAAA;Abs+GN;Aaj+GM;EACE,qBAAA;Abm+GR;Aaj+GM;EACE,YAAA;EACA,mBAAA;EACA,UAAA;Abm+GR;Aa99GE;EACE,mBAAA;EACA,SAAA;Abg+GJ;Aa/9GI;EACE,mBAAA;Abi+GN;Aa/9GI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;Abi+GN;Aah+GM;EACE,4BAAA;EACA,oCAAA;EACA,aAAA;Abk+GR;Aah+GM;EACE,wBAAA;Abk+GR;Aaj+GQ;EACE,2BAAA;Abm+GV;Aah+GM;EACE,2BAAA;Abk+GR;Aah+GM;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;Abk+GR;;Aa39GE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;Ab89GJ;Aa79GI;EACE,WAAA;EACA,mBAAA;Ab+9GN;Aa19GM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;Ab49GR;Aa39GQ;EACE,6BAAA;Ab69GV;;AcvlHA;;+CAAA;AAGA;EACC,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,gDAAA;Ad0lHD;AczlHC;EACC,gBAAA;Ad2lHF;Ac1lHE;EACC,eAAA;EACA,WAAA;Ad4lHH;AczlHC;EACC,mBAAA;EACA,gBAAA;Ad2lHF;AczlHC;EACC,UAAA;Ad2lHF;Ac1lHE;EACC,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;Ad4lHH;Ac3lHG;;EAEC,kBAAA;Ad6lHJ;Ac3lHG;EACC,6BAAA;Ad6lHJ;AczlHC;EACC,gBAAA;Ad2lHF;AczlHC;EAEC,mBAAA;EACA,gBAAA;Ad0lHF;AczlHE;EACC,6BAAA;EACA,+BAAA;EACA,sBAAA;EACA,iBAAA;Ad2lHH;AcxlHC;EACC,yBAAA;EACA,gBAAA;Ad0lHF;AczlHE;EACC,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;Ad2lHH;AczlHE;EAEC,6BAAA;Ad0lHH;AczlHG;EACC,WAAA;Ad2lHJ;AczlHG;EACC,oCAAA;EACA,WAAA;Ad2lHJ;AczlHG;EACC,UAAA;Ad2lHJ;Ac1lHI;EACC,WAAA;Ad4lHL;Ac3lHK;;;EAEC,kBAAA;Ad8lHN;Ac5lHK;EACC,+BAAA;Ad8lHN;Ac1lHG;EACC,gBAAA;EACA,mCAAA;Ad4lHJ;;AejrHA;EACE,mBAAA;AforHF;AenrHE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AfqrHJ;AeprHI;EACE,sBAAA;EACA,gBAAA;AfsrHN;AenrHE;EACE,8CbOS;EaNT,4BAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;AfqrHJ;AeprHI;EACE,kBAAA;AfsrHN;AeprHI;EACE,wBAAA;AfsrHN;AeprHI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,wBAAA;AfsrHN;AerrHM;EACE,6BAAA;EACA,WAAA;AfurHR;AejrHM;EACE,qBAAA;AfmrHR;Ae/qHM;EACE,6BAAA;EACA,WAAA;AfirHR;;Ae3qHA;EACE,kBAAA;Af8qHF;;Ae5qHA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;Af+qHF;;Ae7qHA;EACE,WAAA;AfgrHF;;Ae9qHA;EACE,WAAA;AfirHF;;Ae/qHA;EAEE,qBAAA;AfkrHF;;AehrHA;EACE,6BAAA;EACA,WAAA;AfmrHF;;AgBtwHA;;+CAAA;AAGA;EACE,mBAAA;AhBywHF;AgBvwHI;EACE,gBAAA;AhBywHN;AgBpwHM;EACE,0BAAA;AhBswHR;AgBlwHE;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;AhBowHJ;AgBnwHI;EACE,gBAAA;AhBqwHN;;AgBhwHA;EACE,aAAA;EACA,8CdVW;EcWX,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;AhBmwHF;AgBlwHE;EACE,kBAAA;AhBowHJ;AgBlwHE;EACE,gBAAA;AhBowHJ;AgBnwHI;EACE,kBAAA;AhBqwHN;AgBnwHI;EACE,gBAAA;AhBqwHN;AgBlwHE;EACE,+Cd5BU;AFgyHd;;AgB/vHE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AhBkwHJ;AgBhwHE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AhBkwHJ;AgBjwHI;EACE,WAAA;AhBmwHN;AgBhwHE;EACE,aAAA;AhBkwHJ;;AgB/vHA;EACE,4BAAA;AhBkwHF;;AiB50HA;EACE,8CfkBW;EejBX,kBAAA;EACA,YAAA;EACA,gBAAA;AjB+0HF;AiB90HE;EACE,gBAAA;AjBg1HJ;AiB90HE;EACE,qBAAA;AjBg1HJ;AiB70HE;EACE,oBAAA;EACA,kBAAA;AjB+0HJ;AiB90HI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AjBg1HN;AiB90HI;EACE,gBAAA;EACA,8CfTO;EeUP,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;AjBg1HN;AiB/0HM;EACE,kBAAA;AjBi1HR;AiB50HI;EACE,yCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AjB80HN;AiB70HM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AjB+0HR;AiB70HM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AjB+0HR;AiB30HM;EACE,WAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;AjB60HR;AiB10HI;EACE,eAAA;AjB40HN;AiB30HM;EACE,eAAA;AjB60HR;AiBz0HE;EACE,UAAA;EACA,gBAAA;EACA,uBAAA;AjB20HJ;AiB10HI;EACE,WAAA;AjB40HN;AiB10HI;EACE,kBAAA;EACA,mBAAA;AjB40HN;AiB30HM;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AjB60HR;AiB30HM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;AjB60HR;AiB10HI;EACE,kBAAA;EACA,aAAA;AjB40HN;AiB30HM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AjB60HR;AiB30HM;EACE,gBAAA;EACA,eAAA;AjB60HR;AiB30HM;EACE,wBAAA;AjB60HR;AiB30HM;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AjB60HR;;AiBt0HE;EACE,aAAA;AjBy0HJ;;AiBt0HA;EACE,aAAA;AjBy0HF;;AiBt0HA;EACE,eAAA;EACA,wBAAA;AjBy0HF;;AiBv0HA;EACE,aAAA;EACA,wBAAA;AjB00HF;;AiBv0HA;EACE,oBAAA;AjB00HF;AiBz0HE;EACE,yCAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;AjB20HJ;AiB10HI;EACE,WAAA;EACA,gBAAA;AjB40HN;AiB10HI;EACE,qCAAA;EACA,aAAA;AjB40HN;;AkBv/HA;EACE,kBAAA;AlB0/HF;;AkBv/HE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AlB0/HJ;;AkBt/HA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AlBy/HF;AkBx/HE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;AlB0/HJ;AkBx/HE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AlB0/HJ;AkBx/HE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8ChBdS;AFwgIb;AkBz/HI;EACE,eAAA;AlB2/HN;;AkBt/HA;EACE,qBAAA;EACA,kBAAA;AlBy/HF;;AkBv/HA;EACE,cAAA;EACA,mBAAA;AlB0/HF;;AkBv/HA;EACE,qBAAA;AlB0/HF;AkBz/HE;EACE,WAAA;EACA,aAAA;AlB2/HJ;;AkBv/HA;EACE,mBAAA;EACA,kBAAA;AlB0/HF;;AkBx/HA;EACE,2CAAA;AlB2/HF;AkB1/HE;EACE,oBAAA;EACA,0CAAA;EACA,kCAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AlB4/HJ;AkB3/HI;EACE,0BAAA;AlB6/HN;AkB3/HI;EACE,mCAAA;AlB6/HN;;AkBz/HA;EACE,aAAA;AlB4/HF;;AkBz/HA;EACE,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AlB4/HF;AkB3/HE;EACE,oBAAA;EACA,kCAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AlB6/HJ;AkB5/HI;EACE,0BAAA;AlB8/HN;AkB5/HI;EACE,mCAAA;AlB8/HN;;AkBz/HA;EACE,kBAAA;AlB4/HF;AkB3/HE;EACE,oCAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AlB6/HJ;;AkB1/HA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;AlB6/HF;;AmBjnIA;;yCAAA;AAGA;EACI,mBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;AnBonIJ;;AmBjnIA;EACI,UAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,yBAAA;EACA,kBAAA;EACA,UAAA;EAGA,gCAAA;EACA,YAAA;AnBonIJ;;AmBjnIA;EACI,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AnBonIJ;;AmBlnIA;;;EAGI,UAAA;EAEM,gBAAA;AnBqnIV;;AmBlnIA;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,4BAAA;EACA,+BAAA;EACA,cAAA;EAGA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACF,6BAAA;AnBqnIF;;AmBnnIA;;;EAGI,UAAA;EAEM,gBAAA;AnBsnIV;;AmBnnIA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EAGA,yBAAA;EACA,yDAAA;AnBsnIJ;;AmBnnIA;EACI,mBAAA;EACA,aAAA;AnBsnIJ;;AmBnnIA;EACI,eAAA;EACA,gBAAA;AnBsnIJ;;AmBrnIA;EACI,UAAA;EAIA,yBAAA;EAGA,qBAAA;AnBwnIJ;;AmBvnIA;EACI,UAAA;EAIA,yBAAA;AnB0nIJ;;AmBznIA;EACI,UAAA;EAGA,mBAAA;AnB4nIJ;;AmB3nIA;EACI,YAAA;AnB8nIJ;;AmB7nII;EAGA,qBAAA;EACA,UAAA;AnBgoIJ;;AmB/nIA;EACI,UAAA;AnBkoIJ;;AmB5nIA,6CAAA;AACA;EACI,mBAAA;AnB+nIJ;AmB9nII;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AnBgoIR;AmB/nIQ;EACI,cAAA;AnBioIZ;AmB9nII;EACI,WAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AnBgoIR;AmB/nIQ;EACI,cAAA;AnBioIZ;AmB9nII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AnBgoIR;AmB/nIQ;EACI,WAAA;AnBioIZ;AmB7nIQ;EACI,qDAAA;AnB+nIZ;AmB9nIY;EACI,cAAA;AnBgoIhB;AmB7nIQ;EACI,qDAAA;EACA,uBAAA;AnB+nIZ;AmB9nIY;EACI,cAAA;AnBgoIhB;AmB7nIQ;EACI,qDAAA;EACA,cAAA;AnB+nIZ;AmB3nIQ;EACI,4DAAA;EACA,uBAAA;EACA,UAAA;AnB6nIZ;AmB5nIY;EACI,cAAA;AnB8nIhB;AmB3nIQ;EACI,4DAAA;AnB6nIZ;AmB5nIY;EACI,cAAA;AnB8nIhB;AmB3nIQ;EACI,4DAAA;EACA,uBAAA;EACA,cAAA;AnB6nIZ;AmBznIQ;EACI,mBAAA;AnB2nIZ;AmB1nIY;EACI,cAAA;AnB4nIhB;AmBznIQ;EACI,mBAAA;AnB2nIZ;AmB1nIY;EACI,cAAA;AnB4nIhB;AmBznIQ;EACI,mBAAA;EACA,cAAA;AnB2nIZ;AmBvnIQ;EACI,uBAAA;EACA,WAAA;AnBynIZ;AmBxnIY;EACI,WAAA;AnB0nIhB;AmBvnIQ;EACI,uBAAA;EACA,WAAA;AnBynIZ;AmBxnIY;EACI,WAAA;AnB0nIhB;AmBvnIQ;EACI,uBAAA;EACA,WAAA;AnBynIZ;;AmBnnIA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AnBsnIJ;AmBpnIQ;EACI,wCAAA;AnBsnIZ;AmBrnIY;EACI,WAAA;AnBunIhB;;AmBhnII;EACI,mBAAA;EACA,yBAAA;AnBmnIR;;AoB53IA;;qDAAA;AAGA;EACE,kBAAA;EACA,eAAA;ApB+3IF;;AoB73IA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;ApBg4IF;AoB/3IE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;ApBi4IJ;AoBh4II;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;ApBk4IN;AoBh4II;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;ApBk4IN;AoB/3IE;EACE,8ClBnBS;EkBoBT,kBAAA;EACA,kBAAA;ApBi4IJ;;AoB73IE;EACE,WAAA;ApBg4IJ;;AoB53IA;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;ApB+3IF;AoB73II;EACE,aAAA;ApB+3IN;AoB73II;EACE,2CAAA;EACA,uBAAA;EACA,YAAA;ApB+3IN;;AoB13IA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;ApB63IF;;AoB33IA;EACE,gBAAA;ApB83IF;;AoB53IA;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;ApB+3IF;;AoB73IA;EACE,SAAA;EACA,UAAA;ApBg4IF;;AoB93IA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;ApBi4IF;;AoB/3IA;;EAEE,WAAA;ApBk4IF;;AoBh4IA;;EAEE,gBAAA;EACA,UAAA;ApBm4IF;;AoBh4IA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApBm4IF;;AoBj4IA;EACE,mBAAA;ApBo4IF;;AoBl4IA;EACE,mBAAA;ApBq4IF;;AoBn4IA;EACE,kBAAA;ApBs4IF;;AoBp4IA;EACE,kBAAA;ApBu4IF;;AoBr4IA;EACE,kBAAA;ApBw4IF;;AoBt4IA;EACE,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;ApBy4IF;;AoBv4IA;EACE,cAAA;ApB04IF;;AoBx4IA;;EAEE,iBAAA;EACA,wBAAA;ApB24IF;;AoBz4IA;EACE,2BAAA;EACA,iBAAA;EACA,gBAAA;ApB44IF;;AoBx4IA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;ApB24IF;;AoBz4IA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;ApB44IF;AoB34IE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;ApB64IJ;;AoB14IA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;ApB64IF;AoB54IE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,uCAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;ApB84IJ;;AoB34IA;EACE,gBAAA;ApB84IF;;AoB14IA;EACE,UAAA;ApB64IF;AoB54IE;EACE,gBAAA;ApB84IJ;AoB74II;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ApB+4IN;AoB94IM;EACE,YAAA;EACA,gBAAA;EACA,eAAA;ApBg5IR;AoB74IQ;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;ApB+4IV;AoB54IM;EACE,6DAAA;EACA,mCAAA;EACA,WAAA;ApB84IR;;AoBv4IA;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;ApB04IF;AoBz4IE;EACE,YAAA;EACA,gBAAA;ApB24IJ;;AoBx4IA;EACE,6BAAA;EACA,cAAA;EACA,+BAAA;ApB24IF;;AoBx4IA,8CAAA;AAEE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;ApB04IJ;;AoBv4IA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;EACA,gCAAA;ApB04IF;AoBz4IE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;ApB24IJ;AoB14II;EACE,mCAAA;ApB44IN;AoB14II;EACE,cAAA;ApB44IN;AoBz4IE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;ApB24IJ;AoB14II;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAGA,wBAAA;ApB44IN;;AoBv4IA,sCAAA;AACA;EACE,kBAAA;ApB04IF;AoBz4IE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ApB24IJ;AoB14II;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,8BAAA;ApB44IN;AoB14II;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;ApB44IN;AoB34IM;EACE,eAAA;ApB64IR;AoB34IM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ApB64IR;AoBz4IE;EACE,gBAAA;ApB24IJ;AoB14II;EACE,UAAA;EACA,SAAA;ApB44IN;AoB34IM;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,iCAAA;EACA,oBAAA;EACA,mBAAA;ApB64IR;AoB54IQ;EACE,gBAAA;ApB84IV;AoB54IQ;EACE,wBAAA;EACA,iBAAA;ApB84IV;AoB54IQ;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;ApB84IV;;AoBv4IA,kCAAA;AAEE;EACE,UAAA;ApBy4IJ;AoBx4II;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;ApB04IN;AoBz4IM;EACE,kBAAA;EACA,wBAAA;ApB24IR;AoBz4IM;EACE,kBAAA;EACA,wBAAA;ApB24IR;AoB14IQ;EACE,cAAA;ApB44IV;AoBz4IM;EACE,gBAAA;ApB24IR;AoBz4IM;EACE,eAAA;EACA,eAAA;ApB24IR;AoBr4IM;EACE,wCAAA;EACA,uBAAA;EACA,iBAAA;ApBu4IR;AoBt4IQ;EACE,eAAA;EACA,gBAAA;ApBw4IV;AoBt4IQ;EACE,6BAAA;EACA,mCAAA;ApBw4IV;AoBv4IU;EACE,sBAAA;ApBy4IZ;AoBr4IU;EACE,mBAAA;EACA,yBAAA;ApBu4IZ;AoBt4IY;EACE,sBAAA;ApBw4Id;;AoB93IE;EACE,cAAA;ApBi4IJ;AoBh4II;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ApBk4IN;AoBj4IM;EACE,sBAAA;EACA,gBAAA;ApBm4IR;AoBj4IM;EACE,WAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;ApBm4IR;AoBj4IM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;ApBm4IR;AoBh4IQ;EACE,mBAAA;EACA,UAAA;ApBk4IV;AoBh4IQ;EACE,mBAAA;EACA,UAAA;ApBk4IV;AoBh4IQ;EACE,qBAAA;ApBk4IV;;AoB33IA;EACE,6BAAA;ApB83IF;AoB73IE;EACE,mBAAA;ApB+3IJ;AoB93II;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;ApBg4IN;AoB53II;EACE,mBAAA;ApB83IN;AoB53II;EACE,mBAAA;ApB83IN;AoB53II;EACE,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;ApB83IN;AoB73IM;EACE,6BAAA;EACA,WAAA;ApB+3IR;;AoBx3IE;EACE,kBAAA;ApB23IJ;AoBz3IE;EACE,mBAAA;ApB23IJ;AoB13II;EACE,gBAAA;ApB43IN;;AoBt3IE;EACE,mBAAA;EACA,SAAA;ApBy3IJ;AoBx3II;EACE,iBAAA;ApB03IN;AoBz3IM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;ApB23IR;AoBz3IM;EAEE,aAAA;ApB03IR;AoBr3II;EACE,6BAAA;ApBu3IN;AoBt3IM;EACE,gCAAA;EACA,iBAAA;ApBw3IR;AoBl3IE;EACE,qBAAA;EACA,uBAAA;ApBo3IJ;AoBn3II;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;ApBq3IN;AoBn3II;EACE,iBAAA;EACA,UAAA;ApBq3IN;AoBj3II;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;ApBm3IN;AoBl3IM;EACE,gBAAA;ApBo3IR;AoBn3IQ;EACE,kBAAA;EACA,cAAA;ApBq3IV;AoBp3IU;EACE,YAAA;EACA,WAAA;EACA,mCAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;ApBs3IZ;AoBn3IY;EACE,6BAAA;EACA,WAAA;ApBq3Id;;AqBn9JA;;iDAAA;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;ArBs9JF;AqBr9JE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ArBu9JJ;AqBt9JI;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;ArBw9JN;AqBt9JI;EACE,sBAAA;EACA,gBAAA;ArBw9JN;AqBr9JE;EACE,SAAA;EACA,UAAA;EACA,mBAAA;ArBu9JJ;AqBt9JI;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;ArBw9JN;AqBv9JM;EACE,iBAAA;EACA,wBAAA;ArBy9JR;AqBv9JM;EACE,iBAAA;EACA,wBAAA;ArBy9JR;AqBv9JM;EACE,eAAA;ArBy9JR;AqBp9JI;EACE,kBAAA;ArBs9JN;AqBr9JM;EACE,wBAAA;ArBu9JR;AqBp9JI;EACE,mBAAA;ArBs9JN;AqBp9JI;EACE,mBAAA;ArBs9JN;AqBp9JI;EACE,gBAAA;ArBs9JN;AqBn9JE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;EACA,yBAAA;EACA,gBAAA;ArBq9JJ;AqBp9JI;EACE,kBAAA;EACA,gCAAA;EACA,WAAA;ArBs9JN;AqBp9JI;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,0BAAA;ArBs9JN;AqBr9JM;EACE,gBAAA;ArBu9JR;AqBp9JI;EACE,eAAA;EACA,qBAAA;EACA,WAAA;ArBs9JN;AqBj9JM;EACE,qBAAA;ArBm9JR;;AqB78JA;EACE,kBAAA;EACA,8CnB3FW;EmB4FX,mBAAA;EACA,gBAAA;EACA,gBAAA;ArBg9JF;AqB/8JE;EACE,gBAAA;EACA,kBAAA;ArBi9JJ;AqBh9JI;EACE,gBAAA;ArBk9JN;AqBh9JI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,wCAAA;EACA,2BAAA;EACA,gBAAA;ArBk9JN;AqB/8JE;EACE,kBAAA;EACA,kBAAA;ArBi9JJ;AqBh9JI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;EACA,0BAAA;EACA,WAAA;ArBk9JN;AqB/8JM;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;ArBi9JR;AqBh9JQ;EACE,wBAAA;EACA,iBAAA;ArBk9JV;AqB98JI;EACE,gBAAA;ArBg9JN;AqB/8JM;;EAEE,kBAAA;ArBi9JR;AqB98JI;EACE,gBAAA;ArBg9JN;AqB98JI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;ArBg9JN;AqB/8JM;EACE,gBAAA;ArBi9JR;AqB78JE;EACE,+CnB5JU;AF2mKd;AqB78JM;EACE,qBAAA;ArB+8JR;AqBz8JM;EACE,kBAAA;ArB28JR;AqBv8JM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;ArBy8JR;AqBx8JQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ArB08JV;AqBn8JM;EACE,kBAAA;ArBq8JR;AqBj8JM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;ArBm8JR;AqBl8JQ;EACE,WAAA;ArBo8JV;AqBn8JU;EACE,WAAA;ArBq8JZ;AqBn8JU;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ArBq8JZ;AqBp8JY;EACE,kBAAA;ArBs8Jd;AqBl8JQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ArBo8JV;AqBj8JM;EACE,kBAAA;ArBm8JR;AqBl8JQ;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;ArBo8JV;AqBl8JU;EACE,gBAAA;ArBo8JZ;AqBj8JQ;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;ArBm8JV;AqBh8JU;EACE,cAAA;ArBk8JZ;AqBj8JY;EACE,mBAAA;ArBm8Jd;AqBh8JU;EACE,mBAAA;ArBk8JZ;;AqB17JA,0CAAA;AACA;EACE,oBAAA;EACA,kBAAA;ArB67JF;AqB57JE;;EhBlKE,yBAAA;ALomKJ;AqB97JE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EhB/KA,yBAAA;EgBiLA,cAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;ArBk8JJ;AqBj8JI;EAGE,6BAAA;EACA,WAAA;ArBi8JN;AqB/7JI;EACE,6BAAA;EACA,WAAA;ArBi8JN;;AqB57JA,+CAAA;AAEE;EACE,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;ArB87JJ;AqB57JE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;ArB87JJ;AqB77JI;EACE,2BAAA;EACA,gBAAA;ArB+7JN;AqB77JI;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;ArB+7JN;AqB77JI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ArB+7JN;AqB97JM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;ArBg8JR;;AqB17JA,uCAAA;AACA;EACE,gBAAA;EACA,gCAAA;EACA,eAAA;ArB67JF;AqB37JI;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;ArB67JN;AqB57JM;EACE,6BAAA;EACA,WAAA;EACA,+BAAA;ArB87JR;AqB17JE;EACE,2BAAA;EACA,iBAAA;EACA,eAAA;ArB47JJ;AqBz7JI;EACE,SAAA;EACA,UAAA;EACA,qBAAA;ArB27JN;AqB17JM;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;ArB47JR;AqB37JQ;EACE,eAAA;ArB67JV;;AqBt7JA,6BAAA;AACA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ArBy7JF;AqBx7JE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;ArB07JJ;AqBz7JI;EACE,eAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;ArB27JN;;AqBt7JA;EACE,iBAAA;ArBy7JF;AqBx7JE;EACE,kBAAA;EACA,mBAAA;ArB07JJ;;AqBt7JA;EACE,qBAAA;ArBy7JF;;AqBt7JA;EACE,cAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,gBAAA;ArBy7JF;;AqBt7JA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;ArBy7JF;;AqBt7JA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,gBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ArBy7JF;;AqBt7JA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,cAAA;ArBy7JF;;AqBt7JA;EACE,qBAAA;EACA,iBAAA;ArBy7JF;;AqBt7JA;EACE,aAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;ArBy7JF;;AqBt7JA;;EAEE,eAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ArBy7JF;;AqBt7JA;;EAEE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;ArBy7JF;;AqBt7JA;EACE,mBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;ArBy7JF;;AqBt7JA;EACE,mCAAA;ArBy7JF;;AqBt7JA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,iBAAA;EACA,gBAAA;ArBy7JF;;AqBt7JA;EACE,wBAAA;EACA,qBAAA;ArBy7JF;;AqBt7JA;EACE,gBAAA;ArBy7JF;;AqBt7JA;EACE,mCAAA;ArBy7JF;;AqBt7JA;EACE,wBAAA;ArBy7JF;;AqBt7JA;EACE,gBAAA;ArBy7JF;;AqBt7JA;EACE,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;ArBy7JF;;AqBt7JA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;ArBy7JF;AqBx7JE;EACE,gBAAA;ArB07JJ;;AqBt7JA;EACE;IACE,aAAA;IACA,kBAAA;IACA,MAAA;IACA,QAAA;ErBy7JF;AACF;AqBt7JA;EACE,8CAAA;EACA,cAAA;ArBw7JF;;AqBr7JA;;EAEE,mBAAA;ArBw7JF;;AqBr7JA;EACE,mBAAA;ArBw7JF;;AqBr7JA;EACE,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;ArBw7JF;;AqBr7JA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;ArBw7JF;;AqBr7JA;EACE,eAAA;ArBw7JF;;AqBr7JA;EACE,qBAAA;EACA,wBAAA;EACA,0BAAA;ArBw7JF;;AqBr7JA;EACE,mCAAA;EACA,YAAA;ArBw7JF;;AqBr7JA;EACE,mBAAA;ArBw7JF;;AqBr7JA;EACE,gBAAA;ArBw7JF;;AqBr7JA;EACE,mBAAA;ArBw7JF;;AsBpqLA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AtBuqLF;AsBtqLE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AtBwqLJ;AsBvqLI;EACE,cAAA;EACA,mBAAA;AtByqLN;AsBvqLI;EACE,wBAAA;AtByqLN;AsBtqLE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AtBwqLJ;AsBrqLI;EACE,QAAA;EACA,mBAAA;EACA,UAAA;AtBuqLN;AsBrqLI;EACE,mBAAA;EACA,UAAA;EACA,mBAAA;AtBuqLN;;AuBrtLA;;oDAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AvBwtLF;AuBvtLE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;EACA,WAAA;AvBytLJ;AuBttLE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;AvBwtLJ;AuBttLE;EACE,mBAAA;EACA,kBAAA;AvBwtLJ;AuBrtLI;EACE,mBAAA;EAIH,wBAAA;AvBotLH;AuBvtLM;EACE,gBAAA;AvBytLR;AuBntLM;EACE,gBAAA;EACA,WAAA;AvBqtLR;AuBptLQ;EACE,wBAAA;EACA,kBAAA;AvBstLV;AuBptLQ;EACE,gBAAA;AvBstLV;AuBntLM;EACE,gBAAA;AvBqtLR;AuBntLU;EACE,6BAAA;EACA,WAAA;AvBqtLZ;AuBhtLI;EACE,kBAAA;AvBktLN;AuBjtLM;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;AvBmtLR;AuBjtLM;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AvBmtLR;AuBltLQ;EACE,gCAAA;AvBotLV;AuB9sLI;EACE,SAAA;EACA,UAAA;AvBgtLN;AuB/sLM;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AvBitLR;AuBhtLQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AvBktLV;AuB/sLU;EACE,wBAAA;AvBitLZ;AuB5sLY;EACE,cAAA;AvB8sLd;AuB5sLY;EACE,cAAA;AvB8sLd;AuBtsLI;EACE,kBAAA;AvBwsLN;AuBvsLM;EACE,mBAAA;AvBysLR;AuBtsLI;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,wBAAA;AvBwsLN;AuBtsLI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AvBwsLN;AuBvsLM;EACE,kBAAA;EACA,OAAA;EACA,QAAA;AvBysLR;AuBrsLE;EACE,WAAA;AvBusLJ;AuBrsLE;EACE,cAAA;AvBusLJ;AuBrsLE;EACE,WAAA;AvBusLJ;AuBrsLE;EACE,cAAA;AvBusLJ;;AuBnsLA;EACE,iBAAA;EACA,oBAAA;AvBssLF;;AuBpsLA;EACE,+CAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AvBusLF;AuBtsLE;EACE,gBAAA;EACA,WAAA;AvBwsLJ;AuBtsLE;EACE,kBAAA;EACA,WAAA;AvBwsLJ;AuBvsLI;EACE,eAAA;AvBysLN;;AuBpsLA;EACE,4BAAA;AvBusLF;AuBtsLE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;AvBwsLJ;AuBvsLI;EACE,WAAA;AvBysLN;AuBvsLI;EACE,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,SAAA;AvBysLN;AuBvsLI;EACE,kBAAA;EACA,WAAA;AvBysLN;AuBvsLI;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AvBysLN;AuBxsLM;EACE,YAAA;EACA,aAAA;AvB0sLR;AuBxsLM;EACE,eAAA;AvB0sLR;AuBxsLM;EACE,eAAA;AvB0sLR;AuBxsLM;EACE,kBAAA;EACA,WAAA;AvB0sLR;AuBxsLM;EACE,kBAAA;AvB0sLR;;AuBnsLE;EACE,sCAAA;AvBssLJ;AuBpsLE;EACE,sCAAA;AvBssLJ;AuBpsLE;EACE,wCAAA;AvBssLJ;AuBrsLI;EACE,wCAAA;AvBusLN;AuBrsLI;EACE,mCAAA;AvBusLN;AuBpsLE;EACE,gBAAA;EACA,aAAA;AvBssLJ;AuBpsLE;EACE,6BAAA;AvBssLJ;;AwB/7LA;;oDAAA;AAGA;EACE;IACE,iBAAA;ExBk8LF;EwBh8LA;IACE,WAAA;IACA,YAAA;ExBk8LF;EwBh8LA;IACE,kBAAA;IACA,UAAA;IACA,aAAA;ExBk8LF;EwBh8LA;IACE,YAAA;IACA,WAAA;ExBk8LF;EwBh8LA;IACE,aAAA;ExBk8LF;EwBh8LA;IACE,QAAA;ExBk8LF;EwBh8LA;IACE,iBAAA;ExBk8LF;EwBh8LA;IACE,UAAA;IACA,UAAA;IACA,YAAA;ExBk8LF;EwBh8LA;IACE,iBAAA;ExBk8LF;EwBh8LA;IACE,gBAAA;ExBk8LF;EwBh8LA;IACE,4BAAA;ExBk8LF;EwBh8LA;IACE,4BAAA;ExBk8LF;AACF;AwBh8LA;EACE;IACE,kBAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;ExBk8LF;EwBh8LA;IACE,kBAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;ExBk8LF;EwBh8LA;IACE,WAAA;IACA,YAAA;ExBk8LF;AACF;AwBh8LA;EACE;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,aAAA;ExBk8LF;EwBh8LA;IACE,kBAAA;ExBk8LF;EwBh8LA;IACE,iBAAA;ExBk8LF;EwBh8LA;IACE,aAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,aAAA;IACA,iBAAA;ExBk8LF;EwBh8LA;IACE,aAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,kBAAA;ExBk8LF;EwBh8LA;IACE,iBAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,aAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,UAAA;ExBk8LF;AACF;AwBh8LA;EACE;IACE,eAAA;ExBk8LF;EwBh8LA;IACE,iBAAA;ExBk8LF;EwBh8LA;IACE,eAAA;ExBk8LF;EwBh8LA;IAKE,gBAAA;ExB87LF;EwB57LA;IAKE,SAAA;ExB07LF;EwBx7LA;IACE,aAAA;IACA,eAAA;ExB07LF;EwBx7LA;IACE,SAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,MAAA;ExB07LF;EwBx7LA;IACE,aAAA;IACA,cAAA;IACA,gBAAA;ExB07LF;EwBx7LA;;IAEE,eAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,WAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,6BAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,kBAAA;IACA,uCAAA;ExB07LF;EwBx7LA;IACE,UAAA;IACA,YAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;AACF;AwBx7LA;EACE;IACE,eAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;AACF;AwBx7LA;EACE;IACE,WAAA;IACA,YAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,YAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,eAAA;IACA,mBAAA;ExB07LF;EwBx7LA;IACE,kBAAA;IACA,mBAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,gBAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,kBAAA;IACA,QAAA;IACA,YAAA;IACA,YAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,UAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,WAAA;ExB07LF;EwBx7LA;IACE,UAAA;ExB07LF;EwBx7LA;IACE,eAAA;ExB07LF;EwBx7LA;IACE,eAAA;IACA,WAAA;ExB07LF;EwBx7LA;IACE,gBAAA;IACA,WAAA;IACA,kBAAA;IACA,QAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,6BAAA;ExB07LF;EwBx7LA;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;ExB07LF;EwBx7LA;IACE,gBAAA;ExB07LF;EwBx7LA;IACE,kBAAA;ExB07LF;EwBx7LA;IACE,cAAA;IACA,aAAA;ExB07LF;EwBx7LA;IACE,mBAAA;ExB07LF;EwBx7LA;IACE,cAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,aAAA;ExB07LF;EwBx7LA;IACE,UAAA;ExB07LF;EwBx7LA;IACE,0BAAA;ExB07LF;EwBx7LA;IACE,WAAA;ExB07LF;EwBx7LA;IACE,mBAAA;ExB07LF;EwBx7LA;IACE,YAAA;ExB07LF;EwBx7LA;IACE,WAAA;IACA,WAAA;ExB07LF;AACF;AwBx7LA;EACE;;IAEE,eAAA;ExB07LF;EwBx7LA;IACE,4BAAA;ExB07LF;EwBx7LA;IACE,WAAA;ExB07LF;AACF;AwBv7LA;EACE;IACE,iBAAA;ExBy7LF;AACF;AwBv7LA;EACE;IACE,iBAAA;IACA,cAAA;ExBy7LF;AACF;AwBv7LA;EACE;IACE,iBAAA;ExBy7LF;AACF;ACpxMA;EACI,sBAAA;EACA,4CAAA;ADsxMJ;ACnxMA;EACI,iCAAA;ADqxMJ","sourcesContent":["$animation-speed: .3s;\n$animation-function: ease-out;\n$backdrop-color: rgba(0, 0, 0, .5);\n\n@keyframes modal-video {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes modal-video-inner {\n\tfrom {\n\t\ttransform: translate(0, 100px);\n\t}\n\n\tto {\n\t\ttransform: translate(0, 0);\n\t}\n}\n\n.modal-video {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: $backdrop-color;\n\tz-index: 1000000;\n\tcursor: pointer;\n\topacity: 1;\n\tanimation-timing-function: $animation-function;\n\tanimation-duration: $animation-speed;\n\tanimation-name: modal-video;\n\t-webkit-transition: opacity $animation-speed $animation-function;\n\t-moz-transition: opacity $animation-speed $animation-function;\n\t-ms-transition: opacity $animation-speed $animation-function;\n\t-o-transition: opacity $animation-speed $animation-function;\n\ttransition: opacity $animation-speed $animation-function;\n}\n\n.modal-video-effect-exit {\n\topacity: 0;\n\n\t& .modal-video-movie-wrap {\n\t\t-webkit-transform: translate(0, 100px);\n\t\t-moz-transform: translate(0, 100px);\n\t\t-ms-transform: translate(0, 100px);\n\t\t-o-transform: translate(0, 100px);\n\t\ttransform: translate(0, 100px);\n\t}\n}\n\n.modal-video-body {\n\tmax-width: 960px;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0 auto;\n\tpadding: 0 10px;\n    display: flex;\n    justify-content: center;\n\tbox-sizing: border-box;\n}\n\n.modal-video-inner {\n\tdisplay: flex;\n    justify-content: center;\n    align-items: center;\n\twidth: 100%;\n\theight: 100%;\n\n    @media (orientation: landscape) {\n        padding: 10px 60px;\n        box-sizing: border-box;\n    }\n}\n\n.modal-video-movie-wrap {\n\twidth: 100%;\n\theight: 0;\n\tposition: relative;\n\tpadding-bottom: 56.25%;\n\tbackground-color: #333;\n\tanimation-timing-function: $animation-function;\n\tanimation-duration: $animation-speed;\n\tanimation-name: modal-video-inner;\n\t-webkit-transform: translate(0, 0);\n\t-moz-transform: translate(0, 0);\n\t-ms-transform: translate(0, 0);\n\t-o-transform: translate(0, 0);\n\ttransform: translate(0, 0);\n\t-webkit-transition: -webkit-transform $animation-speed $animation-function;\n\t-moz-transition: -moz-transform $animation-speed $animation-function;\n\t-ms-transition: -ms-transform $animation-speed $animation-function;\n\t-o-transition: -o-transform $animation-speed $animation-function;\n\ttransition: transform $animation-speed $animation-function;\n\n\t& iframe {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.modal-video-close-btn {\n\tposition: absolute;\n\tz-index: 2;\n\ttop: -45px;\n\tright: 0px;\n\tdisplay: inline-block;\n\twidth: 35px;\n\theight: 35px;\n\toverflow: hidden;\n\tborder: none;\n\tbackground: transparent;\n\n    @media (orientation: landscape) {\n        top: 0;\n        right: -45px;\n    }\n\n\t&:before {\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&:after {\n\t\ttransform: rotate(-45deg);\n\t}\n\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\theight: 2px;\n\t\twidth: 100%;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\tmargin-top: -1px;\n\t\tbackground: #fff;\n\t\tborder-radius: 5px;\n\t\tmargin-top: -6px;\n\t}\n}\n","// Plugin CSS\n@import \"~bootstrap/dist/css/bootstrap.min.css\";\n@import \"~animate.css\";\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n@import \"node_modules/react-modal-video/scss/modal-video.scss\";\n\n// Init main SCSS File\n@import \"/public/assets/scss/style.scss\";\n","/*\nTheme Name: AgileTech\nTheme URI: http://wowtheme7.com/html/agiletech\nAuthor: wowtheme7\nAuthor URI: http://wowtheme7.com\nDescription: AglieTech - IT Solutions & Technology Html5 Template\nVersion: 1.0.0\n*/\n/*--------------------------------------------------------------\n>>> TABLE OF CONTENTS:\n----------------------------------------------------------------\n# Global\n    ## Global\n    ## Mixins\n    ## Theme\n    ## Variables\n    ## Common\n\n# Sections\n    ## Nav Bar\n    ## Banner\n    ## Brand Area\n    ## Footer\n    ## Widgets\n\n# Elements\n    ## accordion\n    ## filter\n    ## apartment\n    ## blog\n    ## city\n    ## feature\n    ## gallery\n    ## intro\n    ## main-search\n    ## pricing\n    ## service\n    ## team\n    ## user-list\n\n--------------------------------------------------------------*/\n\n//== Global Design\n@import \"global/_mixins\";\n@import \"global/_variables\";\n@import \"global/_global\";\n@import \"global/_common\";\n@import \"global/_animate\";\n\n//== Pages\n//== Sections\n@import \"sections/_section-title\";\n@import \"sections/_navbar\";\n@import \"sections/_banner\";\n@import \"sections/_about\";\n@import \"sections/_service\";\n@import \"sections/_work-process\";\n@import \"sections/_team\";\n@import \"sections/_pricing\";\n@import \"sections/_case-study\";\n@import \"sections/_content\";\n@import \"sections/_testimonial\";\n@import \"sections/_section-style\";\n@import \"sections/_search\";\n@import \"sections/_widgets\";\n@import \"sections/_blog\";\n@import \"sections/project\";\n@import \"sections/_footer\";\n@import \"sections/_responsive\";\n\n\n@font-face {\n    font-family: yekanBakh;\n    src: url(\"../../fonts/YekanBakh-Regular/@font-face/7296ae79f6faca68798b00fbbbee4c22.ttf\");\n}\n\n* {\n    font-family: yekanBakh !important   ;\n}","\n//== Template Main Color\n$color-white : #fff;\n\n//== social media colors\n$facebook: #3b5999;\n$twitter: #55acee;\n$instagram: #e4405f;\n$youtube: #cd201f;\n$pinterest: #bd081c;\n\n/*-----------------\n    # Typography\n-----------------*/\n@import url(\"https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans:400,500,600,700&display=swap\");\n\n//  transition\n$transition: all .3s ease-in;\n$transition-long: all .5s ease-in;\n$box-shadow: 0px 3px 20px rgba(0, 33, 71, 0.06);\n$box-shadow2: 0px 10px 30px rgba(0, 33, 71, 0.08);\n",":root {\n    --main-color: #246BFD;\n    --main-color2: #EE0020;\n    --heading-color: #101A29;\n    --paragraph-color: #737588;\n    --body-font: 'Plus Jakarta Sans', sans-serif;\n    --heading-font: 'Plus Jakarta Sans', sans-serif;\n    --body-font-size: 16px;\n    --line-height30: 1.7;\n}\n\nhtml {\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    overflow-x: hidden;\n    font-family: var(--body-font);\n}\n\n* {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    outline: none;\n    -moz-osx-font-smoothing: grayscale;\n    /* Firefox */\n    -webkit-font-smoothing: antialiased;\n    /* WebKit  */\n}\n\nbody {\n    margin: 0;\n    color: var(--paragraph-color);\n    overflow-x: hidden;\n    font-family: var(--body-font);\n    line-height: var(--line-height30);\n    font-size: var(--body-font-size);\n    background: #fff;\n    font-weight: 500;\n}\n\nh1 {\n    font-size: 75px;\n    line-height: 1.2333333333333333;\n}\n\nh2 {\n    font-size: 40px;\n    line-height: 1.2380952380952381;\n}\n\nh3 {\n    font-size: 30px;\n    line-height: 1.3833333333333333;\n}\n\nh4 {\n    font-size: 24px;\n    line-height: 1.3380952380952381;\n}\nh5 {\n    font-size: 20px;\n    line-height: 1.3380952380952381;\n}\nh6 {\n    font-size: 16px;\n    line-height: 1.2380952380952381;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    color: var(--heading-color);\n    font-weight: 600;\n    font-family: var(--heading-font);\n}\n\np {\n    color: var(--paragraph-color);\n    -webkit-hyphens: auto;\n    -moz-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n    margin-bottom: 10px;\n}\n\na {\n    color: inherit;\n    text-decoration: none;\n    transition: 0.4s;\n}\n\na,\na:hover,\na:focus,\na:active {\n    text-decoration: none;\n    outline: none;\n    color: inherit;\n}\na:hover {\n    color: var(--main-color);\n}\npre {\n    word-break: break-word;\n}\n\na i {\n    padding: 0 2px;\n}\n\nimg {\n    max-width: 100%;\n}\n\nbutton:hover,\nbutton:active,\nbutton:focus {\n    outline: 0;\n}\n\n/*input and button type focus outline disable*/\n\ninput[type=\"text\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"url\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"search\"]:focus,\ninput[type=\"tel\"]:focus,\ninput[type=\"number\"]:focus,\ntextarea:focus,\ninput[type=\"button\"]:focus,\ninput[type=\"reset\"]:focus,\ninput[type=\"submit\"]:focus,\nselect:focus {\n    outline: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    border: 1px solid #ddd;\n}\n\n.no-gutter.row,\n.no-gutter.container,\n.no-gutter.container-fluid{\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.no-gutter>[class^=\"col-\"]{\n  padding-left: 0;\n  padding-right: 0;\n}\n.no-gutter[class^=\"col-\"]{\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n.h-100vh {\n    height: 100vh;\n}\n\ncode {\n    color: #faa603;\n}\n\n.check-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    li {\n        display: block;\n        padding-left: 20px;\n        position: relative;\n        z-index: 0;\n        &:after {\n            position: absolute;\n            left: 0;\n            top: 0;\n            font-family: 'fontawesome';\n            content: \"\\f105\";\n            color: var(--main-color);\n        }\n    }\n}\n\n.site-main .comment-navigation,\n.site-main .posts-navigation,\n.site-main .post-navigation {\n    clear: both;\n}\n\n.comment-navigation .nav-previous,\n.posts-navigation .nav-previous,\n.post-navigation .nav-previous {\n    float: left;\n    width: 50%;\n}\n\n.comment-navigation .nav-next,\n.posts-navigation .nav-next,\n.post-navigation .nav-next {\n    float: right;\n    text-align: right;\n    width: 50%;\n}\n\n.comment-navigation .nav-previous>a,\n.posts-navigation .nav-previous>a,\n.post-navigation .nav-previous>a,\n.comment-navigation .nav-next>a,\n.posts-navigation .nav-next>a,\n.post-navigation .nav-next>a {\n    transition: .3s ease-in;\n}\n\n.comment-navigation .nav-previous:hover>a,\n.posts-navigation .nav-previous:hover>a,\n.post-navigation .nav-previous:hover>a,\n.comment-navigation .nav-next:hover>a,\n.posts-navigation .nav-next:hover>a,\n.post-navigation .nav-next:hover>a {\n    color: var(--main-color);\n}\n\n.comment-list li {\n    list-style: none;\n}\n\n.h-100vh {\n    height: 100vh;\n}\n\n.position-relative {\n    position: relative;\n}\n\n/*--------------------------------------------------------------\n# Accessibility\n--------------------------------------------------------------*/\n\n\n/* Text meant only for screen readers. */\n\n.screen-reader-text {\n    border: 0;\n    clip: rect(1px, 1px, 1px, 1px);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute !important;\n    width: 1px;\n    word-wrap: normal !important;\n    /* Many screen reader and browser combinations announce broken words as they would appear visually. */\n}\n\n.screen-reader-text:focus {\n    background-color: #f1f1f1;\n    border-radius: 3px;\n    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.6);\n    clip: auto !important;\n    clip-path: none;\n    color: #21759b;\n    display: block;\n    font-size: 15px;\n    font-size: 0.875rem;\n    font-weight: bold;\n    height: auto;\n    left: 5px;\n    line-height: normal;\n    padding: 15px 23px 14px;\n    text-decoration: none;\n    top: 5px;\n    width: auto;\n    z-index: 100000;\n    /* Above WP toolbar. */\n}\n\n\n/* Do not show the outline on the skip link target. */\n\n#content[tabindex=\"-1\"]:focus {\n    outline: 0;\n}\n\n/*--------------------------------------------------------------\n# Alignments\n--------------------------------------------------------------*/\n\n.alignleft {\n    float: left;\n    clear: both;\n    margin-right: 20px;\n}\n\n.alignright {\n    float: right;\n    clear: both;\n    margin-left: 20px;\n}\n\n.aligncenter {\n    clear: both;\n    display: block;\n    margin: 0 auto 1.75em;\n}\n\n.alignfull {\n    margin: 1.5em 0;\n    max-width: 100%;\n}\n\n.alignwide {\n    max-width: 1100px;\n}\n\n\n/*--------------------------------------------------------------\n# Clearings\n--------------------------------------------------------------*/\n\n.clear:before,\n.clear:after,\n.entry-content:before,\n.entry-content:after,\n.comment-content:before,\n.comment-content:after,\n.site-header:before,\n.site-header:after,\n.site-content:before,\n.site-content:after,\n.site-footer:before,\n.site-footer:after {\n    content: \"\";\n    display: table;\n    table-layout: fixed;\n}\n\n.clear:after,\n.entry-content:after,\n.comment-content:after,\n.site-header:after,\n.site-content:after,\n.site-footer:after {\n    clear: both;\n}\n\n\n/*--------------------------------------------------------------\n## Posts and pages\n--------------------------------------------------------------*/\n\n.sticky {\n    display: block;\n}\n\n.updated:not(.published) {\n    display: none;\n}\n\n/*--------------------------------------------------------------\n# Media\n--------------------------------------------------------------*/\n\n.page-content .wp-smiley,\n.entry-content .wp-smiley,\n.comment-content .wp-smiley {\n    border: none;\n    margin-bottom: 0;\n    margin-top: 0;\n    padding: 0;\n}\n\n\n/* Make sure embeds and iframes fit their containers. */\n\nembed,\niframe,\nobject {\n    max-width: 100%;\n}\n\n\n/* Make sure logo link wraps around logo image. */\n\n.custom-logo-link {\n    display: inline-block;\n}\n\n\n/*--------------------------------------------------------------\n## Captions\n--------------------------------------------------------------*/\n\n.wp-caption {\n    margin-bottom: 1.5em;\n    max-width: 100%;\n    clear: both;\n}\n\n.wp-caption img[class*=\"wp-image-\"] {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.wp-caption .wp-caption-text {\n    margin: 0.8075em 0;\n}\n\n.wp-caption-text {\n    text-align: center;\n}\n\n/*----------------------------------------\n    # Unit test\n------------------------------------------*/\n\n.wp-link-pages a {\n    margin: 0 5px;\n    transition: .3s ease-in;\n}\n\n.wp-link-pages {\n    margin-bottom: 30px;\n    margin-top: 25px;\n}\n\n.wp-link-pages span,\n.wp-link-pages a {\n    border: 1px solid #e2e2e2;\n    padding: 5px 15px;\n    display: inline-block;\n}\n\n.wp-link-pages .current,\n.wp-link-pages a:hover {\n    background-color: var(--main-color);\n    color: #fff;\n    border-color: var(--main-color);\n}\n\n.wp-link-pages span:first-child {\n    margin-right: 5px;\n}\n\ndl,\nol,\nul {\n    padding-left: 17px;\n}\n\n.post-password-form input {\n    display: block;\n    border: 1px solid #e2e2e2;\n    height: 50px;\n    border-radius: 3px;\n    padding: 0 20px;\n}\n\n.post-password-form label {\n    font-weight: 600;\n    color: #333;\n}\n\n.post-password-form input[type=submit] {\n    width: 100px;\n    height: 50px;\n    background-color: var(--main-color);\n    color: #fff;\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    border: none;\n    cursor: pointer;\n    transition: .3s ease-in;\n}\n\n.post-password-form input[type=submit]:hover {\n    background-color: #121A2F;\n}\n\n.footer-widget .table td,\n.footer-widget .table th {\n    padding: 0.50rem !important;\n}\n\n.media {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n}\n.media-body {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.custom-gutters-10 > .col,\n.custom-gutters-10 > [class*=col-] {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n\n@media all and (min-width: 1200px) {\n    .no-lg-gutters>.col, \n    .no-lg-gutters>[class*=col-] {\n        padding-right: 0;\n        padding-left: 0;\n    }\n}\n","/*---------------------------------------\n    ## Button\n---------------------------------------*/\n.btn {\n  height: 55px;\n  line-height: 55px;\n  padding: 0 30px;\n  border-radius: 0;\n  overflow: hidden;\n  position: relative;\n  border: 0;\n  @include transition(all, 0.5s, ease);\n  font-weight: 600;\n  border-radius: 30px;\n  z-index: 0;\n  &:focus,\n  &:active {\n    outline: 0;\n    box-shadow: none;\n  }\n  &:after {\n    content: \"\";\n    background: var(--heading-color);\n    position: absolute;\n    transition: $transition;\n    z-index: -1;\n    height: 100%;\n    left: -35%;\n    top: 0;\n    transform: skew(30deg);\n    transition-duration: 0.6s;\n    transform-origin: top left;\n    width: 0;\n  }\n  &:hover {\n    &:after {\n      height: 100%;\n      width: 135%;\n    }\n  }\n  i {\n    font-size: 14px;\n    float: right;\n    padding-top: 16px;\n    padding-left: 5px;\n  }\n  svg {\n    font-size: 12px;\n    margin-top: 20px;\n    margin-left: 6px;\n    float: right;\n  }\n  &.border-radius-0 {\n    border-radius: 0;\n  }\n  &.border-radius-5 {\n    border-radius: 5px;\n  }\n}\n.btn-small {\n  height: 50px;\n  line-height: 50px;\n  i {\n    padding-top: 12px;\n  }\n}\n.btn-base {\n  color: #fff;\n  background: var(--main-color);\n  &:hover {\n    color: #fff;\n  }\n}\n.btn-red {\n  color: #fff;\n  background: #f14d5d;\n  &:hover {\n    color: #fff;\n  }\n}\n.btn-white {\n  color: var(--main-color) !important;\n  background: #fff;\n  &:hover,\n  &:focus {\n    color: #fff !important;\n    background: var(--main-color);\n  }\n}\n.btn-black {\n  color: #fff !important;\n  background: var(--heading-color);\n  &:hover,\n  &:focus {\n    color: #fff !important;\n    background: var(--main-color);\n  }\n}\n.btn-black.sky {\n  color: #fff !important;\n  background: var(--heading-color);\n  &:hover,\n  &:focus {\n    color: #fff !important;\n    background: #50af9b;\n  }\n}\n.btn-border-base {\n  color: var(--heading-color);\n  border: 2px solid var(--main-color);\n  line-height: 52px;\n  &:after {\n    background: var(--main-color);\n  }\n  &:hover,\n  &:focus {\n    color: #fff;\n  }\n}\n.btn-border-base-2 {\n  color: #50af9b;\n  border: 2px solid#50AF9B;\n  line-height: 52px;\n  &:after {\n    background: #50af9b;\n  }\n  &:hover,\n  &:focus {\n    color: #fff;\n  }\n}\n.btn-border-white {\n  color: #fff;\n  border: 2px solid rgba(255, 255, 255, 0.7);\n  line-height: 53px;\n  &:hover,\n  &:focus {\n    color: #fff;\n    background: var(--main-color);\n    border: 2px solid var(--main-color);\n  }\n}\n.btn-border-black {\n  color: #a2a2a2;\n  border: 2px solid #d4d4d4;\n  line-height: 53px;\n  &:hover,\n  &:focus {\n    color: #fff;\n    background: var(--main-color);\n    border: 2px solid var(--main-color);\n  }\n  &:after {\n    background: var(--main-color);\n  }\n}\n.btn-border-black-2 {\n  color: #262626;\n  border: 2px solid #262626;\n  line-height: 53px;\n  &:hover,\n  &:focus {\n    color: #fff;\n    background: var(--main-color);\n    border: 2px solid var(--main-color);\n  }\n  &:after {\n    background: var(--main-color);\n  }\n}\n.btn-border-gray {\n  color: var(--heading-color);\n  border: 2px solid #e3e3e3;\n  line-height: 51px;\n  background: #f8f9fc;\n  &:hover,\n  &:focus {\n    color: #fff;\n    background: var(--main-color);\n    border: 2px solid var(--heading-color);\n  }\n}\n\n.btn-base-color {\n  color: #fff !important;\n  background: #50af9b;\n}\n\n.read-more-text {\n  position: relative;\n  color: var(--heading-color);\n  font-weight: 600;\n  i {\n    font-size: 18px;\n    position: absolute;\n    top: 1px;\n    margin-left: 3px;\n    transition: 0.4s;\n  }\n  svg {\n    font-size: 12px;\n    position: absolute;\n    top: 5px;\n    margin-left: 6px;\n    transition: 0.4s;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background: var(--main-color);\n    height: 1px;\n    width: 0;\n    transition: 0.4s;\n    visibility: hidden;\n    opacity: 0;\n  }\n  &:hover {\n    i {\n      padding-left: 6px;\n    }\n    &:after {\n      width: 100%;\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n}\n\n.read-more-arrow {\n  height: 35px;\n  width: 35px;\n  line-height: 35px;\n  color: #fff;\n  text-align: center;\n  background: var(--main-color);\n  border-radius: 50%;\n  display: inline-block;\n  &:hover {\n    background: #0a1851;\n    color: #fff;\n  }\n}\n\n/*------------------------------------------------\n    ## Back Top\n------------------------------------------------*/\n.back-to-top {\n  position: fixed;\n  right: 30px;\n  bottom: 30px;\n  width: 44px;\n  height: 44px;\n  color: $color-white;\n  background-color: var(--main-color);\n  text-align: center;\n  line-height: 44px;\n  z-index: 99;\n  font-size: 25px;\n  cursor: pointer;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  display: none;\n  animation: backto-top-bounce 4s infinite ease-in-out;\n}\n@-webkit-keyframes backto-top-bounce {\n  0% {\n    -webkit-transform: translateY(-4px);\n    transform: translateY(-5px);\n  }\n  50% {\n    -webkit-transform: translateY(8px);\n    transform: translateY(10px);\n  }\n  100% {\n    -webkit-transform: translateY(-4px);\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes backto-top-bounce {\n  0% {\n    -webkit-transform: translateY(-4px);\n    transform: translateY(-5px);\n  }\n  50% {\n    -webkit-transform: translateY(8px);\n    transform: translateY(10px);\n  }\n  100% {\n    -webkit-transform: translateY(-4px);\n    transform: translateY(-5px);\n  }\n}\n\n/*-----------------------------------------\n    ## Preloader Css\n-------------------------------------------*/\n.pre-wrap {\n  position: fixed;\n  content: \"\";\n  transform: translate(-100%, -240%);\n  font-size: 62px;\n}\n.preloader-inner {\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 999999999999;\n  background-color: #030724;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .cancel-preloader {\n    position: absolute;\n    bottom: 30px;\n    right: 30px;\n    a {\n      background-color: $color-white;\n      font-weight: 600;\n      text-transform: capitalize;\n      color: var(--main-color);\n      width: 200px;\n      height: 50px;\n      text-align: center;\n      line-height: 50px;\n      border-radius: 30px;\n      display: block;\n      @include transition(all, 0.4s, ease);\n      &:hover {\n        background-color: var(--heading-color);\n        color: $color-white;\n      }\n    }\n  }\n}\n.spinner {\n  margin: 120px auto;\n  width: 60px;\n  height: 60px;\n  position: relative;\n  text-align: center;\n\n  -webkit-animation: sk-rotate 2s infinite linear;\n  animation: sk-rotate 2s infinite linear;\n}\n\n.dot1,\n.dot2 {\n  width: 60%;\n  height: 60%;\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  background-color: var(--main-color);\n  border-radius: 100%;\n  -webkit-animation: sk-bounce 2s infinite ease-in-out;\n  animation: sk-bounce 2s infinite ease-in-out;\n}\n\n.dot2 {\n  top: auto;\n  bottom: 0;\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n@-webkit-keyframes sk-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes sk-rotate {\n  100% {\n    transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes sk-bounce {\n  0%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n  50% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes sk-bounce {\n  0%,\n  100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n\n/*-----------------------------------------\n    ## video\n------------------------------------------*/\n.video-thumb {\n  position: relative;\n  .video-play-btn-hover {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 2;\n  }\n}\n.video-play-btn {\n  border-radius: 50%;\n  background: #fff;\n  width: 50px;\n  height: 50px;\n  display: inline-block;\n  line-height: 50px;\n  position: relative;\n  z-index: 0;\n  text-align: center;\n  animation: ripple-white3 2.5s linear infinite;\n  z-index: 3;\n  box-shadow: 0 4px 15px rgba(19, 16, 34, 0.1);\n  &:after {\n    z-index: -1;\n    content: \"\";\n    position: absolute;\n    width: 110px;\n    height: 110px;\n    border-radius: 50%;\n    background: rgba(247, 247, 247, 0.4);\n    top: -15px;\n    left: -15px;\n  }\n  i {\n    color: var(--main-color);\n    margin-left: 6px;\n    font-size: 28px;\n  }\n  &.video-play-btn-base {\n    background: var(--main-color);\n    i {\n      color: #fff;\n    }\n    &:after {\n      display: none;\n    }\n  }\n  &.small {\n    width: 55px;\n    height: 55px;\n    line-height: 60px;\n    i {\n      font-size: 18px;\n    }\n  }\n}\n\n/*-----------------------------------------\n    ## Breadcumb\n------------------------------------------*/\n.breadcrumb-area {\n  padding: 222px 0 108px;\n  position: relative;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  margin-top: -120px;\n  .banner-bg-img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0%;\n    left: 0%;\n    background-size: 102% 96%;\n  }\n  .breadcrumb-inner {\n    position: relative;\n    z-index: 2;\n  }\n  .page-title {\n    font-size: 40px;\n    font-weight: 700;\n    margin-bottom: 5px;\n  }\n  .page-list {\n    margin: 0;\n    padding: 0;\n    li {\n      font-weight: 600;\n      list-style: none;\n      display: inline-block;\n      position: relative;\n      color: var(--heading-color);\n\n      &:first-child {\n        padding-left: 0;\n        margin-left: 0;\n        &:after {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n/********* social-media *********/\n.social-media {\n  padding: 0;\n  margin: 0;\n  position: relative;\n  z-index: 2;\n  li {\n    display: inline-block;\n    margin: 0 2px;\n    a {\n      height: 30px;\n      width: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 5px;\n      display: inline-block;\n      background: #333f4d;\n      color: #fff;\n      font-size: 13px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n      &.facebook {\n        color: $facebook;\n        border-color: $facebook;\n      }\n      &.twitter {\n        color: $twitter;\n        border-color: $twitter;\n      }\n      &.instagram {\n        color: $instagram;\n        border-color: $instagram;\n      }\n      &.youtube {\n        color: $youtube;\n        border-color: $youtube;\n      }\n    }\n    &:first-child {\n      margin-left: 0;\n    }\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n.social-media-light {\n  a {\n    background: rgba(253, 74, 54, 0.15);\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    border-radius: 50%;\n    text-align: center;\n    line-height: 31px;\n    i {\n      color: var(--main-color);\n      font-size: 15px;\n      transition: 0.4s;\n    }\n    &:hover {\n      background: var(--main-color);\n      i {\n        color: #fff;\n      }\n    }\n  }\n}\n\n/********* slider-control *********/\n.slider-control-round {\n  .slick-slider {\n    .slick-next {\n      height: 46px;\n      width: 46px;\n      line-height: 44px;\n      margin: 0 10px;\n      border-radius: 50%;\n      border: 0;\n      transition: 0.4s;\n      box-shadow: none;\n      color: var(--heading-color);\n      border: 1px solid var(--main-color);\n      padding: 9px;\n      cursor: pointer;\n      font-size: 18px;\n      background: transparent;\n      position: absolute;\n      right: 0;\n      top: -95px;\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n    .slick-prev {\n      left: 0;\n      height: 46px;\n      width: 46px;\n      line-height: 44px;\n      margin: 0 10px;\n      border-radius: 50%;\n      border: 0;\n      transition: 0.4s;\n      box-shadow: none;\n      color: var(--heading-color);\n      border: 1px solid var(--main-color);\n      padding: 9px;\n      cursor: pointer;\n      font-size: 18px;\n      background: transparent;\n      position: absolute;\n      left: unset;\n      top: -95px;\n      right: 60px;\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n  }\n}\n.slider-control-square {\n  .slick-slider {\n    .slick-next {\n      height: 46px;\n      width: 46px;\n      line-height: 44px;\n      margin: 0 10px;\n      border-radius: 8px;\n      border: 0;\n      transition: 0.4s;\n      box-shadow: none;\n      color: #fff;\n      border: 1px solid #50af9b;\n      padding: 9px;\n      cursor: pointer;\n      font-size: 18px;\n      background: transparent;\n      position: absolute;\n      right: 0;\n      top: -95px;\n      &:hover {\n        background: #50af9b;\n        color: #fff;\n      }\n    }\n    .slick-prev {\n      left: 0;\n      height: 46px;\n      width: 46px;\n      line-height: 44px;\n      margin: 0 10px;\n      border-radius: 8px;\n      border: 0;\n      transition: 0.4s;\n      box-shadow: none;\n      color: #fff;\n      border: 1px solid #50af9b;\n      padding: 9px;\n      cursor: pointer;\n      font-size: 18px;\n      background: transparent;\n      position: absolute;\n      left: unset;\n      top: -95px;\n      right: 60px;\n      &:hover {\n        background: #50af9b;\n        color: #fff;\n      }\n    }\n  }\n}\n\n.slider-control-square {\n  .owl-nav {\n    button {\n      height: 45px;\n      width: 60px;\n      line-height: 46px;\n      margin: 0 8px;\n      border-radius: 0;\n      border: 1px solid var(--main-color);\n      transition: 0.4s;\n      box-shadow: none;\n      color: var(--main-color);\n      background: transparent;\n      font-size: 20px;\n      padding: 0;\n      cursor: pointer;\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n    .owl-prev {\n      margin-left: 0;\n    }\n    .owl-next {\n      margin-left: 0;\n    }\n  }\n}\n\n.slider-control-right-top {\n  .owl-nav {\n    position: absolute;\n    right: 0;\n    top: -95px;\n  }\n}\n\n.slider-control-dots {\n  .owl-dots {\n    text-align: center;\n    padding-top: 23px;\n    .owl-dot {\n      margin: 0 2px;\n      border: 0;\n      background: none;\n      span {\n        display: block;\n        border-radius: 50%;\n        background-color: var(--heading-color);\n        width: 8px;\n        height: 8px;\n        position: relative;\n        @include transition(all, 0.3s, ease);\n        &:after {\n          position: absolute;\n          content: \"\";\n          top: -5px;\n          left: -5px;\n          border: 1px solid var(--main-color);\n          border-radius: 50%;\n          width: calc(100% + 10px);\n          height: calc(100% + 10px);\n          transform: scale(0);\n          @include transition(all, 0.3s, ease);\n        }\n      }\n      &.active span {\n        background: var(--main-color);\n        &:after {\n          transform: scale(1);\n        }\n      }\n      &:focus {\n        outline: 0;\n      }\n    }\n  }\n}\n\n.single-list-inner {\n  margin: 0;\n  padding: 0;\n  li {\n    margin-bottom: 6px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  &.style-check {\n    li {\n      list-style: none;\n      svg,\n      i {\n        margin-right: 10px;\n        color: var(--main-color);\n        font-size: 18px;\n      }\n      .sky {\n        color: #50af9b;\n      }\n    }\n  }\n  &.style-heading {\n    li {\n      color: var(--heading-color);\n      font-weight: 600;\n    }\n  }\n}\n\n/*--------------------------------------------------------------\n# Globals\n--------------------------------------------------------------*/\n.border-radius-6 {\n  border-radius: 6px;\n  img {\n    border-radius: 6px;\n  }\n}\n.ratting-inner {\n  color: #ffc107;\n}\n.bg-base {\n  background: var(--main-color);\n}\n.bg-base-2 {\n  background: #50af9b !important;\n}\n.bg-green {\n  background: #1dc295;\n}\n.bg-blue {\n  background: #2878eb;\n}\n.bg-red {\n  background: #f14d5d;\n}\n.bg-gray {\n  background: #f8f9fc;\n}\n.bg-sky {\n  background: #f9f9f9;\n}\n.bg-gradient-gray {\n  background-image: linear-gradient(#f8f9fc, #d9e5ff);\n}\n.bg-black {\n  background: var(--heading-color);\n}\n.bg-light {\n  background: #f7fafc;\n}\n.bg-light-pink {\n  background: #fff9f5;\n}\n.bg-relative {\n  position: relative;\n}\n.bg-cover {\n  background-size: cover !important;\n  background-position: center;\n}\n.bg-position-right {\n  background-position: right;\n  background-repeat: no-repeat;\n}\n.bg-left-50 {\n  background-position: left;\n  background-repeat: no-repeat;\n  background-size: 50% 100%;\n}\n.bg-overlay {\n  position: relative;\n  background-size: cover !important;\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    background: rgba(10, 24, 81, 0.88);\n  }\n  .container {\n    position: relative;\n    z-index: 2;\n  }\n  .bg-z-index {\n    position: relative;\n    z-index: 2;\n  }\n}\n.bg-overlay-light {\n  position: relative;\n  background-size: cover !important;\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    background: rgba(10, 24, 81, 0.5);\n  }\n  .container {\n    position: relative;\n    z-index: 2;\n  }\n  .bg-z-index {\n    position: relative;\n    z-index: 2;\n  }\n}\n.bg-parallex {\n  background-attachment: fixed;\n  background-position: center 0;\n}\n.image-hover-animate {\n  overflow: hidden;\n  img {\n    transform: scale(1.02);\n    transition: 0.7s;\n  }\n  &:hover {\n    img {\n      transform: scale(1.1);\n    }\n  }\n}\n.box-shadow {\n  box-shadow: 0px 8px 30px rgb(0 0 0 / 10%);\n}\n\n.pd-top-60 {\n  padding-top: 60px;\n}\n.pd-top-90 {\n  padding-top: 90px;\n}\n.pd-top-100 {\n  padding-top: 100px;\n}\n.pd-top-110 {\n  padding-top: 110px;\n}\n.pd-top-115 {\n  padding-top: 115px;\n}\n.pd-top-120 {\n  padding-top: 120px;\n}\n.pd-top-200 {\n  padding-top: 200px;\n}\n\n.mg-top-120 {\n  margin-top: 120px;\n}\n.mg-bottom-120 {\n  margin-bottom: 120px;\n}\n\n.pd-bottom-60 {\n  padding-bottom: 60px;\n}\n.pd-bottom-70 {\n  padding-bottom: 70px;\n}\n.pd-bottom-80 {\n  padding-bottom: 80px;\n}\n.pd-bottom-90 {\n  padding-bottom: 90px;\n}\n.pd-bottom-100 {\n  padding-bottom: 100px;\n}\n.pd-bottom-110 {\n  padding-bottom: 110px;\n}\n.pd-bottom-115 {\n  padding-bottom: 115px;\n}\n.pd-bottom-120 {\n  padding-bottom: 120px;\n}\n\n.mg-top--82 {\n  margin-top: -100px;\n}\n.position-bottom-left {\n  position: absolute;\n  left: 30px;\n  bottom: 150px;\n  width: 50px;\n}\n.border-right-1 {\n  border-right: 1px solid #ededed;\n}\n.border-radius-20 {\n  border-radius: 20px;\n}\n.border-radius-5 {\n  border-radius: 5px;\n}\n.color-base {\n  color: var(--main-color);\n}\n\n.border-1 {\n  border: 1px solid #ededed;\n}\n.border-top-1 {\n  border-top: 1px solid #ededed;\n}\n.border-right-1 {\n  border-right: 1px solid #ededed;\n}\n.border-radius-20 {\n  border-radius: 20px;\n}\n.border-radius-5 {\n  border-radius: 5px !important;\n}\n\n.image-hover-rotate {\n  .rotate-img {\n    transition: 0.4s;\n  }\n  &:hover {\n    .rotate-img {\n      transform: rotateY(180deg);\n    }\n  }\n}\n","@mixin gradient-border-with-radius($left, $right) {\n    background-image: linear-gradient(white, white), radial-gradient(circle at top left, $left, $right);\n    background-origin: border-box;\n    background-clip: content-box, border-box;\n    @include transition($transition);\n}\n\n@mixin gradient-border($left, $right) {\n    -moz-border-image: -moz-linear-gradient(top, $left 0%, $right 100%);\n    -webkit-border-image: -webkit-linear-gradient(top, $left 0%, $right 100%);\n    border-image: linear-gradient(to bottom, $left 0%, $right 100%);\n    background-clip: padding-box;\n    border-image-slice: 1;\n}\n\n@mixin text-gradient ($left, $right) {\n    background: -webkit-linear-gradient(-25deg, $left 0%, $right 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n@mixin gradient-left-right($leftColor, $rightColor) {\n    background-image: -moz-linear-gradient( 0deg, $leftColor 0%, $rightColor 100%);\n    background-image: -webkit-linear-gradient( 0deg, $leftColor 0%, $rightColor 100%);\n    background-image: -ms-linear-gradient( 0deg, $leftColor 0%, $rightColor 100%);\n}\n\n@mixin gradient-top-bottom($from, $to) {\n    background-color: $from;\n    background-image: -moz-linear-gradient($from, $to);\n    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, from($from), to($to));\n    background-image: -webkit-linear-gradient($from, $to);\n    background-image: -o-linear-gradient($from, $to);\n}\n@mixin hostgr ($left,$right) {\n    background-image: -moz-linear-gradient( 90deg, $left 0%, $right 92%);\n    background-image: -webkit-linear-gradient( 90deg, $left 0%, $right 92%);\n    background-image: -ms-linear-gradient( 90deg, $left 0%, $right 92%);\n}\n// Single side border-radius\n@mixin border-top-radius($radius) {\n    border-top-right-radius: $radius;\n    border-top-left-radius: $radius;\n}\n\n@mixin border-right-radius($radius) {\n    border-bottom-right-radius: $radius;\n    border-top-right-radius: $radius;\n}\n\n@mixin border-bottom-radius($radius) {\n    border-bottom-right-radius: $radius;\n    border-bottom-left-radius: $radius;\n}\n\n@mixin border-left-radius($radius) {\n    border-bottom-left-radius: $radius;\n    border-top-left-radius: $radius;\n}\n\n// BORDER RADIUS\n@mixin border-radius($radius) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n//user select\n@mixin userSelect($user) {\n    -webkit-user-select: $user;\n    -moz-user-select: $user;\n    -ms-user-select: $user;\n    user-select: $user;\n}\n\n//box sizing \n@mixin box-sizing($box) {\n    box-sizing: $box;\n    -moz-box-sizing: $box;\n    -webkit-box-sizing: $box;\n}\n\n//placeholder\n@mixin placeholder {\n    ::-webkit-input-placeholder {\n        @content\n    }\n    :-moz-placeholder {\n        @content\n    }\n    ::-moz-placeholder {\n        @content\n    }\n    :-ms-input-placeholder {\n        @content\n    }\n}\n\n@mixin placeholder-color($color) {\n    &::-webkit-input-placeholder {\n        /* WebKit browsers */\n        color: $color;\n    }\n    &:-moz-placeholder {\n        /* Mozilla Firefox 4 to 18 */\n        color: $color;\n    }\n    &::-moz-placeholder {\n        /* Mozilla Firefox 19+ */\n        color: $color;\n    }\n    &:-ms-input-placeholder {\n        /* Internet Explorer 10+ */\n        color: $color;\n    }\n}\n\n@mixin placeholder-style($style) {\n    &::-webkit-input-placeholder {\n        /* WebKit browsers */\n        font-style: $style;\n    }\n    &:-moz-placeholder {\n        /* Mozilla Firefox 4 to 18 */\n        font-style: $style;\n    }\n    &::-moz-placeholder {\n        /* Mozilla Firefox 19+ */\n        font-style: $style;\n    }\n    &:-ms-input-placeholder {\n        /* Internet Explorer 10+ */\n        font-style: $style;\n    }\n}\n \n// transition\n@mixin transition($option, $time, $style: ease-in-out){\n    -webkit-transition: $option $time $style;\n    -moz-transition: $option $time $style;\n    transition: $option $time $style; \n}\n\n\n//transform\n@mixin transform($transform) {\n    -ms-transform: $transform;\n    /* IE 9 */\n    -webkit-transform: $transform;\n    /* Chrome, Safari, Opera */\n    transform: $transform;\n}\n\n// rotate\n@mixin rotate ($deg) {\n    @include transform(rotate(#{$deg}deg));\n}\n\n// scale\n@mixin scale($scale) {\n    @include transform(scale($scale));\n}\n\n// translate\n@mixin translate ($x, $y) {\n    @include transform(translate($x, $y));\n}\n\n@mixin translateX ($x) {\n    @include transform(translateX($x));\n}\n\n@mixin translateY ($y) {\n    @include transform(translateY($y));\n}\n\n// translate rotate\n@mixin translate-rotate ($x, $y, $deg) {\n    @include transform(translate($x, $y)rotate(#{$deg}deg));\n}\n\n// skew\n@mixin skew ($x, $y) {\n    @include transform(skew(#{$x}deg, #{$y}deg));\n}\n\n@mixin rotate3d($vector-x: $default-vector-x, $vector-y: $default-vector-y, $vector-z: $default-vector-z, $rotate: $default-rotate, $perspective: false) {\n    $trans: rotate3d($vector-x, $vector-y, $vector-z, $rotate);\n    @if $perspective {\n        $trans: perspective($perspective) $trans;\n    }\n}\n\n@mixin even() {\n    &:nth-child(even) {\n        @content\n    }\n}\n\n@mixin odd() {\n    &:nth-child(odd) {\n        @content\n    }\n}\n\n@mixin fontawesomeIcon($content) {\n    content: $content;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n}\n\n@mixin box-shadow($top, $left, $blur, $color, $inset: false) {\n    @if $inset {\n        -webkit-box-shadow: inset $top $left $blur $color;\n        -moz-box-shadow: inset $top $left $blur $color;\n        box-shadow: inset $top $left $blur $color;\n    }\n    @else {\n        -webkit-box-shadow: $top $left $blur $color;\n        -moz-box-shadow: $top $left $blur $color;\n        box-shadow: $top $left $blur $color;\n    }\n}\n\n@mixin selectArrow($arrow) {\n    -webkit-appearance: $arrow;\n    -moz-appearance: $arrow;\n    appearance: $arrow;\n}\n\n@mixin keyframes($animationName) {\n    @-webkit-keyframes #{$animationName} {\n        @content;\n    }\n    @-moz-keyframes #{$animationName} {\n        @content;\n    }\n    @-o-keyframes #{$animationName} {\n        @content;\n    }\n    @keyframes #{$animationName} {\n        @content;\n    }\n}\n\n@mixin animate($name, $duration, $iteration, $direction) {\n    -webkit-animation-duration: $duration;\n    -moz-animation-duration: $duration;\n    -o-animation-duration: $duration;\n    animation-duration: $duration;\n    -webkit-animation-iteration-count: $iteration;\n    -moz-animation-iteration-count: $iteration;\n    -o-animation-iteration-count: $iteration;\n    animation-iteration-count: $iteration;\n    -webkit-animation-name: $name;\n    -moz-animation-name: $name;\n    -o-animation-name: $name;\n    animation-name: $name;\n    -webkit-animation-direction: $direction;\n    -moz-animation-direction: $direction;\n    -o-animation-direction: $direction;\n    animation-direction: $direction;\n}\n\n@mixin skewX($deg) {\n    -moz-transform: skewX($deg);\n    -webkit-transform: skewX($deg);\n    -o-transform: skewX($deg);\n    -ms-transform: skewX($deg);\n    transform: skewX($deg);\n}\n\n@mixin skewY($deg) {\n    -moz-transform: skewY($deg);\n    -webkit-transform: skewY($deg);\n    -o-transform: skewY($deg);\n    -ms-transform: skewY($deg);\n    transform: skewY($deg);\n}","/************ animate style ************/\n.top_image_bounce {\n\tanimation: top-image-bounce 3s infinite ease-in-out;\n}\n.left_image_bounce {\n  animation: left-image-bounce 3s infinite ease-in-out;\n}\n.right_image_bounce {\n  animation: right-image-bounce 3s infinite ease-in-out;\n}\n.spin_image {\n  animation: spin 3s infinite ease-in-out;\n}\n\n@-webkit-keyframes top-image-bounce {\n  0% {\n    -webkit-transform: translateY(-8px);\n    transform: translateY(-8px); }\n  50% {\n    -webkit-transform: translateY(12px);\n    transform: translateY(12px); }\n  100% {\n    -webkit-transform: translateY(-8px);\n    transform: translateY(-8px); } \n}\n@keyframes top-image-bounce {\n  0% {\n    -webkit-transform: translateY(-8px);\n    transform: translateY(-8px); }\n  50% {\n    -webkit-transform: translateY(12px);\n    transform: translateY(12px); }\n  100% {\n    -webkit-transform: translateY(-8px);\n    transform: translateY(-8px); } \n}\n@-webkit-keyframes left-image-bounce {\n  0% {\n    -webkit-transform: translateX(-5px);\n    transform: translateX(-5px); }\n  50% {\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px); }\n  100% {\n    -webkit-transform: translateX(-5px);\n    transform: translateX(-5px); } \n}\n@keyframes left-image-bounce {\n  0% {\n    -webkit-transform: translateX(-5px);\n    transform: translateX(-5px); }\n  50% {\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px); }\n  100% {\n    -webkit-transform: translateX(-5px);\n    transform: translateX(-5px); } \n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n    -webkit-transform-origin: 50%;\n    transform-origin: 50%; } }\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n    -webkit-transform-origin: 50%;\n    transform-origin: 50%; } }\n\n@keyframes ripple-white3 {\n  0% {\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.1), 0 0 0 10px rgba(255, 255, 255, 0.1), 0 0 0 20px rgba(255, 255, 255, 0.1);\n  }\n  100% {\n    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.1), 0 0 0 20px rgba(255, 255, 255, 0.1), 0 0 0 100px rgba(255, 255, 255, 0);\n  }\n}","/*------------------------------------------------\n    ## Section title\n------------------------------------------------*/\n.section-title {\n  margin-bottom: 50px;\n  position: relative;\n  .sub-title {\n    border-radius: 30px;\n    box-shadow: 0 4.4px 30px rgba(19, 16, 34, 0.1);\n    background: #fff;\n    padding: 8px 20px;\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    letter-spacing: 1px;\n  }\n  .sub-title-sky-blue {\n    border-radius: 0;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    color: #50af9b;\n    text-transform: uppercase;\n    font-weight: 600;\n  }\n  .title {\n    margin-bottom: 0;\n    margin-top: 0;\n    span {\n      color: var(--main-color);\n    }\n  }\n  .content {\n    margin-top: 17px;\n    margin-bottom: 0;\n  }\n  .small-title {\n    margin-top: 18px;\n    line-height: 36px;\n  }\n  .phone {\n    font-weight: 400;\n    margin-top: 30px;\n    img {\n      margin-right: 6px;\n    }\n  }\n  .single-list-wrap {\n    margin-top: 21px;\n  }\n  .btn {\n    margin-top: 30px;\n  }\n  &.style-white {\n    .sub-title {\n      color: var(--main-color);\n      &.left-line {\n        &:before {\n          background: #fff;\n        }\n      }\n      &.right-line {\n        &:after {\n          background: #fff;\n        }\n      }\n      &.double-line {\n        &:before {\n          background: #fff;\n        }\n        &:after {\n          background: #fff;\n        }\n      }\n    }\n    .title {\n      color: #fff;\n    }\n    .content {\n      color: #fff;\n    }\n    .small-title {\n      color: #fff;\n    }\n  }\n}\n","/*----------------------------------------------\n    # Nav bar\n----------------------------------------------*/\n.navbar-top {\n  background: #091d3e;\n  padding: 15px 0;\n  ul {\n    margin: 0;\n    padding: 0;\n    line-height: initial;\n    li {\n      display: inline-block;\n      list-style: none;\n      margin-right: 25px;\n      &:last-child {\n        margin-right: 0;\n        padding-right: 0;\n        border-right: 0;\n      }\n      p,\n      a {\n        margin: 0;\n        font-size: 14px;\n        color: #fff;\n        img {\n          margin-right: 5px;\n        }\n        i {\n          margin-right: 5px;\n        }\n        svg {\n          margin-right: 5px;\n        }\n      }\n      a:hover {\n        color: var(--heading-color);\n      }\n    }\n  }\n  .topbar-right {\n    a {\n      margin: 0 3px;\n    }\n    li {\n      a {\n        i {\n          margin-right: 0;\n        }\n        svg {\n          margin-right: 0;\n        }\n        &:last-child {\n          margin-right: 0;\n        }\n      }\n      &:last-child {\n        border-right: 0;\n      }\n    }\n  }\n}\n\n.navbar-area {\n  position: relative;\n  z-index: 99;\n  margin-top: 20px;\n  .nav-container {\n    transition: all 0.4s;\n    position: relative;\n    &.navbar-bg {\n      position: relative;\n      padding-left: 40px;\n      &:after {\n        content: \"\";\n        position: absolute;\n        left: 15px;\n        top: 0;\n        height: 100%;\n        width: 95%;\n        background: #fff;\n        z-index: -1;\n      }\n    }\n    .logo {\n      line-height: 0.9;\n      a {\n        font-weight: 700;\n        font-size: 24px;\n        color: #fff;\n        img {\n          height: auto;\n          max-width: 150px;\n        }\n      }\n      color: var(--main-color);\n    }\n    .btn-transparent {\n      font-size: 13px;\n      font-weight: 700;\n    }\n    .navbar-collapse {\n      .navbar-nav {\n        display: block;\n        width: 100%;\n        text-align: left;\n        li {\n          a {\n            color: var(--heading-color);\n            font-weight: 600;\n            font-size: 16px;\n            font-family: var(--heading-font);\n          }\n          &:hover a {\n            color: var(--main-color);\n          }\n          + li {\n            margin-left: 17px;\n          }\n          display: inline-block;\n          font-weight: 500;\n          line-height: 80px;\n          text-transform: capitalize;\n          &.menu-item-has-children {\n            position: relative;\n            z-index: 0;\n            padding-right: 14px;\n            &:before {\n              content: \"\";\n              position: absolute;\n              right: 3px;\n              top: 50%;\n              height: 10px;\n              width: 2px;\n              transform: translateY(-50%);\n              transition: all 0.3s ease-in;\n              margin-top: 0;\n              z-index: -1;\n            }\n            &:after {\n              content: \"\";\n              position: absolute;\n              right: -1px;\n              top: 40px;\n              height: 2px;\n              width: 10px;\n              transform: translateY(-50%);\n              transition: all 0.3s ease-in;\n              z-index: -1;\n            }\n            &:hover {\n              @include transition(all, 0.4s, ease);\n              &:before {\n                opacity: 0;\n              }\n              &:after {\n                background: var(--main-color);\n              }\n            }\n            &:hover > .sub-menu {\n              visibility: visible;\n              opacity: 1;\n            }\n            .sub-menu {\n              position: absolute;\n              text-align: left;\n              min-width: 210px;\n              margin: 0;\n              padding: 0;\n              list-style: none;\n              left: 0;\n              top: 100%;\n              box-shadow: 0 0 15px 0 rgba(#000, 0.05);\n              background-color: $color-white;\n              z-index: 9;\n              overflow: hidden;\n              visibility: hidden;\n              opacity: 0;\n              //   &.active {\n              //     visibility: visible;\n              //     opacity: 1;\n              //     display: block;\n              //   }\n              @include transition(all, 0.4s, ease);\n              border-radius: 0;\n              &.border-bt0 {\n                border-bottom: 0px !important;\n              }\n              li {\n                display: block;\n                margin-left: 0;\n                line-height: 22px;\n                font-size: 15px;\n                @include transition(all, 0.4s, ease);\n                border-bottom: 1px solid #f5f5f5;\n                a {\n                  display: block;\n                  padding: 10px 20px;\n                  white-space: nowrap;\n                  transition: all 0.3s;\n                  color: #050a30;\n                  font-size: 14px;\n                  font-weight: 500;\n                  @include transition(all, 0.4s, ease);\n                  position: relative;\n                }\n                &:hover {\n                  background: #061539;\n                  a {\n                    color: #fff;\n                    padding: 10px 20px 10px 30px;\n                    &:before {\n                      visibility: visible;\n                      opacity: 1;\n                    }\n                  }\n                }\n                &:last-child {\n                  border-bottom: 0;\n                }\n              }\n              .menu-item-has-children {\n                position: relative;\n                z-index: 0;\n                padding-right: 0px;\n                &:before {\n                  position: absolute;\n                  right: 15px;\n                  top: 50%;\n                  content: \"\\f105\";\n                  font-family: \"fontawesome\";\n                  @include transform(translateY(-50%));\n                }\n                > .sub-menu {\n                  left: 100%;\n                  top: 20px;\n                  .sub-menu {\n                    .sub-menu {\n                      left: auto;\n                      right: 100%;\n                    }\n                  }\n                }\n                &:hover > .sub-menu {\n                  visibility: visible;\n                  opacity: 1;\n                  li {\n                    &:hover {\n                      &:before {\n                        color: $color-white;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        > li {\n          margin-right: 12px;\n        }\n      }\n    }\n  }\n}\n\n.navbar-nav {\n  opacity: 0;\n  margin-right: -30px;\n  visibility: hidden;\n  transition: all 0.4s ease 0s;\n}\n\n.navbar-area-2 {\n  margin-top: 0;\n  &:after {\n    display: none;\n  }\n}\n\n//sticky-style here\n.sticky-active {\n  -webkit-animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;\n  animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;\n  left: 0;\n  // position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 9999;\n  -webkit-box-shadow: 0 10px 20px 0 rgb(46 56 220 / 5%);\n  box-shadow: 0 10px 20px 0 rgb(46 56 220 / 5%);\n  border-bottom: 0;\n  background: #fff;\n}\n\n.menu-open {\n  opacity: 1;\n  margin-right: 0;\n  visibility: visible;\n}\n.bar1 {\n  width: 32px;\n  height: 2px;\n  margin-bottom: 5px;\n  position: absolute;\n  background: $color-white;\n  z-index: 9999;\n  top: 10px;\n  right: -5px;\n}\n.bar2 {\n  width: 24px;\n  height: 2px;\n  margin-bottom: 5px;\n  position: absolute;\n  background: $color-white;\n  z-index: 9999;\n  top: 17px;\n  right: -5px;\n}\n.bar3 {\n  width: 18px;\n  height: 2px;\n  margin-bottom: 5px;\n  position: absolute;\n  background: $color-white;\n  z-index: 9999;\n  top: 24px;\n  right: -5px;\n}\n.responsive-mobile-menu button:focus {\n  outline: none;\n  border: none;\n}\n\n/**************** nav-left-part *************/\n.header-cat-menu {\n  margin: 0;\n  padding: 0;\n  margin-left: 58px;\n  li {\n    position: relative;\n    margin-right: 0;\n    cursor: pointer;\n    list-style: none;\n    img {\n      margin-top: -3px;\n      margin-right: 5px;\n    }\n    a {\n      color: #022334;\n      font-weight: 500;\n      font-size: 18px;\n    }\n    .sub-menu {\n      position: absolute;\n      left: 0;\n      top: 40px;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      z-index: 9;\n      border: none;\n      opacity: 0;\n      visibility: hidden;\n      transition: 0.4s;\n      box-shadow: 0 0 15px 0 rgb(0 0 0 / 5%);\n      background-color: #fff;\n      min-width: 210px;\n      li {\n        display: block;\n        margin-left: 0;\n        line-height: 22px;\n        font-size: 15px;\n        @include transition(all, 0.4s, ease);\n        border-bottom: 1px solid #f5f5f5;\n        a {\n          display: block;\n          padding: 10px 20px;\n          white-space: nowrap;\n          transition: all 0.3s;\n          color: #050a30;\n          font-size: 14px;\n          font-weight: 500;\n          @include transition(all, 0.4s, ease);\n          position: relative;\n          &:before {\n            position: absolute;\n            left: 17px;\n            top: 50%;\n            content: \"\\f105\";\n            font-family: \"fontawesome\";\n            @include transform(translateY(-50%));\n            visibility: hidden;\n            opacity: 0;\n            transition: 0.4s;\n            color: #fff;\n          }\n        }\n        &:hover {\n          background: #061539;\n          a {\n            color: #fff;\n            padding: 10px 20px 10px 30px;\n            &:before {\n              visibility: visible;\n              opacity: 1;\n            }\n          }\n        }\n        &:last-child {\n          border-bottom: 0;\n        }\n      }\n    }\n    &:hover {\n      > a {\n        color: var(--main-color);\n      }\n      ul {\n        opacity: 1;\n        visibility: visible;\n        animation: menuslide 300ms;\n      }\n    }\n  }\n}\n\n/**************** nav-right-part *************/\n.nav-right-part {\n  .navbar-phone {\n    height: 80px;\n    color: #fff;\n    border-radius: 0;\n    position: relative;\n    display: inline-block;\n    background: var(--main-color);\n    padding: 11px 25px 11px 85px;\n    .icon {\n      position: absolute;\n      left: 20px;\n      background: rgba(255, 255, 255, 0.1);\n      display: inline-block;\n      height: 50px;\n      width: 50px;\n      line-height: 47px;\n      text-align: center;\n      border-radius: 50%;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n    span {\n      font-weight: 500;\n      color: #fff;\n      display: inline-block;\n      margin-bottom: 2px;\n      font-size: 15px;\n    }\n    h5 {\n      font-size: 16px;\n      font-weight: 600;\n      color: #fff;\n      margin-bottom: 0;\n    }\n  }\n  a {\n    margin-left: 15px;\n    color: var(--heading-color);\n  }\n  .search-bar-btn {\n    margin-top: -22px;\n    cursor: pointer;\n  }\n  .search-bar {\n    &:hover {\n      background: var(--main-color);\n      border: 1px solid var(--main-color);\n    }\n  }\n}\n.navbar-area-2 .nav-right-part {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.navbar-area-2 .nav-right-part .navbar-phone {\n  color: var(--heading-color);\n  background: transparent;\n}\n.navbar-area-2 .nav-right-part .navbar-phone .icon {\n  background: rgba(36, 107, 253, 0.1803921569);\n}\n.navbar-area-2 .nav-right-part .navbar-phone .icon img {\n  -webkit-filter: invert(38%) sepia(100%) saturate(3579%) hue-rotate(212deg)\n    brightness(97%) contrast(105%);\n  filter: invert(38%) sepia(100%) saturate(3579%) hue-rotate(212deg)\n    brightness(97%) contrast(105%);\n}\n.navbar-area-2 .nav-right-part .navbar-phone h5,\n.navbar-area-2 .nav-right-part .navbar-phone span {\n  color: var(--heading-color);\n}\n\n.navbar-area-3 {\n  .nav-container .navbar-collapse .navbar-nav li a {\n    color: #fff;\n  }\n  .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:before,\n  .nav-container .navbar-collapse .navbar-nav li.menu-item-has-children:after {\n    background: #fff;\n  }\n}\n.navbar-area-3 .navbarFive {\n  li {\n    &:hover {\n      & > a {\n        color: #50af9b !important;\n      }\n    }\n    &:hover:before {\n      background: #50af9b !important;\n    }\n    &:hover::after {\n      background: #50af9b !important;\n    }\n    .sub-menu {\n      li {\n        &:hover {\n          background: #50af9b !important;\n          & > a {\n            color: #fff !important;\n          }\n        }\n      }\n    }\n  }\n}\n.nav-right-part-desktop {\n  margin-left: 20px;\n}\n.nav-right-part-mobile {\n  display: none;\n}\n\n/**************** sidebar-menu *************/\n.sidebar-menu {\n  width: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  height: 100vh;\n  background-color: #fff;\n  z-index: 999;\n  overflow-y: auto;\n  transition: 0.5s;\n  opacity: 0;\n  visibility: hidden;\n}\n.sidebar-menu .sidebar-inner {\n  position: relative;\n  top: 150px;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.3s;\n  padding: 90px 40px 50px 40px;\n  .thumb {\n    margin-bottom: 15px;\n  }\n  p {\n    margin-bottom: 28px;\n  }\n  .sidebar-address {\n    margin-bottom: 35px;\n    ul {\n      margin: 0;\n      padding: 0;\n      li {\n        list-style: none;\n        margin-bottom: 4px;\n        &:last-child {\n          margin-bottom: 0;\n        }\n        i {\n          margin-right: 6px;\n          width: 25px;\n        }\n      }\n    }\n  }\n  .sidebar-subscribe {\n    position: relative;\n    margin-bottom: 40px;\n    input {\n      width: 100%;\n      border: 1px solid #d6dadf;\n      height: 42px;\n      padding: 0 45px 0 12px;\n    }\n    button {\n      position: absolute;\n      right: 0;\n      top: 0;\n      height: 42px;\n      width: 42px;\n      background: #97b3d0;\n      transition: 0.4s;\n      border: 0;\n      color: var(--heading-color);\n      cursor: pointer;\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n  }\n  .social-media li a {\n    background: #ced4da;\n  }\n  .social-media li a:hover {\n    background: var(--main-color);\n    color: #fff;\n  }\n}\n.sidebar-menu .sidebar-menu-close {\n  background-color: var(--main-color);\n  border: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #fff;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  cursor: pointer;\n  z-index: 999;\n}\n.sidebar-menu.active {\n  width: 360px;\n  opacity: 1;\n  visibility: visible;\n}\n.sidebar-menu.active .sidebar-inner {\n  top: 0;\n  opacity: 1;\n  visibility: visible;\n  transition: all 0.7s ease-out 0.8s;\n}\n\n@media only screen and (max-width: 991px) {\n  .navbar-area {\n    background: #fff;\n  }\n  .navbar-area .nav-container {\n    padding: 5px 0;\n  }\n  .nav-right-part {\n    margin-right: 60px;\n  }\n  .nav-right-part .btn .right {\n    padding-left: 5px;\n    font-size: 13px;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav > li {\n    margin-right: 0;\n    padding-right: 0;\n  }\n  .navbar-area {\n    .nav-container {\n      position: relative;\n      z-index: 0;\n      .navbar-toggler {\n        padding: 0px;\n      }\n      .navbar-collapse {\n        margin-top: 13px;\n\n        .navbar-nav {\n          display: block;\n          margin-top: 20px;\n          li {\n            a {\n              display: block;\n            }\n            display: block;\n            text-align: left;\n            line-height: 30px;\n            padding: 10px 0;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n            &:last-child {\n              border-bottom: none;\n            }\n            + li {\n              margin-left: 0;\n            }\n            &.menu-item-has-children {\n              &:before {\n                top: 26px;\n                right: 3px !important;\n              }\n              .sub-menu {\n                position: initial;\n                display: block;\n                width: 100%;\n                border-top: none;\n                box-shadow: none;\n                margin-left: 0;\n                padding-bottom: 0;\n                height: auto;\n                overflow: hidden;\n                max-height: 0;\n                overflow-y: hidden;\n                background-color: transparent;\n                border-radius: 10px;\n                padding: 0px;\n                border-bottom: none;\n                transition: none;\n                visibility: visible;\n                opacity: 1;\n                transition: all 0.5s linear;\n                &.active {\n                  visibility: visible;\n                  opacity: 1;\n                  max-height: 250px;\n                }\n\n                .sub-menu .menu-item-has-children:before {\n                  content: \"\\f107\";\n                }\n                li {\n                  &.menu-item-has-children {\n                    &:hover {\n                      &:before {\n                        top: 30px;\n                        color: $color-white;\n                      }\n                    }\n                  }\n                  padding: 0;\n                  + li {\n                    border-top: none;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.sopen {\n  display: block !important;\n}\n\n//toggle button css\n.toggle-btn {\n  left: auto;\n  right: 0;\n  position: absolute;\n  top: 8px;\n  width: 40px;\n  height: 40px;\n  transition-duration: 0.5s;\n  border: 0;\n  background: transparent;\n\n  .icon-left {\n    transition-duration: 0.5s;\n    position: absolute;\n    height: 2px;\n    width: 11px;\n    top: 18px;\n    background-color: var(--heading-color);\n    left: 7px;\n    &:before {\n      transition-duration: 0.5s;\n      position: absolute;\n      width: 11px;\n      height: 2px;\n      background-color: var(--heading-color);\n      content: \"\";\n      top: -7px;\n      left: 0;\n    }\n\n    &:after {\n      transition-duration: 0.5s;\n      position: absolute;\n      width: 11px;\n      height: 2px;\n      background-color: var(--heading-color);\n      content: \"\";\n      top: 7px;\n      left: 0;\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .icon-right {\n    transition-duration: 0.5s;\n    position: absolute;\n    height: 2px;\n    width: 11px;\n    top: 18px;\n    background-color: var(--heading-color);\n    left: 18px;\n\n    &:before {\n      transition-duration: 0.5s;\n      position: absolute;\n      width: 11px;\n      height: 2px;\n      background-color: var(--heading-color);\n      content: \"\";\n      top: -7px;\n      left: 0;\n    }\n\n    &:after {\n      transition-duration: 0.5s;\n      position: absolute;\n      width: 11px;\n      height: 2px;\n      background-color: var(--heading-color);\n      content: \"\";\n      top: 7px;\n      left: 0;\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  &.open {\n    .icon-left {\n      transition-duration: 0.5s;\n      background: transparent;\n\n      &:before {\n        transform: rotateZ(45deg) scaleX(1.4) translate(2px, 1px);\n      }\n\n      &:after {\n        transform: rotateZ(-45deg) scaleX(1.4) translate(2px, -1px);\n      }\n    }\n\n    .icon-right {\n      transition-duration: 0.5s;\n      background: transparent;\n\n      &:before {\n        transform: rotateZ(-45deg) scaleX(1.4) translate(-2px, 1px);\n      }\n\n      &:after {\n        transform: rotateZ(45deg) scaleX(1.4) translate(-2px, -1px);\n      }\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .navbar-area .nav-container .navbar-collapse .navbar-nav li {\n    font-size: 16px;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav li + li {\n    margin-left: 5px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .responsive-mobile-menu {\n    display: block;\n    width: 100%;\n    position: relative;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav li {\n    font-size: 14px;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .margin-xlt-80 {\n    margin-top: 0px;\n  }\n  .contact-widget .contact_info_list li.single-info-item .details {\n    padding-left: 25px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .navbar-area .logo {\n    padding-top: 0px !important;\n  }\n  .widget ul {\n    text-align: left;\n  }\n  .navbar-collapse {\n    background: $color-white;\n    margin-top: 0px;\n    width: 100%;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children:before {\n    right: 20px;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav {\n    margin-bottom: 20px;\n  }\n  .navbar-area {\n    padding-bottom: 0px;\n  }\n  .bar1,\n  .bar2,\n  .bar3 {\n    background: #fff;\n  }\n  .party-box-wrapper {\n    padding: 50px 0px;\n  }\n  .party-box-wrapper .party-box-content h4 {\n    font-size: 30px;\n    line-height: 45px;\n  }\n  .footer-area .copyright-area-inner {\n    padding: 20px;\n  }\n\n  .navbar-expand-lg .navbar-collapse {\n    margin-top: 0px;\n  }\n  .contact-widget .contact_info_list li.single-info-item .details {\n    padding-left: 25px;\n  }\n  .footer-area .footer-top .widget.widget_nav_menu ul li a {\n    font-size: 14px;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children\n    .sub-menu {\n    padding: 0 0 0 20px;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children\n    .sub-menu\n    li\n    a {\n    padding: 12px 0;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children\n    .sub-menu\n    li:last-child\n    a {\n    padding-bottom: 3px;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children\n    .sub-menu\n    li\n    a:hover\n    i {\n    opacity: 0;\n    margin-right: -18px;\n  }\n  .nav-right-part-mobile {\n    display: block;\n  }\n  .nav-right-part-desktop {\n    display: none;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children\n    .sub-menu\n    li:hover {\n    background: none;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav li a {\n    color: #333333;\n  }\n}\n\n/* Tablet Layout wide: 767px. */\n@media only screen and (max-width: 767px) {\n  .logo-wrapper.mobile-logo {\n    display: block;\n    width: 100%;\n  }\n  .responsive-mobile-menu {\n    display: block;\n    width: 100%;\n    position: relative;\n  }\n\n  .responsive-mobile-menu .navbar-toggler {\n    position: absolute;\n    left: calc(100% - 130px);\n    top: 10px;\n  }\n  .table-responsive {\n    display: block !important;\n  }\n  .btn-custom-default,\n  .btn-custom-white {\n    font-size: 14px;\n    line-height: 33px;\n    padding: 6px 20px;\n  }\n  .navbar-area .logo {\n    padding-top: 0px !important;\n  }\n}\n\n/* medium tablet layout 599px */\n@media only screen and (max-width: 575px) {\n  .navbar-area .nav-container {\n    margin: 0px 0px;\n  }\n  .navbar-area .logo {\n    padding-top: 10px;\n  }\n  .widget.footer-widget .subscribe-form.subscribe-form-style2 .form-control {\n    padding: 15px 20px;\n  }\n  .widget.footer-widget .subscribe-form.subscribe-form-style2 .btn {\n    padding: 15px 20px;\n  }\n  .search-popup .search-form {\n    min-width: 350px;\n  }\n}\n\n@media only screen and (max-width: 375px) {\n  .btn-custom-default,\n  .btn-custom-white {\n    padding: 5px 18px;\n  }\n  .search-popup .search-form .form-group .form-control,\n  .search-popup .search-form .submit-btn {\n    height: 45px;\n  }\n  .search-popup .search-form {\n    min-width: 300px;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .search-popup .search-form {\n    min-width: 265px;\n  }\n  .responsive-mobile-menu .navbar-toggler {\n    left: calc(100% - 95px);\n  }\n}\n","/*----------------------------------------------\n    # banner style\n----------------------------------------------*/\n.banner-area {\n  margin-top: -120px;\n}\n.banner-area-1 {\n  padding-top: 180px;\n  .animate-img-1 {\n    position: absolute;\n    left: 80px;\n    bottom: 100px;\n  }\n  .animate-img-2 {\n    position: absolute;\n    left: 100px;\n    bottom: 50px;\n  }\n}\n.banner-area-2 {\n  padding-top: 210px;\n  padding-bottom: 70px;\n  .bg-img-2 {\n    position: absolute;\n    right: -100px;\n    top: 0;\n    width: 660px;\n  }\n  .video-play-btn-hover {\n    cursor: pointer;\n  }\n}\n.banner-area-3 {\n  margin-top: 0;\n  .bg-gray {\n    padding: 140px 0;\n    position: relative;\n  }\n  .img-right {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 55%;\n    bottom: 0;\n    height: 100%;\n    z-index: 1;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    right: 40%;\n    top: 0;\n    width: 20%;\n    height: 100%;\n    background-image: linear-gradient(to right, #f8f9fc 50%, transparent);\n    z-index: 2;\n  }\n}\n\n.navbar-area-2 {\n  .nav-right-part {\n    align-items: center;\n    .navbar-phone {\n      color: var(--heading-color);\n      background: transparent;\n      .icon {\n        background: #246bfd2e;\n        img {\n          filter: invert(38%) sepia(100%) saturate(3579%) hue-rotate(212deg)\n            brightness(97%) contrast(105%);\n        }\n      }\n      h5,\n      span {\n        color: var(--heading-color);\n      }\n    }\n  }\n}\n\n.banner-inner {\n  position: relative;\n  z-index: 3;\n  .subtitle {\n    border-radius: 30px;\n    box-shadow: 0 4.4px 30px rgba(19, 16, 34, 0.05);\n    background: #fff;\n    padding: 8px 20px;\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    letter-spacing: 1px;\n  }\n  .title {\n    font-size: 60px;\n    margin-bottom: 20px;\n    font-weight: 700;\n    span {\n      color: var(--main-color);\n    }\n  }\n  .content {\n    margin-bottom: 32px;\n  }\n}\n\n.banner-thumb {\n  position: relative;\n  .main-img {\n    border-radius: 300px 300px 0 0;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    left: -25px;\n    bottom: -25px;\n    width: 100%;\n    height: 100%;\n    border: 5px solid var(--main-color);\n    border-radius: 300px 300px 0 0;\n  }\n  .banner-animate-img {\n    position: absolute;\n  }\n  .banner-animate-img-1 {\n    left: -140px;\n  }\n  .banner-animate-img-2 {\n    right: 25px;\n    bottom: -25px;\n    height: 120px;\n    width: 120px;\n    background: var(--main-color);\n    padding: 20px;\n  }\n  .banner-animate-img-3 {\n    right: -9px;\n    bottom: -68px;\n  }\n}\n\n.banner-thumb-2 {\n  position: relative;\n  .banner-animate-img {\n    position: absolute;\n  }\n  .main-img-wrap {\n    position: relative;\n    .banner-animate-img-1 {\n      left: -140px;\n      width: 120px;\n      z-index: 1;\n    }\n    .banner-animate-img-2 {\n      right: -70px;\n      z-index: 1;\n      top: 50px;\n    }\n    .banner-animate-img-3 {\n      left: -110px;\n      bottom: 100px;\n      z-index: 1;\n    }\n  }\n  .banner-animate-img-4 {\n    right: -20px;\n    top: 0;\n    z-index: 0;\n  }\n  .main-img-wrap {\n    z-index: 1;\n    margin-left: 160px;\n  }\n}\n\n.banner-thumb-3 {\n  position: relative;\n  .banner-animate-img {\n    position: absolute;\n  }\n  position: relative;\n  .banner-animate-img-1 {\n    left: -50px;\n    top: 30%;\n  }\n  .banner-animate-img-2 {\n    right: 50px;\n    bottom: 40px;\n  }\n}\n","/*----------------------------------------------\n    # about style\n----------------------------------------------*/\n.about-thumb-inner {\n  position: relative;\n  .animate-img-1 {\n    position: absolute;\n    left: 100px;\n    bottom: 7px;\n    z-index: 2;\n  }\n  .top_image_bounce {\n    z-index: 9;\n  }\n  .animate-img-2 {\n    position: absolute;\n    right: 50px;\n    top: 180px;\n    z-index: 2;\n  }\n  .animate-img-3 {\n    position: absolute;\n    left: 80px;\n    top: -20px;\n  }\n  .animate-img-4 {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n  }\n  .animate-img-bottom-right {\n    position: absolute;\n    right: -100px;\n    bottom: 80px;\n    z-index: 2;\n  }\n  .animate-main-img {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n  .main-img {\n    position: relative;\n    z-index: 1;\n  }\n  .video-play-btn-hover {\n    position: absolute;\n    right: 10px;\n    top: 60px;\n    z-index: 9;\n  }\n}\n\n.single-about-inner {\n  .thumb {\n    display: inline-block;\n    background: #f8f9fc;\n    border-radius: 5px 40px 40px 40px;\n    height: 80px;\n    width: 80px;\n    line-height: 78px;\n    text-align: center;\n    transition: 0.4s;\n    img {\n      transition: 0.4s;\n    }\n  }\n  .details {\n    p {\n      margin-bottom: 0;\n    }\n  }\n  &:hover {\n    .thumb {\n      background: var(--main-color);\n      img {\n        filter: brightness(100);\n      }\n    }\n  }\n}\n\n.accordion-inner {\n  .accordion-item {\n    background: transparent;\n    border: 0;\n    border-bottom: 1px solid #e3e3e3;\n    .accordion-button {\n      background: transparent;\n      font-size: 20px;\n      padding: 22px 0;\n      box-shadow: none;\n      color: var(--main-color);\n      font-weight: 600;\n      &.collapsed {\n        color: var(--heading-color);\n      }\n    }\n    .accordion-body {\n      padding: 0 0 30px 0;\n    }\n  }\n  &.accordion-icon-left {\n    .accordion-item {\n      .accordion-button {\n        padding-left: 50px;\n        &:after {\n          left: 0;\n          position: absolute;\n        }\n      }\n    }\n  }\n  &.style-2 {\n    .accordion-item {\n      .accordion-button {\n        &.collapsed {\n          color: var(--heading-color);\n          &:after {\n            content: \"+\";\n            font-size: 20px;\n          }\n        }\n        &:after {\n          content: \"-\";\n          background-image: none !important;\n          font-size: 22px;\n          transform: rotate(0);\n          width: 30px;\n          height: 30px;\n          line-height: 24px;\n          background: var(--main-color);\n          color: #fff;\n          text-align: center;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n  &.style-3 {\n    .accordion-item {\n      border: 1px solid #e3e3e3;\n      margin-bottom: 20px;\n      border-radius: 5px;\n      padding: 0 20px;\n      .accordion-button {\n        &.collapsed {\n          color: var(--heading-color);\n          &:after {\n            content: \"+\";\n            font-size: 20px;\n          }\n        }\n        &:after {\n          content: \"-\";\n          background-image: none !important;\n          font-size: 22px;\n          transform: rotate(0);\n          width: 30px;\n          height: 30px;\n          line-height: 24px;\n          background: var(--main-color);\n          color: #fff;\n          text-align: center;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n.single-progressbar {\n  background: #fff;\n  border-radius: 0px;\n  margin-top: 0px;\n  h6 {\n    font-size: 14px;\n    font-weight: 700;\n    display: inline-block;\n    margin-bottom: 0;\n  }\n  .skill {\n    overflow: hidden;\n    padding: 40px 0 5px;\n    position: relative;\n    margin-bottom: 10px;\n    margin-top: -30px;\n    &:before {\n      width: 100%;\n      height: 10px;\n      content: \"\";\n      display: block;\n      position: absolute;\n      background: #f2f2f2;\n      border-radius: 10px;\n      bottom: 5px;\n    }\n    p {\n      position: absolute;\n      right: 0;\n      top: 0px;\n      font-size: 14px;\n      font-weight: 700;\n      font-family: var(--heading-font);\n      color: var(--main-color);\n    }\n  }\n}\n.skill-bar {\n  width: 100%;\n  height: 10px;\n  background: var(--main-color);\n  display: block;\n  position: relative;\n  border-radius: 10px;\n  .skill-count1 {\n    right: -17px;\n    position: absolute;\n    top: -30px;\n    padding: 3px 0;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: var(--heading-font);\n    color: var(--heading-color);\n    p {\n      margin: 0 -3px 0 0;\n    }\n  }\n}\n","/*----------------------------------------------\n    # service style\n----------------------------------------------*/\n.single-service-inner {\n  background: #fff;\n  padding: 40px 35px;\n  margin-bottom: 30px;\n  border-radius: 24px;\n  transition: 0.5s;\n  box-shadow: 0px 4px 20px rgba(19, 16, 34, 0.06);\n  .thumb {\n    margin-bottom: 35px;\n    transition: 0.5s;\n    img {\n      transition: 0.5s;\n    }\n  }\n  .details {\n    h5 {\n      margin-bottom: 20px;\n      position: relative;\n      transition: 0.4s;\n    }\n    p {\n      margin-bottom: 28px;\n    }\n  }\n  &:hover {\n    box-shadow: 0px 4px 20px rgba(19, 16, 34, 0.1);\n    .thumb {\n      img {\n        transform: rotateY(180deg);\n      }\n    }\n  }\n  &.style-3 {\n    border-radius: 5px;\n    margin-top: 50px;\n    padding: 35px;\n    .thumb {\n      height: 100px;\n      width: 100px;\n      line-height: 96px;\n      border-radius: 50%;\n      border: 1px solid #e3e3e3;\n      text-align: center;\n      margin-top: -82px;\n      background: #fff;\n    }\n    .details {\n      h5 {\n        font-size: 22px;\n      }\n    }\n    &:hover {\n      .thumb {\n        border: 1px solid var(--main-color);\n      }\n    }\n  }\n}\n\n.single-service-inner-2 {\n  margin-bottom: 30px;\n  .thumb {\n    background: #f3f4ff;\n    border-radius: 20px;\n    padding: 30px;\n    img {\n      transform: scale(1.05);\n      transition: 0.6s;\n    }\n  }\n  .details {\n    padding: 30px;\n    background: #fff;\n    margin-top: -100px;\n    margin-left: 60px;\n    position: relative;\n    z-index: 2;\n    border-radius: 40px 0 0 0;\n    .icon {\n      img {\n        transition: 0.4s;\n      }\n    }\n    p {\n      margin-bottom: 0;\n    }\n  }\n  &:hover {\n    .thumb {\n      img {\n        transform: scale(1.1);\n      }\n    }\n    .details {\n      box-shadow: $box-shadow;\n      .icon {\n        img {\n          transform: rotateY(180deg);\n        }\n      }\n    }\n  }\n}\n\n.single-service-inner-3 {\n  background: #fff;\n  box-shadow: $box-shadow;\n  position: relative;\n  transition: 0.4s;\n  margin-bottom: 30px;\n  .thumb {\n    display: inline-block;\n    border-radius: 50%;\n    border: 1px solid #50af9b;\n    text-align: center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 0.4s;\n    .thumb-inner {\n      background: #fff;\n      height: 70px;\n      width: 70px;\n      line-height: 68px;\n      border-radius: 50%;\n      box-shadow: 0px 0px 4px rgba(19, 16, 34, 0.15);\n      margin: 7px;\n    }\n  }\n  .details {\n    p {\n      transition: 0.4s;\n    }\n  }\n  &.single-service-inner-3-left {\n    padding: 40px 50px 40px 30px;\n    .thumb {\n      right: -40px;\n    }\n  }\n  &.single-service-inner-3-right {\n    padding: 40px 30px 40px 50px;\n    .thumb {\n      left: -40px;\n    }\n  }\n  &:hover {\n    background: #50af9b;\n    .thumb {\n      border: 1px solid #fff;\n    }\n    .details {\n      h5 {\n        color: #fff;\n      }\n      p {\n        color: #fff;\n      }\n    }\n  }\n}\n.bg-blue-right {\n  background: rgba(80, 175, 155, 0.1);\n}\n.service-middle-section {\n  padding: 30px 30px 0 30px;\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n}\n",".single-work-process-inner {\n\tborder-radius: 5px;\n\tbox-shadow: $box-shadow;\n\tmargin-bottom: 30px;\n\tpadding: 30px 20px;\n    transition: 0.4s;\n\t.thumb {\n\t\timg {\n\t\t\ttransition: 0.4s;\n\t\t}\n\t}\n\t.details {\n\t\t.process-count {\n\t\t\tcolor: var(--main-color);\n\t\t\tfont-weight: 600;\n\t\t}\n\t\th5 {\n\t\t\tfont-weight: 700;\n\t\t}\n\t\t.content {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\t&:hover {\n\t\tbox-shadow: $box-shadow2;\n\t\t.thumb {\n\t\t\timg {\n\t\t\t\ttransform: rotateY(180deg);\n\t\t\t}\n\t\t}\n\t\t\n\t}\n}\n\n.single-work-process-inner-2 {\n\tpadding: 25px;\n\tmargin-top: -90px;\n\t.thumb {\n\t\theight: 120px;\n\t\twidth: 120px;\n\t\tline-height: 120px;\n\t\ttext-align: center;\n\t\tborder-radius: 5px;\n\t\tbox-shadow: $box-shadow;\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\tbackground: #fff;\n\t\timg {\n\t\t\ttransition: 0.4s;\n\t\t}\n\t\t.process-count {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tcolor: #fff;\n\t\t\tbackground: var(--main-color);\n\t\t\tborder-radius: 50%;\n\t\t\tline-height: 030px;\n\t\t\ttext-align: center;\n\t\t\tfont-size: 14px;\n\t\t\tposition: absolute;\n\t\t\tright: -15px;\n\t\t\ttop: 45px;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t}\n\t.details {\n\t\tp {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\t&:hover {\n\t\t.thumb {\n\t\t\timg {\n\t\t\t\ttransform: rotateY(180deg);\n\t\t\t}\n\t\t\t.process-count {\n\t\t\t\tbackground: var(--heading-color);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.single-work-process-inner-3 {\n\tpadding: 40px;\n\tpadding-top: 0;\n\timg {\n\t\tborder-radius: 50%;\n\t}\n}",".single-team-inner {\n  border: 1px solid #e3e3e3;\n  box-shadow: 0px 4.4px 20px rgba(19, 16, 34, 0.05);\n  border-radius: 22px;\n  position: relative;\n  margin-bottom: 30px;\n  .thumb {\n    position: relative;\n    border-radius: 22px;\n    overflow: hidden;\n    img {\n      transform: scale(1.05);\n      transition: 0.9s;\n    }\n    .team-social-inner {\n      opacity: 0;\n      transition: 0.4s;\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      bottom: 10px;\n      &.sky {\n        background: #50af9b;\n      }\n    }\n  }\n  .team-social-inner {\n    height: 50px;\n    padding: 11px 25px 8px;\n    background: #fff;\n    border-radius: 50px;\n    transition: 0.4s;\n    display: inline-block;\n    li {\n      display: inline-block;\n      margin-right: 10px;\n      padding-right: 10px;\n      font-size: 15px;\n      border-right: 1px solid #e3e3e3;\n      color: #737588;\n      &:last-child {\n        margin-right: 0;\n        padding-right: 0;\n        border-right: 0;\n      }\n    }\n  }\n  .details {\n    padding: 20px;\n    p {\n      margin-bottom: 0;\n    }\n  }\n  &:hover {\n    .thumb {\n      img {\n        transform: scale(1.1);\n      }\n      .team-social-inner {\n        bottom: 20px;\n        visibility: visible;\n        opacity: 1;\n      }\n    }\n  }\n\n  &.style-2 {\n    border-radius: 10px;\n    border: 0;\n    .thumb {\n      border-radius: 10px;\n    }\n    .details {\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      width: 100%;\n      padding: 0 20px 0;\n      .details-inner {\n        border-radius: 10px 10px 0 0;\n        background: rgba(255, 255, 255, 0.8);\n        padding: 20px;\n      }\n      h5 {\n        color: var(--main-color);\n        &:hover a {\n          color: var(--heading-color);\n        }\n      }\n      p {\n        color: var(--heading-color);\n      }\n      .team-social-inner {\n        border-radius: 5px;\n        height: 40px;\n        padding: 6px 15px;\n      }\n    }\n  }\n}\n\n.team-details-page {\n  .thumb {\n    background: #f5f3ef;\n    padding: 40px 0 40px 0;\n    margin-right: 40px;\n    img {\n      width: 100%;\n      margin-right: -80px;\n    }\n  }\n  .social-media {\n    li {\n      a {\n        height: 46px;\n        width: 46px;\n        line-height: 46px;\n        border-radius: 0;\n        background: var(--heading-color);\n        font-size: 16px;\n        color: #fff;\n        &:hover {\n          background: var(--main-color);\n        }\n      }\n    }\n  }\n}\n","/*----------------------------------------------\n    # pricing style\n----------------------------------------------*/\n.single-pricing-inner {\n\tbackground: #fff;\n\tpadding: 48px;\n\ttransition: 0.4s;\n\tmargin-bottom: 30px;\n\tbox-shadow: 0px 4.8px 20px rgba(19, 16, 34, 0.1);\n\th2 {\n\t\ttransition: 0.4s;\n\t\tsub {\n\t\t\tfont-size: 16px;\n\t\t\tbottom: 1px;\n\t\t}\n\t}\n\th5 {\n\t\tmargin-bottom: 32px;\n\t\ttransition: 0.4s;\n\t}\n\tul {\n\t\tpadding: 0;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcolor: var(--heading-color);\n\t\t\tmargin-bottom: 15px;\n\t\t\ttransition: 0.4s;\n\t\t\ti,\n\t\t\tsvg {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\t&.hide {\n\t\t\t\tcolor: var(--paragraph-color);\n\t\t\t}\n\t\t}\n\t}\n\t.btn {\n\t\tmargin-top: 28px;\n\t}\n\t&.price-active,\n\t&:hover {\n\t\tbackground: #F8F9FC;\n\t\tbox-shadow: none;\n\t\t.btn {\n\t\t\tbackground: var(--main-color);\n\t\t\tborder-color: var(--main-color);\n\t\t\tcolor: #fff !important;\n\t\t\tline-height: 50px;\n\t\t}\n\t}\n\t&.style-3 {\n\t\tborder: 1px solid #E3E3E3;\n\t\tbox-shadow: none;\n\t\th5 {\n\t\t\tbackground: #F8F9FC;\n\t\t\tpadding: 12px 20px;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-bottom: 32px;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t\t&.price-active,\n\t\t&:hover {\n\t\t\tbackground: var(--main-color);\n\t\t\th2 {\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t\th5 {\n\t\t\t\tbackground: rgba(255,255,255,0.1);\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tpadding: 0;\n\t\t\t\tli {\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\ti,\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t}\n\t\t\t\t\t&.hide {\n\t\t\t\t\t\tcolor: grba(255,255,255,0.1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.btn {\n\t\t\t\tbackground: #fff;\n\t\t\t\tcolor: var(--main-color) !important;\n\t\t\t}\n\t\t}\n\t}\n}",".single-case-study-inner {\n  margin-bottom: 30px;\n  .thumb {\n    position: relative;\n    overflow: hidden;\n    border-radius: 5px;\n    img {\n      transform: scale(1.05);\n      transition: 0.9s;\n    }\n  }\n  .details {\n    box-shadow: $box-shadow;\n    padding: 25px 75px 25px 25px;\n    margin-left: 50px;\n    margin-top: -55px;\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    border-radius: 5px 0 5px 5px;\n    h5 {\n      margin-bottom: 5px;\n    }\n    .cat {\n      color: var(--main-color);\n    }\n    .right-arrow {\n      height: 40px;\n      width: 40px;\n      line-height: 40px;\n      text-align: center;\n      border-radius: 50%;\n      background: rgba(36, 107, 253, 0.1);\n      display: inline-block;\n      position: absolute;\n      right: 25px;\n      top: 50%;\n      transform: translateY(-50%);\n      color: var(--main-color);\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n  }\n  &:hover {\n    .thumb {\n      img {\n        transform: scale(1.1);\n      }\n    }\n    .details {\n      .right-arrow {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n  }\n}\n\n.single-case-study-inner.style-2 {\n  position: relative;\n}\n.single-case-study-inner.style-2 .details {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  background: transparent;\n  width: 100%;\n  margin-left: 0;\n}\n.single-case-study-inner.style-2 .details h5 {\n  color: #fff;\n}\n.single-case-study-inner.style-2 .details .cat {\n  color: #fff;\n}\n.single-case-study-inner:hover .thumb img {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n.single-case-study-inner:hover .details .right-arrow {\n  background: var(--main-color);\n  color: #fff;\n}\n","/*----------------------------------------------\n    # content style\n----------------------------------------------*/\n.single-counter-inner {\n  margin-bottom: 30px;\n  .thumb {\n    img {\n      transition: 0.4s;\n    }\n  }\n  &:hover {\n    .thumb {\n      img {\n        transform: rotateY(180deg);\n      }\n    }\n  }\n  &.style-2 {\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    padding: 30px;\n    border-radius: 5px;\n    p {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.single-contact-list {\n  padding: 50px;\n  box-shadow: $box-shadow;\n  transition: 0.4s;\n  border-radius: 5px;\n  margin-bottom: 30px;\n  background: #fff;\n  border: 1px solid rgba(66, 74, 97, 0.1);\n  .media-left {\n    margin-right: 15px;\n  }\n  .media-body {\n    margin-top: -2px;\n    h5 {\n      margin-bottom: 6px;\n    }\n    h6 {\n      margin-bottom: 0;\n    }\n  }\n  &:hover {\n    box-shadow: $box-shadow2;\n  }\n}\n\n.client-slider {\n  .item {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    align-self: center;\n  }\n  .thumb {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    align-self: center;\n    padding: 0 50px;\n    img {\n      width: auto;\n    }\n  }\n  .owl-nav {\n    display: none;\n  }\n}\n.client-border-radius {\n  border-radius: 15px 15px 0 0;\n}\n",".single-testimonial-inner {\n  box-shadow: $box-shadow;\n  padding: 40px 30px;\n  margin: 10px;\n  background: #fff;\n  .designation {\n    font-weight: 600;\n  }\n  .icon {\n    display: inline-block;\n  }\n\n  &.style-1 {\n    margin-bottom: 120px;\n    position: relative;\n    &:after {\n      content: \"\";\n      position: absolute;\n      height: 20px;\n      width: 20px;\n      transform: rotate(-45deg);\n      background: #fff;\n      bottom: -9px;\n      left: 50%;\n      margin-left: -10px;\n    }\n    .thumb {\n      background: #fff;\n      box-shadow: $box-shadow;\n      padding: 8px;\n      height: 80px;\n      width: 80px;\n      border-radius: 50%;\n      position: absolute;\n      bottom: -105px;\n      left: 50%;\n      transform: translateX(-50%);\n      img {\n        border-radius: 50%;\n      }\n    }\n  }\n  &.style-2 {\n    .icon {\n      border: 2px solid rgba(36, 107, 253, 0.1);\n      height: 50px;\n      width: 50px;\n      line-height: 50px;\n      text-align: center;\n      border-radius: 50%;\n      padding: 5px;\n      position: relative;\n      &:after {\n        content: \"\";\n        position: absolute;\n        left: 3px;\n        top: 3px;\n        background: var(--main-color);\n        height: 40px;\n        width: 40px;\n        border-radius: 50%;\n        z-index: 0;\n      }\n      img {\n        position: relative;\n        z-index: 2;\n        color: #fff;\n        width: auto;\n        margin: 0 auto;\n        padding-top: 9px;\n        filter: brightness(10);\n      }\n    }\n    .thumb {\n      img {\n        width: auto;\n        border: 1px solid var(--main-color);\n        padding: 5px;\n        border-radius: 50%;\n      }\n    }\n    .ratting-inner {\n      font-size: 15px;\n      svg {\n        font-size: 13px;\n      }\n    }\n  }\n  &.style-3 {\n    padding: 0;\n    box-shadow: none;\n    background: transparent;\n    img {\n      width: auto;\n    }\n    .thumb {\n      position: relative;\n      padding-right: 50px;\n      .shadow-img {\n        background: #fff;\n        padding: 35px 20px;\n        border-radius: 8px;\n      }\n      .main-img {\n        position: absolute;\n        right: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 130px;\n        border-radius: 8px;\n      }\n    }\n    .details {\n      position: relative;\n      padding: 10px;\n      .quote {\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n      .designation {\n        font-weight: 400;\n        font-size: 15px;\n      }\n      h6 {\n        color: var(--main-color);\n      }\n      .ratting-inner {\n        font-size: 10px;\n        display: flex;\n        gap: 3px;\n        align-items: center;\n      }\n    }\n  }\n}\n\n.testimonial-slider-2 {\n  .owl-nav {\n    display: none;\n  }\n}\n.slick-dots {\n  bottom: -50px;\n}\n\n.slick-dots li button:before {\n  font-size: 14px;\n  color: var(--main-color);\n}\n.slick-dots li.slick-active button:before {\n  opacity: 0.75;\n  color: var(--main-color);\n}\n\n.testimonial-tab {\n  border: 0 !important;\n  button {\n    border: 2px dashed transparent !important;\n    padding: 0;\n    height: 140px;\n    width: 140px;\n    border-radius: 50% !important;\n    padding: 30px;\n    transition: 0.4s;\n    img {\n      width: 100%;\n      transition: 0.4s;\n    }\n    &.active {\n      border: 2px dashed #50af9b !important;\n      padding: 12px;\n    }\n  }\n}\n",".faq-area-margin-top {\n  margin-top: -120px;\n}\n.case-study-area {\n  .animate-img-1 {\n    position: absolute;\n    bottom: 130px;\n    left: 90px;\n    width: 50px;\n  }\n}\n\n.contact-inner-1 {\n  margin-top: -120px;\n  position: relative;\n  z-index: 2;\n  .animate-img-1 {\n    position: absolute;\n    left: -30px;\n    bottom: -30px;\n    z-index: -1;\n  }\n  .animate-img-2 {\n    position: absolute;\n    right: -30px;\n    bottom: -30px;\n  }\n  .section-title {\n    background: #fff;\n    padding: 50px;\n    margin-left: -190px;\n    margin-top: 50px;\n    border-radius: 5px;\n    box-shadow: $box-shadow;\n    .title {\n      font-size: 35px;\n    }\n  }\n}\n\n.contact-page-list {\n  margin-bottom: -110px;\n  position: relative;\n}\n.contact-page-inner {\n  padding: 100px;\n  border-radius: 10px;\n}\n\n.contact-g-map {\n  margin-bottom: -100px;\n  iframe {\n    width: 100%;\n    height: 550px;\n  }\n}\n\n.career-wrap-area {\n  background: #f8f9fc;\n  border-radius: 5px;\n}\n.career-nav-tab {\n  border-bottom: 1px solid #ebebeb !important;\n  button {\n    border: 0 !important;\n    border-right: 1px solid #ebebeb !important;\n    background: transparent !important;\n    width: 25%;\n    font-weight: 600;\n    color: var(--heading-color);\n    padding: 15px 6px;\n    &:last-child {\n      border-right: 0 !important;\n    }\n    &.active {\n      color: var(--main-color) !important;\n    }\n  }\n}\n.career-wrap {\n  padding: 60px;\n}\n\n.project-nav-tab {\n  border-bottom: 0 !important;\n  background: #f8f9fc;\n  padding: 5px 15px;\n  border-radius: 5px;\n  button {\n    border: 0 !important;\n    background: transparent !important;\n    font-weight: 600;\n    color: var(--heading-color);\n    padding: 5px 15px;\n    &:last-child {\n      border-right: 0 !important;\n    }\n    &.active {\n      color: var(--main-color) !important;\n    }\n  }\n}\n\n.counter-4-area {\n  position: relative;\n  .counter-4-title {\n    background: rgba(255, 255, 255, 0.1);\n    display: inline-block;\n    padding: 35px 40px;\n    color: #fff;\n    min-width: 200px;\n  }\n}\n.about-area-margin-bottom {\n  position: relative;\n  margin-bottom: -120px;\n  z-index: 2;\n}\n","/*----------------------------------------\n  ## Search Popup\n----------------------------------------*/\n.td-search-popup.active .search-form {\n    visibility: visible;\n    opacity: 1;\n    width: 40%;\n    z-index: 9999;\n}\n\n.td-search-popup .search-form {\n    width: 35%;\n    position: absolute;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    -webkit-transition: all 0.4s ease;\n    -o-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    visibility: hidden;\n    opacity: 0;\n    -ms-transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    z-index: 999;\n}\n\n.td-search-popup .search-form .form-group .form-control {\n    border: none;\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n    height: 54px;\n    padding: 0 75px 0 25px;\n    background: #f7f9fb;\n}\n.td-search-popup .search-form .form-group .form-control:hover, \n.td-search-popup .search-form .form-group .form-control:focus, \n.td-search-popup .search-form .form-group .form-control:active {\n    outline: 0;\n    -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.td-search-popup .search-form .submit-btn {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 60px;\n    height: 54px;\n    border: 0;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n    color: #ffffff;\n    -webkit-transition: all 0.4s ease;\n    -o-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    padding: 0;\n    text-align: center;\n    cursor: pointer;\n  background: var(--main-color);\n}\n.td-search-popup .search-form .submit-btn:hover, \n.td-search-popup .search-form .submit-btn:focus, \n.td-search-popup .search-form .submit-btn:active {\n    outline: 0;\n    -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.body-overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    display: block;\n    background: rgba(0, 0, 0, 0.95);\n    z-index: 999;\n    content: \"\";\n    left: 0;\n    top: 0;\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 0.4s ease;\n    -o-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAMFBMVEVMaXH////////////////////////////////////////////////////////////6w4mEAAAAD3RSTlMAlAX+BKLcA5+b6hJ7foD4ZP1OAAAAkUlEQVR4XkWPoQ3CUBQAL4SktoKAbCUjgAKLJZ2ABYosngTJCHSD6joUI6BZgqSoB/+Shqde7sS9x3OGk81fdO+texMtRVTia+TsQtHEUJLdohJfgNNPJHyEJPZTsWLoxShqsWITazEwqePAn69Sw2TUxk1+euPis3EwaXy8RMHSZBIlRcKKnC5hRctjMf57/wJbBlAIs9k1BAAAAABJRU5ErkJggg==), progress;\n}\n\n.body-overlay.active {\n    visibility: visible;\n    opacity: 0.97;\n}\n\n.mfp-zoom-in {\n    /* animate in */\n    /* animate out */ }\n.mfp-zoom-in .mfp-content {\n    opacity: 0;\n    -webkit-transition: all 0.4s ease;\n    -moz-transition: all 0.4s ease;\n    -o-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    -webkit-transform: scale(0.7);\n    -ms-transform: scale(0.7);\n    transform: scale(0.7); }\n.mfp-zoom-in.mfp-bg {\n    opacity: 0;\n    -webkit-transition: all 0.4s ease;\n    -moz-transition: all 0.4s ease;\n    -o-transition: all 0.4s ease;\n    transition: all 0.4s ease; }\n.mfp-zoom-in.mfp-ready .mfp-content {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1); }\n.mfp-zoom-in.mfp-ready.mfp-bg {\n    opacity: 0.7; }\n    .mfp-zoom-in.mfp-removing .mfp-content {\n    -webkit-transform: scale(0.7);\n    -ms-transform: scale(0.7);\n    transform: scale(0.7);\n    opacity: 0; }\n.mfp-zoom-in.mfp-removing.mfp-bg {\n    opacity: 0; }\n\n\n\n\n\n/************ single-inpur-inner ************/\n.single-input-inner {\n    margin-bottom: 20px;\n    input {\n        width: 100%;\n        height: 50px;\n        border: 0 !important;\n        padding: 0 18px;\n        border-radius: 6px;\n        font-weight: 300;\n        &::placeholder {\n            color: #adadad;\n        }\n    }\n    textarea {\n        width: 100%;\n        border: 0 !important;\n        height: 140px;\n        border-radius: 6px;\n        padding: 14px 18px;\n        font-weight: 300;\n        &::placeholder {\n            color: #adadad;\n        }\n    }\n    .single-select {\n        width: 100%;\n        height: 50px;\n        line-height: 50px;\n        border: 0 !important;\n        border-radius: 6px;\n        padding: 0 18px;\n        margin-bottom: 20px;\n        .list {\n            width: 100%;\n        }\n    }\n    &.style-border {\n        input {\n            border: 1px solid rgba(234, 225, 214, 0.7) !important;\n            &::placeholder {\n                color: #adadad;\n            }\n        }\n        textarea {\n            border: 1px solid rgba(234, 225, 214, 0.7) !important;\n            background: transparent;\n            &::placeholder {\n                color: #adadad;\n            }\n        }\n        .single-select {\n            border: 1px solid rgba(234, 225, 214, 0.7) !important;\n            color: #adadad;\n        }\n    }\n    &.style-border-bottom {\n        input {\n            border-bottom: 1px solid rgba(234, 225, 214, 0.7) !important;\n            background: transparent;\n            padding: 0;\n            &::placeholder {\n                color: #adadad;\n            }\n        }\n        textarea {\n            border-bottom: 1px solid rgba(234, 225, 214, 0.7) !important;\n            &::placeholder {\n                color: #adadad;\n            }\n        }\n        .single-select {\n            border-bottom: 1px solid rgba(234, 225, 214, 0.7) !important;\n            background: transparent;\n            color: #adadad;\n        }\n    }\n    &.style-bg {\n        input {\n            background: #F7FAFC;\n            &::placeholder {\n                color: #3F517E;\n            }\n        }\n        textarea {\n            background: #F7FAFC;\n            &::placeholder {\n                color: #3F517E;\n            }\n        }\n        .single-select {\n            background: #F7FAFC;\n            color: #3F517E;\n        }\n    }\n    &.style-bg-none {\n        input {\n            background: transparent;\n            color: #fff;\n            &::placeholder {\n                color: #fff;\n            }\n        }\n        textarea {\n            background: transparent;\n            color: #fff;\n            &::placeholder {\n                color: #fff;\n            }\n        }\n        .single-select {\n            background: transparent;\n            color: #fff;\n        }\n    }\n}\n\n\n.contact-form-inner {\n    padding: 0 30px 30px;\n    border-radius: 7px;\n    overflow: hidden;\n    background-size: cover;\n    .single-input-inner.style-border-bottom {\n        input {\n            border-bottom: 1px solid #fff !important;\n            &::placeholder {\n                color: #fff;\n            }\n        }\n    }\n}\n\n.blog-comment-form {\n    textarea {\n        background: #FBFBFB;\n        border: 1px solid #FBFBFB;\n    }\n}","/*---------------------------------------------------\n\twidget styles\n----------------------------------------------------*/\n.widget-title {\n  position: relative;\n  font-size: 20px;\n}\n.td-sidebar .widget {\n  margin-bottom: 34px;\n  padding: 30px;\n  border-radius: 4px;\n  border: 1px solid #ededed;\n  .widget-title {\n    margin-bottom: 30px;\n    position: relative;\n    padding-bottom: 8px;\n    color: var(--main-color);\n    &:after {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      bottom: -5px;\n      height: 3px;\n      width: 100%;\n      background: #e1e1e1;\n    }\n    &:before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      bottom: -5px;\n      height: 3px;\n      width: 60px;\n      background: var(--main-color);\n      z-index: 2;\n    }\n  }\n  &.widget-recent-post ul li .media {\n    box-shadow: $box-shadow;\n    padding: 15px 20px;\n    border-radius: 5px;\n  }\n}\n.footer-area {\n  .widget-title {\n    color: #fff;\n  }\n}\n\n.td-sidebar-service .widget {\n  margin-bottom: 34px;\n  padding: 0;\n  border-radius: 0;\n  box-shadow: none;\n  .widget-title {\n    &:before {\n      display: none;\n    }\n    &:after {\n      border-bottom: 1px dashed var(--main-color);\n      background: transparent;\n      width: 156px;\n    }\n  }\n}\n\n.widget_search .search-form {\n  position: relative;\n  background: #f4f6f9;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid #e1e1e1;\n}\n.widget_search .search-form .form-group {\n  margin-bottom: 0;\n}\n.widget_search .search-form input {\n  width: 100%;\n  border: 0;\n  height: 55px;\n  padding: 0 60px 0 22px;\n}\n.widget_search .search-form input:focus {\n  border: 0;\n  outline: 0;\n}\n.widget_search .search-form button {\n  position: absolute;\n  right: 0;\n  border: 0;\n  background: var(--main-color);\n  cursor: pointer;\n  padding: 0 22px;\n  top: 0;\n  height: 55px;\n  color: #fff;\n}\n.widget_search .search-form button svg,\n.widget_search .search-form button i {\n  color: #fff;\n}\n.widget_search .search-form button:active,\n.widget_search .search-form button:focus {\n  box-shadow: none;\n  outline: 0;\n}\n\n.widget-recent-post ul {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 9px;\n  padding-bottom: 0;\n}\n.widget-recent-post ul li {\n  margin-bottom: 15px;\n}\n.widget-recent-post ul li .media {\n  align-items: center;\n}\n.widget-recent-post ul li .media .media-left {\n  margin-right: 18px;\n}\n.widget-recent-post ul li .media .media-left img {\n  border-radius: 4px;\n}\n.widget-recent-post ul li .media .media-body .title {\n  margin-bottom: 8px;\n}\n.widget-recent-post ul li .media .media-body .post-info {\n  font-size: 13px;\n  color: var(--heading-color);\n  display: flex;\n  align-items: center;\n}\n.widget-recent-post ul li .media .media-body .post-info span {\n  color: #3f517e;\n}\n.widget-recent-post ul li .media .media-body .post-info svg,\n.widget-recent-post ul li .media .media-body .post-info i {\n  margin-right: 8px;\n  color: var(--main-color);\n}\n.widget-recent-post ul li:last-child {\n  border-bottom: 0 !important;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\n//widget-catagory\n.widget_catagory ul {\n  padding-left: 0;\n  padding-bottom: 0;\n  margin-bottom: 0;\n  margin-top: -5px;\n}\n.widget_catagory ul li {\n  list-style: none;\n  transition: 0.6s;\n  padding-bottom: 10px;\n  &:last-child {\n    border-bottom: 0;\n    padding-bottom: 0;\n    margin-bottom: 0;\n  }\n}\n.widget_catagory ul li a {\n  position: relative;\n  padding: 10px 15px;\n  background: #f8f9fc;\n  display: block;\n  padding-right: 60px;\n  border-radius: 6px;\n  span {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    border: 1px solid rgba(66, 74, 97, 0.1);\n    display: inline-block;\n    padding: 10px 18px;\n    right: 0;\n    border-radius: 6px;\n  }\n}\n.widget_catagory ul li:last-child {\n  margin-bottom: 0;\n}\n\n//style-2\n.widget_catagory_2 ul {\n  padding: 0;\n  li {\n    list-style: none;\n    a {\n      border: 1px solid #d1d1d1;\n      display: block;\n      margin-bottom: 20px;\n      padding: 10px 15px;\n      border-radius: 5px;\n      font-weight: 600;\n      i {\n        float: right;\n        padding-top: 3px;\n        font-size: 21px;\n      }\n      span {\n        i {\n          float: left;\n          margin-right: 10px;\n          color: var(--main-color);\n          background: #ffe6e2;\n          padding: 5px 5px 2px 5px;\n          border-radius: 3px;\n        }\n      }\n      &:hover {\n        background-image: linear-gradient(to right, #f99746, #ee0020);\n        border: 1px solid var(--main-color);\n        color: #fff;\n      }\n    }\n  }\n}\n\n//widget-tags\n.widget_tag_cloud .tagcloud a {\n  background: #f4f6f9;\n  height: 36px;\n  line-height: 34px;\n  padding: 0 18px;\n  border-radius: 5px;\n  display: inline-block;\n  margin: 0 5px 9px 0;\n  font-family: \"Lato\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #909090;\n  border: 1px solid rgba(66, 74, 97, 0.1);\n  i {\n    float: right;\n    padding-top: 5px;\n  }\n}\n.widget_tag_cloud .tagcloud a:hover {\n  background: var(--main-color);\n  color: #ffffff;\n  border-color: var(--main-color);\n}\n\n/*********** widget_checkbox_list ************/\n.widget_checkbox_list {\n  .single-checkbox:last-child {\n    margin-bottom: 0;\n    border-bottom: 0;\n    padding-bottom: 0;\n  }\n}\n.single-checkbox {\n  display: block;\n  position: relative;\n  padding-left: 28px;\n  margin-bottom: 7px;\n  padding-bottom: 7px;\n  cursor: pointer;\n  font-size: 16px;\n  color: var(--heading-color);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom: 1px solid #e3e3e3;\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n    &:checked ~ .checkmark {\n      background-color: var(--main-color);\n    }\n    &:checked ~ .checkmark:after {\n      display: block;\n    }\n  }\n  .checkmark {\n    position: absolute;\n    top: 4px;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: #eae1d6;\n    &:after {\n      content: \"\";\n      position: absolute;\n      display: none;\n      left: 8px;\n      top: 4px;\n      width: 5px;\n      height: 10px;\n      border: solid #fff;\n      border-width: 0 2px 2px 0;\n      -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n      transform: rotate(45deg);\n    }\n  }\n}\n\n/******** widget-video-inner *********/\n.widget-video-inner {\n  border-radius: 5px;\n  .thumb {\n    position: relative;\n    border-radius: 5px;\n    overflow: hidden;\n    margin-bottom: 20px;\n    &:after {\n      content: \"\";\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0;\n      left: 0;\n      background: rgba(0, 0, 0, 0.3);\n    }\n    .video-btn {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 50px;\n      height: 50px;\n      line-height: 52px;\n      z-index: 1;\n      i {\n        font-size: 18px;\n      }\n      &:after {\n        width: 70px;\n        height: 70px;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n    }\n  }\n  .details {\n    margin-top: 10px;\n    ul {\n      padding: 0;\n      margin: 0;\n      li {\n        list-style: none;\n        text-align: right;\n        display: flex;\n        align-items: baseline;\n        border-bottom: 1px dashed #e3e3e3;\n        padding-bottom: 10px;\n        margin-bottom: 10px;\n        &:last-child {\n          border-bottom: 0;\n        }\n        i {\n          color: var(--main-color);\n          margin-right: 7px;\n        }\n        span {\n          margin-right: auto;\n          font-weight: 500;\n          color: var(--heading-color);\n        }\n      }\n    }\n  }\n}\n\n/******** widget-contact *********/\n.widget_contact {\n  .details {\n    padding: 0;\n    li {\n      margin-bottom: 10px;\n      position: relative;\n      list-style: none;\n      i {\n        margin-right: 14px;\n        color: var(--main-color);\n      }\n      svg {\n        margin-right: 14px;\n        color: var(--main-color);\n        &.sky {\n          color: #50af9b;\n        }\n      }\n      &:last-child {\n        margin-bottom: 0;\n      }\n      .time {\n        font-size: 12px;\n        margin-top: 3px;\n      }\n    }\n  }\n  .social-media {\n    li {\n      a {\n        border: 1px solid var(--paragraph-color);\n        background: transparent;\n        line-height: 28px;\n        svg {\n          margin-right: 0;\n          transition: 0.4s;\n        }\n        &:hover {\n          background: var(--main-color);\n          border: 1px solid var(--main-color);\n          svg {\n            color: #fff !important;\n          }\n        }\n        &.sky {\n          &:hover {\n            background: #50af9b;\n            border: 1px solid #50af9b;\n            svg {\n              color: #fff !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.widget_instagram {\n  .instagram-wrap {\n    margin: 0 10px;\n    .thumb {\n      margin-bottom: 10px;\n      position: relative;\n      border-radius: 6px;\n      overflow: hidden;\n      cursor: pointer;\n      img {\n        transform: scale(1.05);\n        transition: 0.9s;\n      }\n      &:after {\n        content: \"\";\n        background: rgba(0, 0, 0, 0.5);\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        left: 0;\n        top: 0;\n        visibility: hidden;\n        opacity: 0;\n        transition: 0.4s;\n      }\n      i {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        height: 35px;\n        width: 35px;\n        line-height: 35px;\n        text-align: center;\n        background: rgba(253, 74, 54, 0.7);\n        display: inline-block;\n        z-index: 3;\n        color: #fff;\n        border-radius: 50%;\n        visibility: hidden;\n        opacity: 0;\n        transition: 0.4s;\n      }\n      &:hover {\n        &:after {\n          visibility: visible;\n          opacity: 1;\n        }\n        i {\n          visibility: visible;\n          opacity: 1;\n        }\n        img {\n          transform: scale(1.1);\n        }\n      }\n    }\n  }\n}\n\n.widget_author {\n  padding: 50px 30px !important;\n  .thumb {\n    margin-bottom: 20px;\n    img {\n      border-radius: 50%;\n      max-width: 180px;\n      max-height: 180px;\n    }\n  }\n  .details {\n    h5 {\n      margin-bottom: 15px;\n    }\n    h6 {\n      margin-bottom: 30px;\n    }\n    .social-media li a {\n      background: #f8f9fc;\n      color: var(--main-color);\n      height: 45px;\n      width: 45px;\n      line-height: 45px;\n      font-size: 15px;\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n      }\n    }\n  }\n}\n\n.widget-info-inner {\n  h6 {\n    margin-bottom: 4px;\n  }\n  p {\n    margin-bottom: 15px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.service-sidebar {\n  .widget {\n    background: #f8f9fc;\n    border: 0;\n    .widget-title {\n      padding-bottom: 0;\n      svg {\n        margin-top: 6px;\n        float: left;\n        margin-right: 10px;\n        font-size: 15px;\n      }\n      &:before,\n      &:after {\n        display: none;\n      }\n    }\n  }\n  .widget_catagory {\n    .catagory-items {\n      border-top: 1px solid #e5e5e5;\n      li {\n        border-bottom: 1px solid #e5e5e5;\n        padding-bottom: 0;\n        &:last-child {\n        }\n      }\n    }\n  }\n  .widget_author {\n    padding: 0 !important;\n    background: transparent;\n    .thumb img {\n      border-radius: 5px;\n      max-width: 100%;\n      max-height: 100%;\n    }\n    .details {\n      margin-top: -49px;\n      padding: 0;\n    }\n  }\n  .widget_download {\n    ul {\n      padding: 8px 0;\n      background: #fff;\n      border-radius: 5px;\n      li {\n        list-style: none;\n        a {\n          padding: 10px 18px;\n          display: block;\n          svg {\n            height: 30px;\n            width: 30px;\n            background: rgba(36, 107, 253, 0.1);\n            color: var(--main-color);\n            border-radius: 50%;\n            line-height: 30px;\n            text-align: center;\n            padding: 8px;\n            float: right;\n            transition: 0.4s;\n          }\n          &:hover {\n            svg {\n              background: var(--main-color);\n              color: #fff;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","/*------------------------------------------------\n    blog style\n------------------------------------------------*/\n.single-blog-inner {\n  margin-bottom: 50px;\n  overflow: hidden;\n  transition: 0.4s;\n  .thumb {\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 20px;\n    border-radius: 10px;\n    .date {\n      height: 94px;\n      width: 84px;\n      background: var(--main-color);\n      position: absolute;\n      left: 20px;\n      top: 20px;\n      border-radius: 5px;\n      color: #fff;\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.2;\n      text-align: center;\n      padding: 15px;\n      padding-top: 22px;\n    }\n    img {\n      transform: scale(1.05);\n      transition: 0.9s;\n    }\n  }\n  .blog-meta {\n    margin: 0;\n    padding: 0;\n    margin-bottom: 15px;\n    li {\n      display: inline-block;\n      margin-right: 15px;\n      color: #8a8a8a;\n      font-size: 14px;\n      i {\n        margin-right: 4px;\n        color: var(--main-color);\n      }\n      svg {\n        margin-right: 4px;\n        color: var(--main-color);\n      }\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n  .details {\n    h2 {\n      margin-bottom: 3px;\n      &:hover a {\n        color: var(--main-color);\n      }\n    }\n    .title {\n      margin-bottom: 17px;\n    }\n    p {\n      margin-bottom: 16px;\n    }\n    .read-more-text {\n      font-weight: 600;\n    }\n  }\n  .portfolio-details {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background: var(--main-color);\n    border-radius: 0 30px 0 0;\n    overflow: hidden;\n    h5 {\n      padding: 10px 30px;\n      background: var(--heading-color);\n      color: #fff;\n    }\n    p {\n      margin-bottom: 4px;\n      color: #fff;\n      border-bottom: 1px dashed #fff;\n      padding: 5px 30px 7px 30px;\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n    strong {\n      min-width: 95px;\n      display: inline-block;\n      color: #fff;\n    }\n  }\n  &:hover {\n    .thumb {\n      img {\n        transform: scale(1.1);\n      }\n    }\n  }\n}\n\n.single-blog-list {\n  border-radius: 6px;\n  box-shadow: $box-shadow;\n  margin-bottom: 30px;\n  overflow: hidden;\n  transition: 0.4s;\n  .thumb {\n    overflow: hidden;\n    position: relative;\n    img {\n      transition: 0.7s;\n    }\n    .date {\n      position: absolute;\n      right: 0;\n      top: 25px;\n      background: #fff;\n      padding: 9px 18px;\n      border-radius: 5px 0 0 5px;\n      border-left: 3px solid var(--main-color);\n      color: var(--heading-color);\n      font-weight: 600;\n    }\n  }\n  .details {\n    padding: 25px 30px;\n    position: relative;\n    .cat {\n      position: absolute;\n      right: 0;\n      top: -24px;\n      background: var(--main-color);\n      padding: 9px 18px;\n      border-radius: 5px 0 0 5px;\n      color: #fff;\n    }\n    .blog-meta {\n      li {\n        list-style: none;\n        display: inline-block;\n        margin-right: 12px;\n        font-size: 12px;\n        svg {\n          color: var(--main-color);\n          margin-right: 4px;\n        }\n      }\n    }\n    p {\n      font-weight: 500;\n      i,\n      svg {\n        margin-right: 10px;\n      }\n    }\n    h5 {\n      margin-bottom: 0;\n    }\n    .meta {\n      margin-top: 20px;\n      padding-top: 18px;\n      border-top: 1px solid #ededed;\n      p {\n        margin-bottom: 0;\n      }\n    }\n  }\n  &:hover {\n    box-shadow: $box-shadow2;\n    .thumb {\n      img {\n        transform: scale(1.1);\n      }\n    }\n  }\n  &.style-2 {\n    .thumb {\n      img {\n        border-radius: 5px;\n      }\n    }\n    .details {\n      .blog-meta {\n        display: flex;\n        align-items: center;\n        background: #f8f9fc;\n        padding: 10px;\n        border-radius: 6px 0 0 6px;\n        margin-right: -30px;\n        margin-left: 50px;\n        margin-top: -64px;\n        z-index: 2;\n        position: relative;\n        .date {\n          height: 50px;\n          width: 50px;\n          border-radius: 5px;\n          background: var(--main-color);\n          color: #fff;\n          text-align: center;\n          padding: 8px;\n          line-height: 1.4;\n        }\n      }\n    }\n  }\n  &.style-3 {\n    .thumb {\n      img {\n        border-radius: 5px;\n      }\n    }\n    .details {\n      .blog-meta {\n        display: flex;\n        align-items: center;\n        background: #50af9b;\n        padding: 10px;\n        border-radius: 6px;\n        margin-right: 48px;\n        margin-top: -54px;\n        z-index: 2;\n        position: relative;\n        li {\n          color: #fff;\n          svg {\n            color: #fff;\n          }\n          span {\n            border-radius: 50%;\n            border: 1px solid #fff;\n            padding: 3px;\n            display: inline-block;\n            height: 30px;\n            width: 30px;\n            margin-right: 3px;\n            img {\n              border-radius: 50%;\n            }\n          }\n        }\n        .date {\n          height: 50px;\n          width: 50px;\n          border-radius: 5px;\n          color: #fff;\n          text-align: center;\n          padding: 8px;\n          line-height: 1.4;\n        }\n      }\n      .btn-wrap {\n        position: relative;\n        .read-more-text {\n          background: #fff;\n          z-index: 2;\n          position: relative;\n          padding-left: 5px;\n\n          svg {\n            background: #fff;\n          }\n        }\n        &:after {\n          content: \"\";\n          position: absolute;\n          left: 0;\n          top: 15px;\n          height: 1px;\n          width: 100%;\n          background: #ccc;\n          opacity: 1;\n          visibility: visible;\n        }\n        &:hover {\n          .read-more-text {\n            color: #50af9b;\n            &::after {\n              background: #50af9b;\n            }\n          }\n          &::after {\n            background: #50af9b;\n          }\n        }\n      }\n    }\n  }\n}\n\n/************ page navigation ************/\n.pagination {\n  display: inline-flex;\n  margin: 10px 0 0 0;\n  .prev,\n  .next {\n    @include transition(all, 0.4s, ease);\n  }\n  .page-numbers {\n    height: 40px;\n    width: 40px;\n    margin-right: 8px;\n    border: 0;\n    border-radius: 5px;\n    background: #f8f9fc;\n    line-height: 40px;\n    text-align: center;\n    text-decoration: none;\n    @include transition(all, 0.4s, ease);\n    display: block;\n    color: var(--heading-color);\n    font-size: 16px;\n    font-weight: 700;\n    &:active,\n    &:focus,\n    &:hover {\n      background: var(--main-color);\n      color: #fff;\n    }\n    &.current {\n      background: var(--main-color);\n      color: #fff;\n    }\n  }\n}\n\n/******** blog-details-page-content ***********/\n.blog-details-page-content {\n  .single-blog-inner {\n    box-shadow: none !important;\n    border-radius: 0;\n    border-bottom: 0;\n    padding-bottom: 0;\n  }\n  blockquote {\n    background: #fff;\n    padding: 30px 40px;\n    font-weight: 500;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    position: relative;\n    border: 1px solid rgba(66, 74, 97, 0.1);\n    text-align: center;\n    p {\n      margin-bottom: 0 !important;\n      text-align: left;\n    }\n    svg {\n      height: 50px;\n      width: 50px !important;\n      line-height: 50px;\n      padding: 15px;\n      border-radius: 50%;\n      display: inline-block;\n      text-align: center;\n      color: #fff;\n      background: var(--main-color);\n      margin-bottom: 15px;\n    }\n    .name {\n      position: relative;\n      padding-left: 40px;\n      margin-top: 15px;\n      text-align: left;\n      &:after {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 12px;\n        width: 28px;\n        height: 3px;\n        background: var(--main-color);\n      }\n    }\n  }\n}\n\n/*********** tag-and-share ************/\n.tag-and-share {\n  margin-top: 20px;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 15px 0;\n  .tags {\n    a {\n      height: 30px;\n      line-height: 29px;\n      padding: 0 12px;\n      background: #f2f5f6;\n      display: inline-block;\n      border-radius: 5px;\n      font-size: 12px;\n      font-weight: 600;\n      color: #757575;\n      transition: 0.4s;\n      border: 1px solid rgba(66, 74, 97, 0.1);\n      &:hover {\n        background: var(--main-color);\n        color: #fff;\n        border-color: var(--main-color);\n      }\n    }\n  }\n  strong {\n    color: var(--heading-color);\n    margin-right: 6px;\n    font-size: 20px;\n  }\n  .blog-share {\n    ul {\n      margin: 0;\n      padding: 0;\n      display: inline-block;\n      li {\n        display: inline-block;\n        list-style: none;\n        margin-right: 10px;\n        color: var(--heading-color);\n        &:last-child {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n\n/****** prev-next-post ******/\n.prev-next-post {\n  padding: 20px;\n  margin-top: 50px;\n  border: 1px solid #ededed;\n  border-radius: 5px;\n  .btn {\n    height: 50px;\n    width: 50px;\n    line-height: 50px;\n    padding: 0;\n    text-align: center;\n    display: inline-block;\n    svg {\n      font-size: 12px;\n      margin-top: 0;\n      margin-left: 0;\n      float: initial;\n    }\n  }\n}\n\n.blog-comment-form {\n  padding-top: 30px;\n  h3 {\n    position: relative;\n    margin-bottom: 32px;\n  }\n}\n\n.comment-content a {\n  word-wrap: break-word;\n}\n\n.bypostauthor {\n  display: block;\n}\n\n.blog-comment {\n  position: relative;\n  margin-top: 40px;\n}\n\n.blog-comment .comment-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.blog-comment .comment-list ul.children {\n  margin: 0;\n  list-style: none;\n  padding-left: 65px;\n}\n\n.blog-comment .comment-box {\n  position: relative;\n  margin-bottom: 60px;\n  padding-bottom: 60px;\n  border-bottom: 1px solid var(--aivons-light, #f2f4f8);\n}\n\n.blog-comment .comment {\n  position: relative;\n  min-height: 90px;\n}\n\n.blog-comment .comment-box .author-thumb {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n\n.blog-comment .comment-box .author-thumb img {\n  width: 90px;\n  height: 90px;\n  display: block;\n  border-radius: 50%;\n}\n\n.blog-comment .comment-box .info {\n  position: relative;\n  margin-bottom: 25px;\n  line-height: 24px;\n}\n\n.blog-comment .comment-box .info .name {\n  position: relative;\n  display: block;\n  font-size: 24px;\n  line-height: 30px;\n  font-weight: 800;\n  color: var(--aivons-black, #0f0d1d);\n  text-transform: uppercase;\n}\n\n.blog-comment .comment-box .info .date {\n  position: relative;\n  display: inline-block;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 600;\n  color: var(--main-color);\n}\n\n.blog-comment .comment-box .text {\n  position: relative;\n  display: block;\n  color: var(--aivons-gray, #726f84);\n  font-weight: 300;\n  line-height: 1.5em;\n  letter-spacing: 0.1em;\n  margin-bottom: 30px;\n}\n\n.blog-comment .comment-box .reply-btn {\n  position: relative;\n  display: block;\n}\n\n.blog-comment .comment-box .theme-btn .btn-title {\n  padding: 6px 30px 4px;\n  line-height: 30px;\n}\n\n.blog-comment .comment-body .says {\n  display: none;\n}\n\n.blog-comment .comment-body {\n  position: relative;\n  padding-left: 100px;\n  margin-bottom: 30px;\n}\n\n.blog-comment .pingback .comment-body,\n.blog-comment .trackback .comment-body {\n  padding-left: 0;\n}\n\n.blog-comment .comment-body .avatar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 5px;\n  height: 85px;\n  width: 85px;\n}\n\n.blog-comment .fn a,\n.blog-comment .fn {\n  position: relative;\n  display: block;\n  font-size: 18px;\n  color: var(--heading-color);\n  text-decoration: none;\n  line-height: 1;\n}\n\n.blog-comment .comment-body .comment-metadata {\n  margin-bottom: 13px;\n}\n\n.blog-comment .comment-body .comment-metadata a {\n  position: relative;\n  display: inline-block;\n  font-size: 12px;\n  text-decoration: none;\n}\n\n.blog-comment .comment-body .comment-metadata a:hover {\n  color: var(--aivons-black, #0f0d1d);\n}\n\n.blog-comment .comment-body .comment-metadata .edit-link a::before {\n  content: \".\";\n  margin-left: 8px;\n  margin-right: 10px;\n}\n\n.blog-comment .comment-content p {\n  position: relative;\n  display: block;\n  color: var(--aivons-gray, #726f84);\n  font-weight: 300;\n  line-height: 1.5em;\n  margin-bottom: 30px;\n  font-size: 16px;\n  line-height: 2em;\n  font-family: var(--aivons-font, \"Jost\", sans-serif);\n  letter-spacing: 0;\n  font-weight: 500;\n}\n\n.blog-comment .comment-content table a {\n  color: var(--main-color);\n  text-decoration: none;\n}\n\n.blog-comment .comment-content {\n  font-weight: 500;\n}\n\n.blog-comment .comment-content table a {\n  color: var(--aivons-black, #0f0d1d);\n}\n\n.blog-comment .comment-content table a:hover {\n  color: var(--main-color);\n}\n\n.blog-comment .comment-content p:last-of-type {\n  margin-bottom: 0;\n}\n\n.blog-comment .reply a {\n  position: relative;\n  background-color: var(--main-color);\n  font-size: 12px;\n  color: #fff;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  text-decoration: none;\n  height: 30px;\n  line-height: 30px;\n  transition: all 500ms ease;\n  margin-top: 40px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border: none;\n  outline: none !important;\n  padding: 0 18px;\n  border-radius: 30px;\n  text-transform: capitalize;\n}\n\n.blog-admin {\n  background: #f8f9fc;\n  padding: 30px;\n  border-radius: 5px;\n  p {\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .blog-comment .reply a {\n    margin-top: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n}\n\n.blog-comment .reply a:hover {\n  background-color: var(--aivons-black, #0f0d1d);\n  color: #ffffff;\n}\n\n.blog-comment .blog-pagination a,\n.blog-comment .blog-pagination span {\n  margin-bottom: 45px;\n}\n\n.comment-respond .blog-details__content-title {\n  margin-bottom: 50px;\n}\n\n.reply-form .logged-in-as {\n  display: flex;\n  color: var(--main-color);\n  margin-left: -10px;\n  margin-top: -40px;\n  margin-bottom: 20px;\n}\n\n.reply-form .logged-in-as a {\n  text-decoration: none;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.comment-form__title small {\n  font-size: 20px;\n}\n\n.comment-form__title small a {\n  text-decoration: none;\n  color: var(--main-color);\n  text-decoration: underline;\n}\n\n.comment-form__title small a:hover {\n  color: var(--aivons-black, #0f0d1d);\n  opacity: 0.5;\n}\n\n.comment-list .comment-respond {\n  margin-bottom: 30px;\n}\n\n.reply-form .form-submit {\n  margin-bottom: 0;\n}\n\n.comment-list .reply-form .form-submit {\n  margin-bottom: 30px;\n}\n",".single-project-inner {\n  position: relative;\n  border-radius: 10px;\n  margin-bottom: 25px;\n  .details {\n    position: absolute;\n    left: 50%;\n    top: 55%;\n    text-align: center;\n    transform: translate(-50%, -50%);\n    z-index: 2;\n    color: var(--main-color);\n    visibility: hidden;\n    opacity: 0;\n    transition: 0.4s;\n    span {\n      display: block;\n      margin-bottom: 10px;\n    }\n    a {\n      color: var(--main-color);\n    }\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    left: 20px;\n    right: 20px;\n    top: 20px;\n    bottom: 20px;\n    background: rgba(255, 255, 255, 0.8);\n    z-index: 1;\n    border-radius: 50px;\n    visibility: hidden;\n    opacity: 0;\n    transition: 0.4s;\n  }\n  &:hover {\n    .details {\n      top: 50%;\n      visibility: visible;\n      opacity: 1;\n    }\n    &:after {\n      visibility: visible;\n      opacity: 1;\n      border-radius: 10px;\n    }\n  }\n}\n","/*--------------------------------------------------\n    ##Footer style\n---------------------------------------------------*/\n.footer-area {\n  position: relative;\n  margin-top: 90px;\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    background: var(--heading-color);\n    z-index: -1;\n    \n  }\n  .widget {\n    position: relative;\n    z-index: 2;\n    margin-bottom: 70px;\n  }\n  .widget-title {\n    margin-bottom: 30px;\n    position: relative;\n  }\n  .widget_about {\n    .thumb {\n      margin-bottom: 20px;\n      img {\n        max-width: 150px;\n      }\n\t\t\tcolor: var(--main-color);\n\n    }\n    .details {\n      p {\n        margin-bottom: 0;\n        color: #fff;\n        svg {\n          color: var(--main-color);\n          margin-right: 10px;\n        }\n        + p {\n          font-weight: 500;\n        }\n      }\n      .social-media {\n        margin-top: 26px;\n        li {\n          a:hover {\n            background: var(--main-color);\n            color: #fff;\n          }\n        }\n      }\n    }\n    .subscribe {\n      position: relative;\n      input {\n        width: 100%;\n        height: 44px;\n        padding: 0 50px 0 15px;\n        border-radius: 5px;\n        border: 1px solid #e3e3e3;\n        box-shadow: none;\n        outline: 0;\n      }\n      button {\n        position: absolute;\n        right: 0;\n        top: 0;\n        border-radius: 0 5px 5px 0;\n        height: 44px;\n        width: 40px;\n        border: 0;\n        background: var(--main-color);\n        color: #fff;\n        font-size: 15px;\n        transition: 0.4s;\n        &:hover {\n          background: var(--heading-color);\n        }\n      }\n    }\n  }\n  .widget_nav_menu {\n    ul {\n      margin: 0;\n      padding: 0;\n      li {\n        list-style: none;\n        margin-bottom: 7px;\n        position: relative;\n        color: #fff;\n        position: relative;\n        svg {\n          margin-right: 8px;\n          color: #333f4d;\n          transition: 0.4s;\n        }\n        &:hover {\n          svg {\n            color: var(--main-color);\n          }\n        }\n        &.sky {\n          &:hover {\n            svg {\n              color: #50af9b;\n            }\n            a {\n              color: #50af9b;\n            }\n          }\n        }\n      }\n    }\n  }\n  .widget_subscribe {\n    .single-input-inner {\n      position: relative;\n      input {\n        padding-right: 40px;\n      }\n    }\n    button {\n      padding: 0;\n      border: 0;\n      position: absolute;\n      right: 15px;\n      top: 10px;\n      background: transparent;\n      color: var(--main-color);\n    }\n    label {\n      color: #fff;\n      position: relative;\n      padding-left: 22px;\n      input {\n        position: absolute;\n        left: 0;\n        top: 7px;\n      }\n    }\n  }\n  .widget-recent-post ul li .media .media-body .title {\n    color: #fff;\n  }\n  .widget-recent-post ul li .media .media-body .title.sky a:hover {\n    color: #50af9b;\n  }\n  .widget-recent-post ul li .media .media-body .post-info span {\n    color: #fff;\n  }\n  .widget-recent-post ul li .media .media-body .post-info .sky {\n    color: #50af9b;\n  }\n}\n\n.footer-top {\n  padding-top: 55px;\n  padding-bottom: 90px;\n}\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 23px 0;\n  position: relative;\n  z-index: 2;\n  p {\n    margin-bottom: 0;\n    color: #fff;\n  }\n  a {\n    margin-right: 10px;\n    color: #fff;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n\n.footer-subscribe {\n  transform: translateY(-90px);\n  .footer-subscribe-inner {\n    border-radius: 10px;\n    padding: 40px;\n    position: relative;\n    h2 {\n      color: #fff;\n    }\n    input {\n      height: 55px;\n      padding: 0 150px 0 20px;\n      color: var(--heading-color);\n      width: 100%;\n      border: 0;\n    }\n    .btn {\n      position: absolute;\n      right: 30px;\n    }\n    &.style-2 {\n      display: flex;\n      text-align: center;\n      margin-top: -90px;\n      border-radius: 0;\n      .media {\n        width: 340px;\n        padding: 30px;\n      }\n      p {\n        font-size: 13px;\n      }\n      input {\n        padding: 0 18px;\n      }\n      .btn {\n        position: relative;\n        right: auto;\n      }\n      .row {\n        padding: 20px 30px;\n      }\n    }\n  }\n}\n\n.footer-area-2 {\n  .widget-title {\n    color: var(--heading-color) !important;\n  }\n  p {\n    color: var(--heading-color) !important;\n  }\n  a {\n    color: var(--paragraph-color) !important;\n    svg {\n      color: var(--paragraph-color) !important;\n    }\n    &:hover {\n      color: var(--main-color) !important;\n    }\n  }\n  .widget_about {\n    background: #fff;\n    padding: 25px;\n  }\n  .footer-bottom {\n    border-top: 1px solid #e3e3e3;\n  }\n}\n","/*--------------------------------------------------\n    ## All responsive style\n---------------------------------------------------*/\n@media all and (min-width: 1600px) {\n  .container {\n    max-width: 1280px;\n  }\n  .back-to-top {\n    right: 70px;\n    bottom: 50px;\n  }\n  .position-bottom-left {\n    position: absolute;\n    left: 90px;\n    bottom: 180px;\n  }\n  .case-study-area .animate-img-1 {\n    bottom: 53px;\n    left: 282px;\n  }\n  .contact-g-map iframe {\n    height: 650px;\n  }\n  .banner-thumb-2 .main-img-wrap .banner-animate-img-2 {\n    right: 0;\n  }\n  .contact-inner-1 .section-title {\n    margin-top: 106px;\n  }\n  .banner-area-2 .bg-img-2 {\n    right: 0px;\n    top: -72px;\n    width: 796px;\n  }\n  .contact-inner-2 .section-title {\n    margin-top: 134px;\n  }\n  .banner-area-3 .bg-gray {\n    padding: 240px 0;\n  }\n  .single-service-inner-3.single-service-inner-3-left {\n    padding: 43px 70px 43px 40px;\n  }\n  .single-service-inner-3.single-service-inner-3-right {\n    padding: 43px 40px 43px 70px;\n  }\n}\n@media all and (max-width: 1599px) {\n  .banner-area-1 .animate-img-1 {\n    position: absolute;\n    left: 30px;\n    bottom: 70px;\n    width: 40px;\n  }\n  .banner-area-1 .animate-img-2 {\n    position: absolute;\n    left: 50px;\n    bottom: 50px;\n    width: 60px;\n  }\n  .banner-thumb .banner-animate-img-1 {\n    width: 40px;\n    left: -100px;\n  }\n}\n@media all and (max-width: 1199px) {\n  .single-blog-inner .details h2 {\n    font-size: 35px;\n  }\n  .single-work-process-inner-3 {\n    padding: 20px;\n  }\n  .single-service-inner {\n    padding: 30px 25px;\n  }\n  .single-case-study-inner .details {\n    margin-left: 25px;\n  }\n  .single-pricing-inner {\n    padding: 25px;\n  }\n  .single-blog-list .details p {\n    font-size: 15px;\n  }\n  .single-blog-list .details .meta p {\n    font-size: 14px;\n  }\n  .single-list-inner li {\n    font-size: 15px;\n  }\n  .single-service-inner-2 .details {\n    padding: 20px;\n    margin-left: 30px;\n  }\n  .contact-inner-1 .section-title {\n    padding: 30px;\n  }\n  .accordion-inner .accordion-item .accordion-button {\n    font-size: 17px;\n  }\n  .single-testimonial-inner {\n    padding: 30px 20px;\n  }\n  .single-blog-list.style-2 .details .blog-meta {\n    margin-left: 12px;\n  }\n  .single-pricing-inner ul li {\n    font-size: 15px;\n  }\n  .single-testimonial-inner.style-2 .ratting-inner {\n    font-size: 13px;\n  }\n  .single-testimonial-inner.style-2 .ratting-inner svg {\n    font-size: 11px;\n  }\n  .contact-page-inner {\n    padding: 50px;\n  }\n  .banner-area-3 .bg-gray {\n    padding: 80px 0;\n  }\n  .banner-area-3 {\n    padding: 0;\n  }\n}\n@media all and (max-width: 991px) {\n  .navbar {\n    padding: 14px 0;\n  }\n  .td-sidebar {\n    margin-top: 100px;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav {\n    padding-left: 0;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children {\n    padding-right: 0;\n  }\n  .navbar-area\n    .nav-container\n    .navbar-collapse\n    .navbar-nav\n    li.menu-item-has-children:after {\n    top: 26px;\n  }\n  .navbar-area .nav-container .navbar-collapse {\n    padding: 13px;\n    padding-left: 0;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav {\n    margin: 0;\n  }\n  .navbar-area:after {\n    display: none;\n  }\n  .navbar-area .nav-container .navbar-collapse .navbar-nav li a {\n    font-size: 16px;\n  }\n  .navbar-area .nav-container.navbar-bg {\n    padding-left: 15px;\n  }\n  .navbar-area {\n    margin-top: 0;\n  }\n  .banner-area-1 {\n    padding-top: 200px;\n  }\n  .toggle-btn {\n    top: 0;\n  }\n  .contact-inner-1 .section-title {\n    padding: 30px;\n    margin-left: 0;\n    margin-top: 30px;\n  }\n  .footer-bottom p,\n  .footer-bottom a {\n    font-size: 15px;\n  }\n  .footer-subscribe .footer-subscribe-inner h2 {\n    font-size: 30px;\n  }\n  .single-work-process-inner-2 {\n    margin-top: 0;\n  }\n  .slider-control-right-top .owl-nav {\n    display: none;\n  }\n  .service-sidebar .widget_author .thumb img {\n    width: 100%;\n  }\n  .service-sidebar {\n    margin-top: 0;\n  }\n  .td-sidebar .widget.widget_author .social-media {\n    text-align: center !important;\n  }\n  .single-project-inner .details span {\n    margin-bottom: 0px;\n  }\n  .single-project-inner .details a {\n    font-size: 13px;\n  }\n  .single-project-inner:after {\n    top: 15px;\n    bottom: 15px;\n    left: 15px;\n    right: 15px;\n  }\n  .career-wrap {\n    padding: 30px;\n  }\n  .banner-area-3 .bg-gray {\n    padding: 80px 0;\n  }\n  .single-service-inner-3 {\n    margin-right: 40px;\n    padding: 25px 60px 25px 25px !important;\n  }\n  .single-service-inner-3.single-service-inner-3-right .thumb {\n    left: auto;\n    right: -40px;\n  }\n  .footer-subscribe .footer-subscribe-inner.style-2 .border-1 {\n    margin: 5px 0;\n  }\n}\n@media all and (max-width: 767px) {\n  .breadcrumb-area .page-title {\n    font-size: 50px;\n  }\n  .banner-area-3 .img-right {\n    display: none;\n  }\n}\n@media all and (max-width: 575px) {\n  .back-to-top {\n    right: 15px;\n    bottom: 20px;\n  }\n  .navbar-top .topbar-right li {\n    margin-bottom: 4px;\n  }\n  .breadcrumb-area .page-title {\n    font-size: 30px;\n  }\n  .breadcrumb-area .page-list li {\n    font-size: 15px;\n  }\n  .single-blog-inner .details h2 {\n    font-size: 24px;\n  }\n  .td-page-navigation .pagination li a {\n    height: 45px;\n    width: 45px;\n    line-height: 45px;\n    font-size: 16px;\n  }\n  .blog-details-page-content blockquote {\n    padding: 30px 20px;\n  }\n  .blog-comment .comment-body {\n    padding-left: 0;\n    margin-bottom: 40px;\n  }\n  .blog-comment .comment-body .avatar {\n    position: relative;\n    margin-bottom: 18px;\n  }\n  .blog-comment .comment-body .comment-metadata {\n    margin-bottom: 6px;\n  }\n  .blog-comment .reply a {\n    margin-top: 12px;\n  }\n  .td-sidebar .widget {\n    padding: 25px;\n  }\n  .banner-inner .title {\n    font-size: 40px;\n  }\n  .banner-inner .subtitle {\n    font-size: 13px;\n  }\n  .section-title .title {\n    font-size: 32px;\n  }\n  .about-thumb-inner .animate-img-bottom-right {\n    position: absolute;\n    right: 0;\n    bottom: 30px;\n    width: 200px;\n  }\n  .accordion-inner .accordion-item .accordion-button {\n    font-size: 16px;\n  }\n  .accordion-inner.accordion-icon-left .accordion-item .accordion-button {\n    padding-left: 42px;\n  }\n  .footer-subscribe .footer-subscribe-inner h2 {\n    font-size: 24px;\n  }\n  .td-search-popup.active .search-form {\n    width: 90%;\n  }\n  .navbar {\n    padding: 14px 10px;\n  }\n  .banner-thumb-3 .banner-animate-img {\n    width: 60px;\n  }\n  .banner-thumb-3 .banner-animate-img-1 {\n    left: -8px;\n  }\n  .contact-inner-1 .section-title .title {\n    font-size: 32px;\n  }\n  .footer-subscribe .footer-subscribe-inner input {\n    padding: 0 20px;\n    width: 100%;\n  }\n  .footer-subscribe .footer-subscribe-inner .btn {\n    margin-top: 10px;\n    width: 100%;\n    position: relative;\n    right: 0;\n  }\n  .footer-subscribe .footer-subscribe-inner {\n    padding: 25px;\n  }\n  .contact-page-inner {\n    padding: 30px;\n  }\n  .single-contact-list {\n    padding: 25px;\n  }\n  .widget_author {\n    padding: 30px 20px !important;\n  }\n  .single-blog-inner .thumb .date {\n    height: 68px;\n    width: 65px;\n    font-size: 16px;\n    padding-top: 15px;\n  }\n  .blog-comment .reply a {\n    margin-top: 12px;\n  }\n  .blog-comment .comment-body .comment-metadata {\n    margin-bottom: 5px;\n  }\n  .blog-admin {\n    display: block;\n    padding: 20px;\n  }\n  .blog-admin .media-left {\n    margin-bottom: 20px;\n  }\n  .blog-comment .comment-list .comment-author a {\n    display: block;\n  }\n  .banner-area-3 .img-right {\n    display: none;\n  }\n  .career-wrap {\n    padding: 30px;\n  }\n  .career-nav-tab button {\n    width: 50%;\n  }\n  .career-nav-tab button:nth-child(2) {\n    border-right: 0 !important;\n  }\n  .single-project-inner img {\n    width: 100%;\n  }\n  .single-testimonial-inner.style-3 .thumb {\n    margin-bottom: 20px;\n  }\n  .single-testimonial-inner.style-3 .thumb .shadow-img {\n    width: 180px;\n  }\n  .single-testimonial-inner.style-3 .thumb .main-img {\n    right: auto;\n    left: 130px;\n  }\n}\n@media all and (max-width: 360px) {\n  .contact-inner-1 .section-title .title,\n  .section-title .title {\n    font-size: 30px;\n  }\n  .single-case-study-inner .details {\n    padding: 18px 60px 18px 18px;\n  }\n  .single-case-study-inner .details .right-arrow {\n    right: 15px;\n  }\n}\n\n@media all and (min-width: 1300px) {\n  .custom-container {\n    max-width: 1250px;\n  }\n}\n@media all and (min-width: 2000px) {\n  .contact-inner-2 {\n    max-width: 1920px;\n    margin: 0 auto;\n  }\n}\n@media all and (min-width: 1800px) {\n  .custom-container {\n    max-width: 1720px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
